function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1d2a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1d2a"] = parcelRequire;
}
// import _hash from 'js-sha256'
let $c174e9ba92688b1a$export$53f5378863036ef2 = async (url, options)=>{
    const { timeout: timeout = 8000 } = options;
    const ac = new AbortController();
    const t = setTimeout(()=>ac.abort(), timeout);
    const response = await fetch(url, {
        ...options,
        signal: ac.signal
    });
    clearTimeout(t);
    return response;
};
let $c174e9ba92688b1a$export$9401e867e2e765ab = (el, classname)=>{
    /*
		Takes a base element (probably which triggered a click) and
		walks up the DOM tree, testing if an parent element has a given
		class. Returns the matching element, or false if not found.
	*/ let done = false;
    while(!done){
        let match = el && el.classList && el.classList.contains(classname);
        if (match) return el;
        else if (el && el.classList) el = el.parentElement;
        else {
            done = true;
            return false;
        }
    }
};
let $c174e9ba92688b1a$export$b534c57610dde912 = (e)=>{
    let el = e.touches && e.touches[0].target ? e.touches[0].target : e.target;
    return el;
};
let $c174e9ba92688b1a$export$c5552dfdbc7cec71 = ()=>{
    return Math.random() < 0.5 ? "-" : "+";
};
let $c174e9ba92688b1a$export$131fbe5a1126fa73 = ()=>{
    return Math.random() < 0.5 ? -1 : 1;
};
let $c174e9ba92688b1a$export$6de97f731db02df9 = (el, _threshold)=>{
    if (el === undefined) {
        console.error("cannot prevent widows on undefined DOM element");
        return;
    }
    let threshold = _threshold !== undefined ? _threshold : 3;
    let text = el.innerHTML.replaceAll("&nbsp;", " ");
    let arr = text.split(" ");
    text = "";
    arr.forEach((word, i)=>{
        let space = i > arr.length - 1 - threshold && i < arr.length - 1 ? "&nbsp;" : " ";
        text += word + space;
    });
    el.innerHTML = text;
};
let $c174e9ba92688b1a$export$5507196051a9157 = (filepath)=>{
    if (typeof filepath !== "string") return false;
    let re = /(?:\.([^.]+))?$/;
    return re.exec(filepath)[1];
};
let $c174e9ba92688b1a$export$7d1440dcfc32f4cf = (filepath, trim_leading_slash)=>{
    if (typeof filepath !== "string") return false;
    let r = /[^\/]*$/;
    let _path = filepath.replace(r, "");
    if (trim_leading_slash && _path[0] === "/") _path = _path.substr(1, _path.length);
    return _path;
};
let $c174e9ba92688b1a$export$32dd0b63bfc59465 = (filepath)=>{
    if (typeof filepath !== "string") return false;
    let _name = filepath.substring(filepath.lastIndexOf("/") + 1, filepath.length);
    return _name;
};
let $c174e9ba92688b1a$export$39b2c93d4fe7768a = (arr, fn)=>{
    /* ex fn:
	( a, b ) => {
		return a.num - b.num
	}*/ return arr.sort(fn);
};
let $c174e9ba92688b1a$export$8839c75b84489be1 = (el)=>{
    let rect = el.getBoundingClientRect();
    let scroll_left = window.pageXOffset || document.documentElement.scrollLeft;
    let scroll_top = window.pageYOffset || document.documentElement.scrollTop;
    return {
        y: rect.top + scroll_top,
        x: rect.left + scroll_left
    };
};
let $c174e9ba92688b1a$export$61c1f6510720cf8b = (data)=>{
    let type = typeof data;
    // Be more specific between objects and arrays, please javascript
    if (type === "object") type = data instanceof Object && data instanceof Array ? "array" : "object";
    // Dont return object as type of null, please javascript
    if (data == undefined && data !== null) type = "undefined";
    return type;
};
let $c174e9ba92688b1a$export$6c4a311cc157c764 = (x1, y1, x2, y2)=>{
    return Math.pow(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2), 0.5);
};
let $c174e9ba92688b1a$export$8569474e06044b6b = (x, y)=>{
    return Math.pow(Math.pow(x, 2) + Math.pow(y, 2), 0.5);
};
let $c174e9ba92688b1a$export$a3295358bff77e = (value, min, max, if_clamp)=>{
    let norm = (value - min) / (max - min);
    if (if_clamp) norm = $c174e9ba92688b1a$export$7d15b64cf5a3a4c4(norm, 0, 1);
    return norm;
};
let $c174e9ba92688b1a$export$7d15b64cf5a3a4c4 = (value, min, max)=>{
    let val = value > max ? max : value;
    val = val < min ? min : val;
    return val;
};
let $c174e9ba92688b1a$export$7390bdb1369814d7 = (value, min, max)=>{
    let range = max - min;
    let val = value > max ? value % range : value;
    val = val < min ? max - (min - val) % range : val;
    return val;
};
let $c174e9ba92688b1a$export$2c9e8a9632a706b2 = (norm, min, max, _clamp)=>{
    let range = max - min;
    let val = norm * range + min;
    val = _clamp ? $c174e9ba92688b1a$export$7d15b64cf5a3a4c4(val, min, max) : val;
    return val;
};
let $c174e9ba92688b1a$export$836aee6bce45247 = (selector, node)=>{
    if (node) return node.querySelector(selector);
    else return document.querySelector(selector);
};
let $c174e9ba92688b1a$export$9ca9051b92b5a6d2 = (selector, node)=>{
    if (node) return Array.prototype.slice.call(node.querySelectorAll(selector));
    else return Array.prototype.slice.call(document.querySelectorAll(selector));
};
let $c174e9ba92688b1a$export$31b40729666a4ae0 = (a, b)=>{
    for(b = a = ""; a++ < 36; b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : "-");
    return b;
};
let $c174e9ba92688b1a$export$354d673d2de74a14 = (x)=>{
    let hash = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for(let i = 0; i < x; i++)hash += possible.charAt(Math.floor(Math.random() * possible.length));
    return hash;
};
let $c174e9ba92688b1a$export$7de0135fa809844c = (rgb)=>{
    function helper(x) {
        let y = x.toString(16);
        return y.length === 1 ? "0" + y : y;
    }
    let hex = "#" + helper(rgb.r) + helper(rgb.g) + helper(rgb.b);
    return hex;
};
let $c174e9ba92688b1a$export$ca305c142c6fc3cf = (hex)=>{
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};
let $c174e9ba92688b1a$export$1b29eb3e91de02b0 = (hex, alpha)=>{
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
        alpha !== undefined ? alpha : 1.0
    ] : null;
};
let $c174e9ba92688b1a$export$8d412d78a19aa893 = (data)=>{
    return JSON.parse(JSON.stringify(data));
};
let $c174e9ba92688b1a$export$853b92426fb69247 = (data)=>{
    return JSON.parse(JSON.stringify(data));
};
let $c174e9ba92688b1a$export$f20468cc961a2aea = (a, b)=>{
    let is_eq = Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index)=>val === b[index]);
    return is_eq;
};
let $c174e9ba92688b1a$export$d3f81fe5cd541a4b = async function(data, callback) {
    // Object
    let t = $c174e9ba92688b1a$export$61c1f6510720cf8b(data);
    if (t == "object") {
        let keys = Object.keys(data);
        for(let i = 0; i < keys.length; i++){
            let k = keys[i];
            await callback(data[k], k, data);
        }
    } else if (t === "array") for(let i = 0; i < data.length; i++)await callback(data[i], i, data);
};
let $c174e9ba92688b1a$export$e772c8ff12451969 = async (delay)=>{
    // delay in ms
    await new Promise((resolve)=>setTimeout(resolve, delay));
};
let $c174e9ba92688b1a$export$3dea766d36a8935f = (obj, predicate)=>{
    let result = {};
    for(let key in obj)if (predicate(obj[key])) result[key] = obj[key];
    return result;
};


var $cd7640162cf6c6ef$export$2e2bcd8739ae039 = ()=>{
    let usr = navigator.userAgent;
    return usr.match(/Android/i) || usr.match(/BlackBerry/i) || usr.match(/iPhone/i) || usr.match(/iPad/i) || usr.match(/iPod/i) || usr.match(/iPhone|iPad|iPod/i) || usr.match(/IEMobile/i);
};


/*!
 * GSAP 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ let $ae2aa5d5610059af$export$4922bee768729a77 = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, $ae2aa5d5610059af$var$_defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, $ae2aa5d5610059af$var$_suppressOverwrites, $ae2aa5d5610059af$var$_reverting, $ae2aa5d5610059af$var$_context, $ae2aa5d5610059af$var$_bigNum = 1e8, $ae2aa5d5610059af$var$_tinyNum = 1 / $ae2aa5d5610059af$var$_bigNum, $ae2aa5d5610059af$var$_2PI = Math.PI * 2, $ae2aa5d5610059af$var$_HALF_PI = $ae2aa5d5610059af$var$_2PI / 4, $ae2aa5d5610059af$var$_gsID = 0, $ae2aa5d5610059af$var$_sqrt = Math.sqrt, $ae2aa5d5610059af$var$_cos = Math.cos, $ae2aa5d5610059af$var$_sin = Math.sin, $ae2aa5d5610059af$export$f664476fd67145ca = (value)=>typeof value === "string", $ae2aa5d5610059af$var$_isFunction = (value)=>typeof value === "function", $ae2aa5d5610059af$var$_isNumber = (value)=>typeof value === "number", $ae2aa5d5610059af$export$a8178c063a9fd3a1 = (value)=>typeof value === "undefined", $ae2aa5d5610059af$var$_isObject = (value)=>typeof value === "object", $ae2aa5d5610059af$var$_isNotFalse = (value)=>value !== false, $ae2aa5d5610059af$var$_windowExists = ()=>typeof window !== "undefined", $ae2aa5d5610059af$var$_isFuncOrString = (value)=>$ae2aa5d5610059af$var$_isFunction(value) || $ae2aa5d5610059af$export$f664476fd67145ca(value), $ae2aa5d5610059af$var$_isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, $ae2aa5d5610059af$var$_isArray = Array.isArray, $ae2aa5d5610059af$var$_strictNumExp = /(?:-?\.?\d|\.)+/gi, $ae2aa5d5610059af$export$b9d44bb6523120d6 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, $ae2aa5d5610059af$export$65c88bbd597e7b0a = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, $ae2aa5d5610059af$var$_complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, $ae2aa5d5610059af$export$5a680e28b0b61bc = /[+-]=-?[.\d]+/, $ae2aa5d5610059af$var$_delimitedValueExp = /[^,'"\[\]\s]+/gi, $ae2aa5d5610059af$var$_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, $ae2aa5d5610059af$var$_globalTimeline, $ae2aa5d5610059af$var$_win, $ae2aa5d5610059af$var$_coreInitted, $ae2aa5d5610059af$var$_doc, $ae2aa5d5610059af$var$_globals = {}, $ae2aa5d5610059af$var$_installScope = {}, $ae2aa5d5610059af$var$_coreReady, $ae2aa5d5610059af$var$_install = (scope)=>($ae2aa5d5610059af$var$_installScope = $ae2aa5d5610059af$var$_merge(scope, $ae2aa5d5610059af$var$_globals)) && $ae2aa5d5610059af$export$99ee26438460406a, $ae2aa5d5610059af$export$7fb54635790b59a5 = (property, value)=>console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()"), $ae2aa5d5610059af$var$_warn = (message, suppress)=>!suppress && console.warn(message), $ae2aa5d5610059af$var$_addGlobal = (name, obj)=>name && ($ae2aa5d5610059af$var$_globals[name] = obj) && $ae2aa5d5610059af$var$_installScope && ($ae2aa5d5610059af$var$_installScope[name] = obj) || $ae2aa5d5610059af$var$_globals, $ae2aa5d5610059af$var$_emptyFunc = ()=>0, $ae2aa5d5610059af$var$_startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, $ae2aa5d5610059af$var$_revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, $ae2aa5d5610059af$var$_revertConfig = {
    suppressEvents: true
}, $ae2aa5d5610059af$var$_reservedProps = {}, $ae2aa5d5610059af$var$_lazyTweens = [], $ae2aa5d5610059af$var$_lazyLookup = {}, $ae2aa5d5610059af$var$_lastRenderedFrame, $ae2aa5d5610059af$export$d305d8ec5d7c26b8 = {}, $ae2aa5d5610059af$var$_effects = {}, $ae2aa5d5610059af$var$_nextGCFrame = 30, $ae2aa5d5610059af$var$_harnessPlugins = [], $ae2aa5d5610059af$var$_callbackNames = "", $ae2aa5d5610059af$var$_harness = (targets)=>{
    let target = targets[0], harnessPlugin, i;
    $ae2aa5d5610059af$var$_isObject(target) || $ae2aa5d5610059af$var$_isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        i = $ae2aa5d5610059af$var$_harnessPlugins.length;
        while(i-- && !$ae2aa5d5610059af$var$_harnessPlugins[i].targetTest(target));
        harnessPlugin = $ae2aa5d5610059af$var$_harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new $ae2aa5d5610059af$export$cf10981d5419cad5(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, $ae2aa5d5610059af$export$8b9be379d2de2a39 = (target)=>target._gsap || $ae2aa5d5610059af$var$_harness($ae2aa5d5610059af$export$45b10814cc054894(target))[0]._gsap, $ae2aa5d5610059af$export$51d6bbe898aef1f9 = (target, property, v)=>(v = target[property]) && $ae2aa5d5610059af$var$_isFunction(v) ? target[property]() : $ae2aa5d5610059af$export$a8178c063a9fd3a1(v) && target.getAttribute && target.getAttribute(property) || v, $ae2aa5d5610059af$export$f9000b814859f126 = (names, func)=>(names = names.split(",")).forEach(func) || names, $ae2aa5d5610059af$export$9c8d725d65e13f94 = (value)=>Math.round(value * 100000) / 100000 || 0, $ae2aa5d5610059af$var$_roundPrecise = (value)=>Math.round(value * 10000000) / 10000000 || 0, $ae2aa5d5610059af$export$dac762bc6301b560 = (start, value)=>{
    let operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, $ae2aa5d5610059af$var$_arrayContainsAny = (toSearch, toFind)=>{
    let l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, $ae2aa5d5610059af$var$_lazyRender = ()=>{
    let l = $ae2aa5d5610059af$var$_lazyTweens.length, a = $ae2aa5d5610059af$var$_lazyTweens.slice(0), i, tween;
    $ae2aa5d5610059af$var$_lazyLookup = {};
    $ae2aa5d5610059af$var$_lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, $ae2aa5d5610059af$var$_lazySafeRender = (animation, time, suppressEvents, force)=>{
    $ae2aa5d5610059af$var$_lazyTweens.length && !$ae2aa5d5610059af$var$_reverting && $ae2aa5d5610059af$var$_lazyRender();
    animation.render(time, suppressEvents, force || $ae2aa5d5610059af$var$_reverting && time < 0 && (animation._initted || animation._startAt));
    $ae2aa5d5610059af$var$_lazyTweens.length && !$ae2aa5d5610059af$var$_reverting && $ae2aa5d5610059af$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, $ae2aa5d5610059af$var$_numericIfPossible = (value)=>{
    let n = parseFloat(value);
    return (n || n === 0) && (value + "").match($ae2aa5d5610059af$var$_delimitedValueExp).length < 2 ? n : $ae2aa5d5610059af$export$f664476fd67145ca(value) ? value.trim() : value;
}, $ae2aa5d5610059af$var$_passThrough = (p)=>p, $ae2aa5d5610059af$export$dc2b19673bb53610 = (obj, defaults)=>{
    for(let p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $ae2aa5d5610059af$var$_setKeyframeDefaults = (excludeDuration)=>(obj, defaults)=>{
        for(let p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    }, $ae2aa5d5610059af$var$_merge = (base, toMerge)=>{
    for(let p in toMerge)base[p] = toMerge[p];
    return base;
}, $ae2aa5d5610059af$var$_mergeDeep = (base, toMerge)=>{
    for(let p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = $ae2aa5d5610059af$var$_isObject(toMerge[p]) ? $ae2aa5d5610059af$var$_mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, $ae2aa5d5610059af$var$_copyExcluding = (obj, excluding)=>{
    let copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, $ae2aa5d5610059af$var$_inheritDefaults = (vars)=>{
    let parent = vars.parent || $ae2aa5d5610059af$var$_globalTimeline, func = vars.keyframes ? $ae2aa5d5610059af$var$_setKeyframeDefaults($ae2aa5d5610059af$var$_isArray(vars.keyframes)) : $ae2aa5d5610059af$export$dc2b19673bb53610;
    if ($ae2aa5d5610059af$var$_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, $ae2aa5d5610059af$var$_arraysMatch = (a1, a2)=>{
    let i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, $ae2aa5d5610059af$var$_addLinkedListItem = (parent, child, firstProp = "_first", lastProp = "_last", sortBy)=>{
    let prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, $ae2aa5d5610059af$export$cd008aa6cd8844e3 = (parent, child, firstProp = "_first", lastProp = "_last")=>{
    let prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, $ae2aa5d5610059af$var$_removeFromParent = (child, onlyIfParentHasAutoRemove)=>{
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, $ae2aa5d5610059af$var$_uncache = (animation, child)=>{
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        let a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, $ae2aa5d5610059af$var$_recacheAncestors = (animation)=>{
    let parent = animation.parent;
    while(parent && parent.parent){
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, $ae2aa5d5610059af$var$_rewindStartAt = (tween, totalTime, suppressEvents, force)=>tween._startAt && ($ae2aa5d5610059af$var$_reverting ? tween._startAt.revert($ae2aa5d5610059af$var$_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force)), $ae2aa5d5610059af$var$_hasNoPausedAncestors = (animation)=>!animation || animation._ts && $ae2aa5d5610059af$var$_hasNoPausedAncestors(animation.parent), $ae2aa5d5610059af$var$_elapsedCycleDuration = (animation)=>animation._repeat ? $ae2aa5d5610059af$var$_animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
$ae2aa5d5610059af$var$_animationCycle = (tTime, cycleDuration)=>{
    let whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, $ae2aa5d5610059af$var$_parentToChildTotalTime = (parentTime, child)=>(parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur), $ae2aa5d5610059af$var$_setEnd = (animation)=>animation._end = $ae2aa5d5610059af$var$_roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || $ae2aa5d5610059af$var$_tinyNum) || 0)), $ae2aa5d5610059af$var$_alignPlayhead = (animation, totalTime)=>{
    let parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = $ae2aa5d5610059af$var$_roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        $ae2aa5d5610059af$var$_setEnd(animation);
        parent._dirty || $ae2aa5d5610059af$var$_uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
	_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
		let cycleDuration = duration + repeatDelay,
			time = _round(clampedTotalTime % cycleDuration);
		if (time > duration) {
			time = duration;
		}
		return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
	},
	*/ $ae2aa5d5610059af$var$_postAddChecks = (timeline, child)=>{
    let t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        t = $ae2aa5d5610059af$var$_parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || $ae2aa5d5610059af$var$_clamp(0, child.totalDuration(), t) - child._tTime > $ae2aa5d5610059af$var$_tinyNum) child.render(t, true);
    }
    //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if ($ae2aa5d5610059af$var$_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -$ae2aa5d5610059af$var$_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, $ae2aa5d5610059af$var$_addToTimeline = (timeline, child, position, skipChecks)=>{
    child.parent && $ae2aa5d5610059af$var$_removeFromParent(child);
    child._start = $ae2aa5d5610059af$var$_roundPrecise(($ae2aa5d5610059af$var$_isNumber(position) ? position : position || timeline !== $ae2aa5d5610059af$var$_globalTimeline ? $ae2aa5d5610059af$var$_parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = $ae2aa5d5610059af$var$_roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    $ae2aa5d5610059af$var$_addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    $ae2aa5d5610059af$var$_isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || $ae2aa5d5610059af$var$_postAddChecks(timeline, child);
    timeline._ts < 0 && $ae2aa5d5610059af$var$_alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, $ae2aa5d5610059af$var$_scrollTrigger = (animation, trigger)=>($ae2aa5d5610059af$var$_globals.ScrollTrigger || $ae2aa5d5610059af$export$7fb54635790b59a5("scrollTrigger", trigger)) && $ae2aa5d5610059af$var$_globals.ScrollTrigger.create(trigger, animation), $ae2aa5d5610059af$var$_attemptInitTween = (tween, time, force, suppressEvents, tTime)=>{
    $ae2aa5d5610059af$var$_initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !$ae2aa5d5610059af$var$_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && $ae2aa5d5610059af$var$_lastRenderedFrame !== $ae2aa5d5610059af$export$762ed8fbedb691e3.frame) {
        $ae2aa5d5610059af$var$_lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, $ae2aa5d5610059af$var$_parentPlayheadIsBeforeStart = ({ parent: parent })=>parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || $ae2aa5d5610059af$var$_parentPlayheadIsBeforeStart(parent)), $ae2aa5d5610059af$var$_isFromOrFromStart = ({ data: data })=>data === "isFromStart" || data === "isStart", $ae2aa5d5610059af$var$_renderZeroDurationTween = (tween, totalTime, suppressEvents, force)=>{
    let prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && $ae2aa5d5610059af$var$_parentPlayheadIsBeforeStart(tween) && !(!tween._initted && $ae2aa5d5610059af$var$_isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !$ae2aa5d5610059af$var$_isFromOrFromStart(tween)) ? 0 : 1, repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        tTime = $ae2aa5d5610059af$var$_clamp(0, tween._tDur, totalTime);
        iteration = $ae2aa5d5610059af$var$_animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== $ae2aa5d5610059af$var$_animationCycle(tween._tTime, repeatDelay)) {
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || $ae2aa5d5610059af$var$_reverting || force || tween._zTime === $ae2aa5d5610059af$var$_tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && $ae2aa5d5610059af$var$_attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? $ae2aa5d5610059af$var$_tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && $ae2aa5d5610059af$var$_rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && $ae2aa5d5610059af$var$_callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && $ae2aa5d5610059af$var$_callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && $ae2aa5d5610059af$var$_removeFromParent(tween, 1);
            if (!suppressEvents && !$ae2aa5d5610059af$var$_reverting) {
                $ae2aa5d5610059af$var$_callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, $ae2aa5d5610059af$var$_findNextPauseTween = (animation, prevTime, time)=>{
    let child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, $ae2aa5d5610059af$var$_setDuration = (animation, duration, skipUncache, leavePlayhead)=>{
    let repeat = animation._repeat, dur = $ae2aa5d5610059af$var$_roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : $ae2aa5d5610059af$var$_roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && $ae2aa5d5610059af$var$_alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && $ae2aa5d5610059af$var$_setEnd(animation);
    skipUncache || $ae2aa5d5610059af$var$_uncache(animation.parent, animation);
    return animation;
}, $ae2aa5d5610059af$var$_onUpdateTotalDuration = (animation)=>animation instanceof $ae2aa5d5610059af$export$e6a97ba2cae5bb94 ? $ae2aa5d5610059af$var$_uncache(animation) : $ae2aa5d5610059af$var$_setDuration(animation, animation._dur), $ae2aa5d5610059af$var$_zeroPosition = {
    _start: 0,
    endTime: $ae2aa5d5610059af$var$_emptyFunc,
    totalDuration: $ae2aa5d5610059af$var$_emptyFunc
}, $ae2aa5d5610059af$var$_parsePosition = (animation, position, percentAnimation)=>{
    let labels = animation.labels, recent = animation._recent || $ae2aa5d5610059af$var$_zeroPosition, clippedDuration = animation.duration() >= $ae2aa5d5610059af$var$_bigNum ? recent.endTime(false) : animation._dur, i, offset, isPercent;
    if ($ae2aa5d5610059af$export$f664476fd67145ca(position) && (isNaN(position) || position in labels)) {
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * ($ae2aa5d5610059af$var$_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? $ae2aa5d5610059af$var$_parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, $ae2aa5d5610059af$var$_createTweenType = (type, params, timeline)=>{
    let isLegacy = $ae2aa5d5610059af$var$_isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            irVars = parent.vars.defaults || {};
            parent = $ae2aa5d5610059af$var$_isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = $ae2aa5d5610059af$var$_isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new $ae2aa5d5610059af$export$208a41d6b4e37b97(params[0], vars, params[varsIndex + 1]);
}, $ae2aa5d5610059af$var$_conditionalReturn = (value, func)=>value || value === 0 ? func(value) : func, $ae2aa5d5610059af$var$_clamp = (min, max, value)=>value < min ? min : value > max ? max : value, $ae2aa5d5610059af$export$65f2564e9a9b9222 = (value, v)=>!$ae2aa5d5610059af$export$f664476fd67145ca(value) || !(v = $ae2aa5d5610059af$var$_unitExp.exec(value)) ? "" : v[1], $ae2aa5d5610059af$export$7d15b64cf5a3a4c4 = (min, max, value)=>$ae2aa5d5610059af$var$_conditionalReturn(value, (v)=>$ae2aa5d5610059af$var$_clamp(min, max, v)), $ae2aa5d5610059af$var$_slice = [].slice, $ae2aa5d5610059af$var$_isArrayLike = (value, nonEmpty)=>value && $ae2aa5d5610059af$var$_isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && $ae2aa5d5610059af$var$_isObject(value[0])) && !value.nodeType && value !== $ae2aa5d5610059af$var$_win, $ae2aa5d5610059af$var$_flatten = (ar, leaveStrings, accumulator = [])=>ar.forEach((value)=>$ae2aa5d5610059af$export$f664476fd67145ca(value) && !leaveStrings || $ae2aa5d5610059af$var$_isArrayLike(value, 1) ? accumulator.push(...$ae2aa5d5610059af$export$45b10814cc054894(value)) : accumulator.push(value)) || accumulator, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
$ae2aa5d5610059af$export$45b10814cc054894 = (value, scope, leaveStrings)=>$ae2aa5d5610059af$var$_context && !scope && $ae2aa5d5610059af$var$_context.selector ? $ae2aa5d5610059af$var$_context.selector(value) : $ae2aa5d5610059af$export$f664476fd67145ca(value) && !leaveStrings && ($ae2aa5d5610059af$var$_coreInitted || !$ae2aa5d5610059af$var$_wake()) ? $ae2aa5d5610059af$var$_slice.call((scope || $ae2aa5d5610059af$var$_doc).querySelectorAll(value), 0) : $ae2aa5d5610059af$var$_isArray(value) ? $ae2aa5d5610059af$var$_flatten(value, leaveStrings) : $ae2aa5d5610059af$var$_isArrayLike(value) ? $ae2aa5d5610059af$var$_slice.call(value, 0) : value ? [
        value
    ] : [], $ae2aa5d5610059af$export$aea217a45095ce11 = (value)=>{
    value = $ae2aa5d5610059af$export$45b10814cc054894(value)[0] || $ae2aa5d5610059af$var$_warn("Invalid scope") || {};
    return (v)=>{
        let el = value.current || value.nativeElement || value;
        return $ae2aa5d5610059af$export$45b10814cc054894(v, el.querySelectorAll ? el : el === value ? $ae2aa5d5610059af$var$_warn("Invalid scope") || $ae2aa5d5610059af$var$_doc.createElement("div") : value);
    };
}, $ae2aa5d5610059af$export$448332262467e042 = (a)=>a.sort(()=>.5 - Math.random()), //for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
$ae2aa5d5610059af$export$f02a9ddbe4480f19 = (v)=>{
    if ($ae2aa5d5610059af$var$_isFunction(v)) return v;
    let vars = $ae2aa5d5610059af$var$_isObject(v) ? v : {
        each: v
    }, ease = $ae2aa5d5610059af$var$_parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if ($ae2aa5d5610059af$export$f664476fd67145ca(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return (i, target, a)=>{
        let l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                $ae2aa5d5610059af$var$_bigNum
            ])[1];
            if (!wrapAt) {
                max = -$ae2aa5d5610059af$var$_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === $ae2aa5d5610059af$var$_bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = $ae2aa5d5610059af$var$_bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? $ae2aa5d5610059af$var$_sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && $ae2aa5d5610059af$export$448332262467e042(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = $ae2aa5d5610059af$export$65f2564e9a9b9222(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? $ae2aa5d5610059af$var$_invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return $ae2aa5d5610059af$var$_roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, $ae2aa5d5610059af$export$dd12390e6b265a17 = (v)=>{
    let p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return (raw)=>{
        let n = $ae2aa5d5610059af$var$_roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + ($ae2aa5d5610059af$var$_isNumber(raw) ? 0 : $ae2aa5d5610059af$export$65f2564e9a9b9222(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, $ae2aa5d5610059af$export$51a0620f7a28532b = (snapTo, value)=>{
    let isArray = $ae2aa5d5610059af$var$_isArray(snapTo), radius, is2D;
    if (!isArray && $ae2aa5d5610059af$var$_isObject(snapTo)) {
        radius = isArray = snapTo.radius || $ae2aa5d5610059af$var$_bigNum;
        if (snapTo.values) {
            snapTo = $ae2aa5d5610059af$export$45b10814cc054894(snapTo.values);
            if (is2D = !$ae2aa5d5610059af$var$_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = $ae2aa5d5610059af$export$dd12390e6b265a17(snapTo.increment);
    }
    return $ae2aa5d5610059af$var$_conditionalReturn(value, !isArray ? $ae2aa5d5610059af$export$dd12390e6b265a17(snapTo) : $ae2aa5d5610059af$var$_isFunction(snapTo) ? (raw)=>{
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : (raw)=>{
        let x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = $ae2aa5d5610059af$var$_bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || $ae2aa5d5610059af$var$_isNumber(raw) ? closest : closest + $ae2aa5d5610059af$export$65f2564e9a9b9222(raw);
    });
}, $ae2aa5d5610059af$export$4385e60b38654f68 = (min, max, roundingIncrement, returnFunction)=>$ae2aa5d5610059af$var$_conditionalReturn($ae2aa5d5610059af$var$_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, ()=>$ae2aa5d5610059af$var$_isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? 10 ** ((roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction), $ae2aa5d5610059af$export$a4627e546088548d = (...functions)=>(value)=>functions.reduce((v, f)=>f(v), value), $ae2aa5d5610059af$export$d7502930aa5492de = (func, unit)=>(value)=>func(parseFloat(value)) + (unit || $ae2aa5d5610059af$export$65f2564e9a9b9222(value)), $ae2aa5d5610059af$export$a3295358bff77e = (min, max, value)=>$ae2aa5d5610059af$export$f65a7599bbc6b121(min, max, 0, 1, value), $ae2aa5d5610059af$var$_wrapArray = (a, wrapper, value)=>$ae2aa5d5610059af$var$_conditionalReturn(value, (index)=>a[~~wrapper(index)]), $ae2aa5d5610059af$export$4997ffc0176396a6 = function(min, max, value) {
    let range = max - min;
    return $ae2aa5d5610059af$var$_isArray(min) ? $ae2aa5d5610059af$var$_wrapArray(min, $ae2aa5d5610059af$export$4997ffc0176396a6(0, min.length), max) : $ae2aa5d5610059af$var$_conditionalReturn(value, (value)=>(range + (value - min) % range) % range + min);
}, $ae2aa5d5610059af$export$cfc0b067273edc55 = (min, max, value)=>{
    let range = max - min, total = range * 2;
    return $ae2aa5d5610059af$var$_isArray(min) ? $ae2aa5d5610059af$var$_wrapArray(min, $ae2aa5d5610059af$export$cfc0b067273edc55(0, min.length - 1), max) : $ae2aa5d5610059af$var$_conditionalReturn(value, (value)=>{
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, $ae2aa5d5610059af$export$d5962a97e3cde94d = (value)=>{
    let prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? $ae2aa5d5610059af$var$_delimitedValueExp : $ae2aa5d5610059af$var$_strictNumExp);
        s += value.substr(prev, i - prev) + $ae2aa5d5610059af$export$4385e60b38654f68(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, $ae2aa5d5610059af$export$f65a7599bbc6b121 = (inMin, inMax, outMin, outMax, value)=>{
    let inRange = inMax - inMin, outRange = outMax - outMin;
    return $ae2aa5d5610059af$var$_conditionalReturn(value, (value)=>outMin + ((value - inMin) / inRange * outRange || 0));
}, $ae2aa5d5610059af$export$89e29e4ab65e70a9 = (start, end, progress, mutate)=>{
    let func = isNaN(start + end) ? 0 : (p)=>(1 - p) * start + p * end;
    if (!func) {
        let isString = $ae2aa5d5610059af$export$f664476fd67145ca(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if ($ae2aa5d5610059af$var$_isArray(start) && !$ae2aa5d5610059af$var$_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push($ae2aa5d5610059af$export$89e29e4ab65e70a9(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = (p)=>{
                p *= l;
                let i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = $ae2aa5d5610059af$var$_merge($ae2aa5d5610059af$var$_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)$ae2aa5d5610059af$var$_addPropTween.call(master, start, p, "get", end[p]);
            func = (p)=>$ae2aa5d5610059af$var$_renderPropTweens(p, master) || (isString ? start.p : start);
        }
    }
    return $ae2aa5d5610059af$var$_conditionalReturn(progress, func);
}, $ae2aa5d5610059af$var$_getLabelInDirection = (timeline, fromTime, backward)=>{
    let labels = timeline.labels, min = $ae2aa5d5610059af$var$_bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, $ae2aa5d5610059af$var$_callback = (animation, type, executeLazyFirst)=>{
    let v = animation.vars, callback = v[type], prevContext = $ae2aa5d5610059af$var$_context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && $ae2aa5d5610059af$var$_lazyTweens.length && $ae2aa5d5610059af$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && ($ae2aa5d5610059af$var$_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    $ae2aa5d5610059af$var$_context = prevContext;
    return result;
}, $ae2aa5d5610059af$var$_interrupt = (animation)=>{
    $ae2aa5d5610059af$var$_removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!$ae2aa5d5610059af$var$_reverting);
    animation.progress() < 1 && $ae2aa5d5610059af$var$_callback(animation, "onInterrupt");
    return animation;
}, $ae2aa5d5610059af$var$_quickTween, $ae2aa5d5610059af$var$_registerPluginQueue = [], $ae2aa5d5610059af$var$_createPlugin = (config)=>{
    if ($ae2aa5d5610059af$var$_windowExists() && config) {
        config = !config.name && config.default || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
        let name = config.name, isFunc = $ae2aa5d5610059af$var$_isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, instanceDefaults = {
            init: $ae2aa5d5610059af$var$_emptyFunc,
            render: $ae2aa5d5610059af$var$_renderPropTweens,
            add: $ae2aa5d5610059af$var$_addPropTween,
            kill: $ae2aa5d5610059af$var$_killPropTweensOf,
            modifier: $ae2aa5d5610059af$var$_addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: $ae2aa5d5610059af$export$d60fbc1e0278aaf0,
            aliases: {},
            register: 0
        };
        $ae2aa5d5610059af$var$_wake();
        if (config !== Plugin) {
            if ($ae2aa5d5610059af$export$d305d8ec5d7c26b8[name]) return;
            $ae2aa5d5610059af$export$dc2b19673bb53610(Plugin, $ae2aa5d5610059af$export$dc2b19673bb53610($ae2aa5d5610059af$var$_copyExcluding(config, instanceDefaults), statics)); //static methods
            $ae2aa5d5610059af$var$_merge(Plugin.prototype, $ae2aa5d5610059af$var$_merge(instanceDefaults, $ae2aa5d5610059af$var$_copyExcluding(config, statics))); //instance methods
            $ae2aa5d5610059af$export$d305d8ec5d7c26b8[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                $ae2aa5d5610059af$var$_harnessPlugins.push(Plugin);
                $ae2aa5d5610059af$var$_reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        $ae2aa5d5610059af$var$_addGlobal(name, Plugin);
        config.register && config.register($ae2aa5d5610059af$export$99ee26438460406a, Plugin, $ae2aa5d5610059af$export$3a67f7f44b1e838a);
    } else config && $ae2aa5d5610059af$var$_registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ $ae2aa5d5610059af$var$_255 = 255, $ae2aa5d5610059af$var$_colorLookup = {
    aqua: [
        0,
        $ae2aa5d5610059af$var$_255,
        $ae2aa5d5610059af$var$_255
    ],
    lime: [
        0,
        $ae2aa5d5610059af$var$_255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        $ae2aa5d5610059af$var$_255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        $ae2aa5d5610059af$var$_255,
        $ae2aa5d5610059af$var$_255,
        $ae2aa5d5610059af$var$_255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        $ae2aa5d5610059af$var$_255,
        $ae2aa5d5610059af$var$_255,
        0
    ],
    orange: [
        $ae2aa5d5610059af$var$_255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        $ae2aa5d5610059af$var$_255,
        0,
        0
    ],
    pink: [
        $ae2aa5d5610059af$var$_255,
        192,
        203
    ],
    cyan: [
        0,
        $ae2aa5d5610059af$var$_255,
        $ae2aa5d5610059af$var$_255
    ],
    transparent: [
        $ae2aa5d5610059af$var$_255,
        $ae2aa5d5610059af$var$_255,
        $ae2aa5d5610059af$var$_255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
$ae2aa5d5610059af$var$_hue = (h, m1, m2)=>{
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * $ae2aa5d5610059af$var$_255 + .5 | 0;
}, $ae2aa5d5610059af$export$73d6f35be992df24 = (v, toHSL, forceAlpha)=>{
    let a = !v ? $ae2aa5d5610059af$var$_colorLookup.black : $ae2aa5d5610059af$var$_isNumber(v) ? [
        v >> 16,
        v >> 8 & $ae2aa5d5610059af$var$_255,
        v & $ae2aa5d5610059af$var$_255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") v = v.substr(0, v.length - 1);
        if ($ae2aa5d5610059af$var$_colorLookup[v]) a = $ae2aa5d5610059af$var$_colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & $ae2aa5d5610059af$var$_255,
                    a & $ae2aa5d5610059af$var$_255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & $ae2aa5d5610059af$var$_255,
                v & $ae2aa5d5610059af$var$_255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match($ae2aa5d5610059af$var$_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = $ae2aa5d5610059af$var$_hue(h + 1 / 3, r, g);
                a[1] = $ae2aa5d5610059af$var$_hue(h, r, g);
                a[2] = $ae2aa5d5610059af$var$_hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                a = v.match($ae2aa5d5610059af$export$b9d44bb6523120d6);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match($ae2aa5d5610059af$var$_strictNumExp) || $ae2aa5d5610059af$var$_colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / $ae2aa5d5610059af$var$_255;
        g = a[1] / $ae2aa5d5610059af$var$_255;
        b = a[2] / $ae2aa5d5610059af$var$_255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, $ae2aa5d5610059af$var$_colorOrderData = (v)=>{
    let values = [], c = [], i = -1;
    v.split($ae2aa5d5610059af$export$dd733e62515be2bd).forEach((v)=>{
        let a = v.match($ae2aa5d5610059af$export$65c88bbd597e7b0a) || [];
        values.push(...a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, $ae2aa5d5610059af$var$_formatColors = (s, toHSL, orderMatchData)=>{
    let result = "", colors = (s + result).match($ae2aa5d5610059af$export$dd733e62515be2bd), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map((color)=>(color = $ae2aa5d5610059af$export$73d6f35be992df24(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")");
    if (orderMatchData) {
        d = $ae2aa5d5610059af$var$_colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace($ae2aa5d5610059af$export$dd733e62515be2bd, "1").split($ae2aa5d5610059af$export$65c88bbd597e7b0a);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split($ae2aa5d5610059af$export$dd733e62515be2bd);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, $ae2aa5d5610059af$export$dd733e62515be2bd = function() {
    let s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", p;
    for(p in $ae2aa5d5610059af$var$_colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), $ae2aa5d5610059af$var$_hslExp = /hsl[a]?\(/, $ae2aa5d5610059af$export$7eb2e5eb5eeb96a4 = (a)=>{
    let combined = a.join(" "), toHSL;
    $ae2aa5d5610059af$export$dd733e62515be2bd.lastIndex = 0;
    if ($ae2aa5d5610059af$export$dd733e62515be2bd.test(combined)) {
        toHSL = $ae2aa5d5610059af$var$_hslExp.test(combined);
        a[1] = $ae2aa5d5610059af$var$_formatColors(a[1], toHSL);
        a[0] = $ae2aa5d5610059af$var$_formatColors(a[0], toHSL, $ae2aa5d5610059af$var$_colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ $ae2aa5d5610059af$var$_tickerActive, $ae2aa5d5610059af$export$762ed8fbedb691e3 = function() {
    let _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = (v)=>{
        let elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)_listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick () {
            _tick(true);
        },
        deltaRatio (fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake () {
            if ($ae2aa5d5610059af$var$_coreReady) {
                if (!$ae2aa5d5610059af$var$_coreInitted && $ae2aa5d5610059af$var$_windowExists()) {
                    $ae2aa5d5610059af$var$_win = $ae2aa5d5610059af$var$_coreInitted = window;
                    $ae2aa5d5610059af$var$_doc = $ae2aa5d5610059af$var$_win.document || {};
                    $ae2aa5d5610059af$var$_globals.gsap = $ae2aa5d5610059af$export$99ee26438460406a;
                    ($ae2aa5d5610059af$var$_win.gsapVersions || ($ae2aa5d5610059af$var$_win.gsapVersions = [])).push($ae2aa5d5610059af$export$99ee26438460406a.version);
                    $ae2aa5d5610059af$var$_install($ae2aa5d5610059af$var$_installScope || $ae2aa5d5610059af$var$_win.GreenSockGlobals || !$ae2aa5d5610059af$var$_win.gsap && $ae2aa5d5610059af$var$_win || {});
                    _raf = $ae2aa5d5610059af$var$_win.requestAnimationFrame;
                    $ae2aa5d5610059af$var$_registerPluginQueue.forEach($ae2aa5d5610059af$var$_createPlugin);
                }
                _id && _self.sleep();
                _req = _raf || ((f)=>setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0));
                $ae2aa5d5610059af$var$_tickerActive = 1;
                _tick(2);
            }
        },
        sleep () {
            (_raf ? $ae2aa5d5610059af$var$_win.cancelAnimationFrame : clearTimeout)(_id);
            $ae2aa5d5610059af$var$_tickerActive = 0;
            _req = $ae2aa5d5610059af$var$_emptyFunc;
        },
        lagSmoothing (threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps (fps) {
            _gap = 1000 / (fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add (callback, once, prioritize) {
            let func = once ? (t, d, f, v)=>{
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            $ae2aa5d5610059af$var$_wake();
            return func;
        },
        remove (callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), $ae2aa5d5610059af$var$_wake = ()=>!$ae2aa5d5610059af$var$_tickerActive && $ae2aa5d5610059af$export$762ed8fbedb691e3.wake(), /*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ $ae2aa5d5610059af$var$_easeMap = {}, $ae2aa5d5610059af$var$_customEaseExp = /^[\d.\-M][\d.\-,\s]/, $ae2aa5d5610059af$var$_quotesExp = /["']/g, $ae2aa5d5610059af$var$_parseObjectInString = (value)=>{
    let obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace($ae2aa5d5610059af$var$_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, $ae2aa5d5610059af$var$_valueInParentheses = (value)=>{
    let open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, $ae2aa5d5610059af$var$_configEaseFromString = (name)=>{
    let split = (name + "").split("("), ease = $ae2aa5d5610059af$var$_easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        $ae2aa5d5610059af$var$_parseObjectInString(split[1])
    ] : $ae2aa5d5610059af$var$_valueInParentheses(name).split(",").map($ae2aa5d5610059af$var$_numericIfPossible)) : $ae2aa5d5610059af$var$_easeMap._CE && $ae2aa5d5610059af$var$_customEaseExp.test(name) ? $ae2aa5d5610059af$var$_easeMap._CE("", name) : ease;
}, $ae2aa5d5610059af$var$_invertEase = (ease)=>(p)=>1 - ease(1 - p), // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
$ae2aa5d5610059af$var$_propagateYoyoEase = (timeline, isYoyo)=>{
    let child = timeline._first, ease;
    while(child){
        if (child instanceof $ae2aa5d5610059af$export$e6a97ba2cae5bb94) $ae2aa5d5610059af$var$_propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) $ae2aa5d5610059af$var$_propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, $ae2aa5d5610059af$var$_parseEase = (ease, defaultEase)=>!ease ? defaultEase : ($ae2aa5d5610059af$var$_isFunction(ease) ? ease : $ae2aa5d5610059af$var$_easeMap[ease] || $ae2aa5d5610059af$var$_configEaseFromString(ease)) || defaultEase, $ae2aa5d5610059af$var$_insertEase = (names, easeIn, easeOut = (p)=>1 - easeIn(1 - p), easeInOut = (p)=>p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2)=>{
    let ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    $ae2aa5d5610059af$export$f9000b814859f126(names, (name)=>{
        $ae2aa5d5610059af$var$_easeMap[name] = $ae2aa5d5610059af$var$_globals[name] = ease;
        $ae2aa5d5610059af$var$_easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(let p in ease)$ae2aa5d5610059af$var$_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = $ae2aa5d5610059af$var$_easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, $ae2aa5d5610059af$var$_easeInOutFromOut = (easeOut)=>(p)=>p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2, $ae2aa5d5610059af$var$_configElastic = (type, amplitude, period)=>{
    let p1 = amplitude >= 1 ? amplitude : 1, p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / $ae2aa5d5610059af$var$_2PI * (Math.asin(1 / p1) || 0), easeOut = (p)=>p === 1 ? 1 : p1 * 2 ** (-10 * p) * $ae2aa5d5610059af$var$_sin((p - p3) * p2) + 1, ease = type === "out" ? easeOut : type === "in" ? (p)=>1 - easeOut(1 - p) : $ae2aa5d5610059af$var$_easeInOutFromOut(easeOut);
    p2 = $ae2aa5d5610059af$var$_2PI / p2; //precalculate to optimize
    ease.config = (amplitude, period)=>$ae2aa5d5610059af$var$_configElastic(type, amplitude, period);
    return ease;
}, $ae2aa5d5610059af$var$_configBack = (type, overshoot = 1.70158)=>{
    let easeOut = (p)=>p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0, ease = type === "out" ? easeOut : type === "in" ? (p)=>1 - easeOut(1 - p) : $ae2aa5d5610059af$var$_easeInOutFromOut(easeOut);
    ease.config = (overshoot)=>$ae2aa5d5610059af$var$_configBack(type, overshoot);
    return ease;
};
// a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
$ae2aa5d5610059af$export$f9000b814859f126("Linear,Quad,Cubic,Quart,Quint,Strong", (name, i)=>{
    let power = i < 5 ? i + 1 : i;
    $ae2aa5d5610059af$var$_insertEase(name + ",Power" + (power - 1), i ? (p)=>p ** power : (p)=>p, (p)=>1 - (1 - p) ** power, (p)=>p < .5 ? (p * 2) ** power / 2 : 1 - ((1 - p) * 2) ** power / 2);
});
$ae2aa5d5610059af$var$_easeMap.Linear.easeNone = $ae2aa5d5610059af$var$_easeMap.none = $ae2aa5d5610059af$var$_easeMap.Linear.easeIn;
$ae2aa5d5610059af$var$_insertEase("Elastic", $ae2aa5d5610059af$var$_configElastic("in"), $ae2aa5d5610059af$var$_configElastic("out"), $ae2aa5d5610059af$var$_configElastic());
((n, c)=>{
    let n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = (p)=>p < n1 ? n * p * p : p < n2 ? n * (p - 1.5 / c) ** 2 + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * (p - 2.625 / c) ** 2 + .984375;
    $ae2aa5d5610059af$var$_insertEase("Bounce", (p)=>1 - easeOut(1 - p), easeOut);
})(7.5625, 2.75);
$ae2aa5d5610059af$var$_insertEase("Expo", (p)=>p ? 2 ** (10 * (p - 1)) : 0);
$ae2aa5d5610059af$var$_insertEase("Circ", (p)=>-($ae2aa5d5610059af$var$_sqrt(1 - p * p) - 1));
$ae2aa5d5610059af$var$_insertEase("Sine", (p)=>p === 1 ? 1 : -$ae2aa5d5610059af$var$_cos(p * $ae2aa5d5610059af$var$_HALF_PI) + 1);
$ae2aa5d5610059af$var$_insertEase("Back", $ae2aa5d5610059af$var$_configBack("in"), $ae2aa5d5610059af$var$_configBack("out"), $ae2aa5d5610059af$var$_configBack());
$ae2aa5d5610059af$var$_easeMap.SteppedEase = $ae2aa5d5610059af$var$_easeMap.steps = $ae2aa5d5610059af$var$_globals.SteppedEase = {
    config (steps = 1, immediateStart) {
        let p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - $ae2aa5d5610059af$var$_tinyNum;
        return (p)=>((p2 * $ae2aa5d5610059af$var$_clamp(0, max, p) | 0) + p3) * p1;
    }
};
$ae2aa5d5610059af$var$_defaults.ease = $ae2aa5d5610059af$var$_easeMap["quad.out"];
$ae2aa5d5610059af$export$f9000b814859f126("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", (name)=>$ae2aa5d5610059af$var$_callbackNames += name + "," + name + "Params,");
class $ae2aa5d5610059af$export$cf10981d5419cad5 {
    constructor(target, harness){
        this.id = $ae2aa5d5610059af$var$_gsID++;
        target._gsap = this;
        this.target = target;
        this.harness = harness;
        this.get = harness ? harness.get : $ae2aa5d5610059af$export$51d6bbe898aef1f9;
        this.set = harness ? harness.getSetter : $ae2aa5d5610059af$export$d60fbc1e0278aaf0;
    }
}
class $ae2aa5d5610059af$export$c35d437ae5945fcd {
    constructor(vars){
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        $ae2aa5d5610059af$var$_setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if ($ae2aa5d5610059af$var$_context) {
            this._ctx = $ae2aa5d5610059af$var$_context;
            $ae2aa5d5610059af$var$_context.data.push(this);
        }
        $ae2aa5d5610059af$var$_tickerActive || $ae2aa5d5610059af$export$762ed8fbedb691e3.wake();
    }
    delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    }
    duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    }
    totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return $ae2aa5d5610059af$var$_setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    }
    totalTime(totalTime, suppressEvents) {
        $ae2aa5d5610059af$var$_wake();
        if (!arguments.length) return this._tTime;
        let parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            $ae2aa5d5610059af$var$_alignPlayhead(this, totalTime);
            !parent._dp || parent.parent || $ae2aa5d5610059af$var$_postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && totalTime < this._tDur || this._ts < 0 && totalTime > 0 || !this._tDur && !totalTime)) $ae2aa5d5610059af$var$_addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === $ae2aa5d5610059af$var$_tinyNum || !totalTime && !this._initted && (this.add || this._ptLookup)) {
            this._ts || (this._pTime = totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            $ae2aa5d5610059af$var$_lazySafeRender(this, totalTime, suppressEvents);
        //   this._lock = 0;
        //}
        }
        return this;
    }
    time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + $ae2aa5d5610059af$var$_elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    }
    totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    }
    progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + $ae2aa5d5610059af$var$_elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    }
    iteration(value, suppressEvents) {
        let cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? $ae2aa5d5610059af$var$_animationCycle(this._tTime, cycleDuration) + 1 : 1;
    }
    // potential future addition:
    // isPlayingBackwards() {
    // 	let animation = this,
    // 		orientation = 1; // 1 = forward, -1 = backward
    // 	while (animation) {
    // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
    // 		animation = animation.parent;
    // 	}
    // 	return orientation < 0;
    // }
    timeScale(value) {
        if (!arguments.length) return this._rts === -$ae2aa5d5610059af$var$_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        let tTime = this.parent && this._ts ? $ae2aa5d5610059af$var$_parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -$ae2aa5d5610059af$var$_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime($ae2aa5d5610059af$var$_clamp(-Math.abs(this._delay), this._tDur, tTime), true);
        $ae2aa5d5610059af$var$_setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return $ae2aa5d5610059af$var$_recacheAncestors(this);
    }
    paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                $ae2aa5d5610059af$var$_wake();
                this._ts = this._rts;
                //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== $ae2aa5d5610059af$var$_tinyNum && (this._tTime -= $ae2aa5d5610059af$var$_tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    }
    startTime(value) {
        if (arguments.length) {
            this._start = value;
            let parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && $ae2aa5d5610059af$var$_addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    }
    endTime(includeRepeats) {
        return this._start + ($ae2aa5d5610059af$var$_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    }
    rawTime(wrapRepeats) {
        let parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : $ae2aa5d5610059af$var$_parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    }
    revert(config = $ae2aa5d5610059af$var$_revertConfig) {
        let prevIsReverting = $ae2aa5d5610059af$var$_reverting;
        $ae2aa5d5610059af$var$_reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        $ae2aa5d5610059af$var$_reverting = prevIsReverting;
        return this;
    }
    globalTime(rawTime) {
        let animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.vars.immediateRender ? -Infinity : this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    }
    repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return $ae2aa5d5610059af$var$_onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    }
    repeatDelay(value) {
        if (arguments.length) {
            let time = this._time;
            this._rDelay = value;
            $ae2aa5d5610059af$var$_onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    }
    yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    }
    seek(position, suppressEvents) {
        return this.totalTime($ae2aa5d5610059af$var$_parsePosition(this, position), $ae2aa5d5610059af$var$_isNotFalse(suppressEvents));
    }
    restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, $ae2aa5d5610059af$var$_isNotFalse(suppressEvents));
    }
    play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    }
    reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    }
    pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    }
    resume() {
        return this.paused(false);
    }
    reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -$ae2aa5d5610059af$var$_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    }
    invalidate() {
        this._initted = this._act = 0;
        this._zTime = -$ae2aa5d5610059af$var$_tinyNum;
        return this;
    }
    isActive() {
        let parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - $ae2aa5d5610059af$var$_tinyNum);
    }
    eventCallback(type, callback, params) {
        let vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    }
    then(onFulfilled) {
        let self = this;
        return new Promise((resolve)=>{
            let f = $ae2aa5d5610059af$var$_isFunction(onFulfilled) ? onFulfilled : $ae2aa5d5610059af$var$_passThrough, _resolve = ()=>{
                let _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                $ae2aa5d5610059af$var$_isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    }
    kill() {
        $ae2aa5d5610059af$var$_interrupt(this);
    }
}
$ae2aa5d5610059af$export$dc2b19673bb53610($ae2aa5d5610059af$export$c35d437ae5945fcd.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -$ae2aa5d5610059af$var$_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
class $ae2aa5d5610059af$export$e6a97ba2cae5bb94 extends $ae2aa5d5610059af$export$c35d437ae5945fcd {
    constructor(vars = {}, position){
        super(vars);
        this.labels = {};
        this.smoothChildTiming = !!vars.smoothChildTiming;
        this.autoRemoveChildren = !!vars.autoRemoveChildren;
        this._sort = $ae2aa5d5610059af$var$_isNotFalse(vars.sortChildren);
        $ae2aa5d5610059af$var$_globalTimeline && $ae2aa5d5610059af$var$_addToTimeline(vars.parent || $ae2aa5d5610059af$var$_globalTimeline, this, position);
        vars.reversed && this.reverse();
        vars.paused && this.paused(true);
        vars.scrollTrigger && $ae2aa5d5610059af$var$_scrollTrigger(this, vars.scrollTrigger);
    }
    to(targets, vars, position) {
        $ae2aa5d5610059af$var$_createTweenType(0, arguments, this);
        return this;
    }
    from(targets, vars, position) {
        $ae2aa5d5610059af$var$_createTweenType(1, arguments, this);
        return this;
    }
    fromTo(targets, fromVars, toVars, position) {
        $ae2aa5d5610059af$var$_createTweenType(2, arguments, this);
        return this;
    }
    set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        $ae2aa5d5610059af$var$_inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new $ae2aa5d5610059af$export$208a41d6b4e37b97(targets, vars, $ae2aa5d5610059af$var$_parsePosition(this, position), 1);
        return this;
    }
    call(callback, params, position) {
        return $ae2aa5d5610059af$var$_addToTimeline(this, $ae2aa5d5610059af$export$208a41d6b4e37b97.delayedCall(0, callback, params), position);
    }
    //ONLY for backward compatibility! Maybe delete?
    staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new $ae2aa5d5610059af$export$208a41d6b4e37b97(targets, vars, $ae2aa5d5610059af$var$_parsePosition(this, position));
        return this;
    }
    staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        $ae2aa5d5610059af$var$_inheritDefaults(vars).immediateRender = $ae2aa5d5610059af$var$_isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    }
    staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        $ae2aa5d5610059af$var$_inheritDefaults(toVars).immediateRender = $ae2aa5d5610059af$var$_isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    }
    render(totalTime, suppressEvents, force) {
        let prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : $ae2aa5d5610059af$var$_roundPrecise(totalTime), crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== $ae2aa5d5610059af$var$_globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime);
                //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $ae2aa5d5610059af$var$_roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = $ae2aa5d5610059af$var$_animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
				make sure children at the end/beginning of the timeline are rendered properly. If, for example,
				a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
				would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
				could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
				we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
				ensure that zero-duration tweens at the very beginning or end of the Timeline work.
				*/ if (iteration !== prevIteration && !this._lock) {
                    let rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : $ae2aa5d5610059af$var$_roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && $ae2aa5d5610059af$var$_callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                    //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    $ae2aa5d5610059af$var$_propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = $ae2aa5d5610059af$var$_findNextPauseTween(this, $ae2aa5d5610059af$var$_roundPrecise(prevTime), $ae2aa5d5610059af$var$_roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                $ae2aa5d5610059af$var$_callback(this, "onStart");
                if (this._tTime !== tTime) return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            pauseTween = 0;
                            next && (tTime += this._zTime = -$ae2aa5d5610059af$var$_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                let adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || $ae2aa5d5610059af$var$_reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -$ae2aa5d5610059af$var$_tinyNum : $ae2aa5d5610059af$var$_tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -$ae2aa5d5610059af$var$_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    $ae2aa5d5610059af$var$_setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && $ae2aa5d5610059af$var$_callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && $ae2aa5d5610059af$var$_removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            $ae2aa5d5610059af$var$_callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    }
    add(child, position) {
        $ae2aa5d5610059af$var$_isNumber(position) || (position = $ae2aa5d5610059af$var$_parsePosition(this, position, child));
        if (!(child instanceof $ae2aa5d5610059af$export$c35d437ae5945fcd)) {
            if ($ae2aa5d5610059af$var$_isArray(child)) {
                child.forEach((obj)=>this.add(obj, position));
                return this;
            }
            if ($ae2aa5d5610059af$export$f664476fd67145ca(child)) return this.addLabel(child, position);
            if ($ae2aa5d5610059af$var$_isFunction(child)) child = $ae2aa5d5610059af$export$208a41d6b4e37b97.delayedCall(0, child);
            else return this;
        }
        return this !== child ? $ae2aa5d5610059af$var$_addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    }
    getChildren(nested = true, tweens = true, timelines = true, ignoreBeforeTime = -$ae2aa5d5610059af$var$_bigNum) {
        let a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof $ae2aa5d5610059af$export$208a41d6b4e37b97) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push(...child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    }
    getById(id) {
        let animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    }
    remove(child) {
        if ($ae2aa5d5610059af$export$f664476fd67145ca(child)) return this.removeLabel(child);
        if ($ae2aa5d5610059af$var$_isFunction(child)) return this.killTweensOf(child);
        $ae2aa5d5610059af$export$cd008aa6cd8844e3(this, child);
        if (child === this._recent) this._recent = this._last;
        return $ae2aa5d5610059af$var$_uncache(this);
    }
    totalTime(totalTime, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) this._start = $ae2aa5d5610059af$var$_roundPrecise($ae2aa5d5610059af$export$762ed8fbedb691e3.time - (this._ts > 0 ? totalTime / this._ts : (this.totalDuration() - totalTime) / -this._ts));
        super.totalTime(totalTime, suppressEvents);
        this._forcing = 0;
        return this;
    }
    addLabel(label, position) {
        this.labels[label] = $ae2aa5d5610059af$var$_parsePosition(this, position);
        return this;
    }
    removeLabel(label) {
        delete this.labels[label];
        return this;
    }
    addPause(position, callback, params) {
        let t = $ae2aa5d5610059af$export$208a41d6b4e37b97.delayedCall(0, callback || $ae2aa5d5610059af$var$_emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return $ae2aa5d5610059af$var$_addToTimeline(this, t, $ae2aa5d5610059af$var$_parsePosition(this, position));
    }
    removePause(position) {
        let child = this._first;
        position = $ae2aa5d5610059af$var$_parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") $ae2aa5d5610059af$var$_removeFromParent(child);
            child = child._next;
        }
    }
    killTweensOf(targets, props, onlyActive) {
        let tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)$ae2aa5d5610059af$var$_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    }
    getTweensOf(targets, onlyActive) {
        let a = [], parsedTargets = $ae2aa5d5610059af$export$45b10814cc054894(targets), child = this._first, isGlobalTime = $ae2aa5d5610059af$var$_isNumber(onlyActive), children;
        while(child){
            if (child instanceof $ae2aa5d5610059af$export$208a41d6b4e37b97) {
                if ($ae2aa5d5610059af$var$_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!$ae2aa5d5610059af$var$_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push(...children);
            child = child._next;
        }
        return a;
    }
    // potential future feature - targets() on timelines
    // targets() {
    // 	let result = [];
    // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
    // 	return result.filter((v, i) => result.indexOf(v) === i);
    // }
    tweenTo(position, vars) {
        vars = vars || {};
        let tl = this, endTime = $ae2aa5d5610059af$var$_parsePosition(tl, position), { startAt: startAt, onStart: onStart, onStartParams: onStartParams, immediateRender: immediateRender } = vars, initted, tween = $ae2aa5d5610059af$export$208a41d6b4e37b97.to(tl, $ae2aa5d5610059af$export$dc2b19673bb53610({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || $ae2aa5d5610059af$var$_tinyNum,
            onStart: ()=>{
                tl.pause();
                if (!initted) {
                    let duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && $ae2aa5d5610059af$var$_setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                onStart && onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    }
    tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, $ae2aa5d5610059af$export$dc2b19673bb53610({
            startAt: {
                time: $ae2aa5d5610059af$var$_parsePosition(this, fromPosition)
            }
        }, vars));
    }
    recent() {
        return this._recent;
    }
    nextLabel(afterTime = this._time) {
        return $ae2aa5d5610059af$var$_getLabelInDirection(this, $ae2aa5d5610059af$var$_parsePosition(this, afterTime));
    }
    previousLabel(beforeTime = this._time) {
        return $ae2aa5d5610059af$var$_getLabelInDirection(this, $ae2aa5d5610059af$var$_parsePosition(this, beforeTime), 1);
    }
    currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + $ae2aa5d5610059af$var$_tinyNum);
    }
    shiftChildren(amount, adjustLabels, ignoreBeforeTime = 0) {
        let child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return $ae2aa5d5610059af$var$_uncache(this);
    }
    invalidate(soft) {
        let child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return super.invalidate(soft);
    }
    clear(includeLabels = true) {
        let child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return $ae2aa5d5610059af$var$_uncache(this);
    }
    totalDuration(value) {
        let max = 0, self = this, child = self._last, prevStart = $ae2aa5d5610059af$var$_bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    $ae2aa5d5610059af$var$_addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            $ae2aa5d5610059af$var$_setDuration(self, self === $ae2aa5d5610059af$var$_globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    }
    static updateRoot(time) {
        if ($ae2aa5d5610059af$var$_globalTimeline._ts) {
            $ae2aa5d5610059af$var$_lazySafeRender($ae2aa5d5610059af$var$_globalTimeline, $ae2aa5d5610059af$var$_parentToChildTotalTime(time, $ae2aa5d5610059af$var$_globalTimeline));
            $ae2aa5d5610059af$var$_lastRenderedFrame = $ae2aa5d5610059af$export$762ed8fbedb691e3.frame;
        }
        if ($ae2aa5d5610059af$export$762ed8fbedb691e3.frame >= $ae2aa5d5610059af$var$_nextGCFrame) {
            $ae2aa5d5610059af$var$_nextGCFrame += $ae2aa5d5610059af$export$4922bee768729a77.autoSleep || 120;
            let child = $ae2aa5d5610059af$var$_globalTimeline._first;
            if (!child || !child._ts) {
                if ($ae2aa5d5610059af$export$4922bee768729a77.autoSleep && $ae2aa5d5610059af$export$762ed8fbedb691e3._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || $ae2aa5d5610059af$export$762ed8fbedb691e3.sleep();
                }
            }
        }
    }
}
$ae2aa5d5610059af$export$dc2b19673bb53610($ae2aa5d5610059af$export$e6a97ba2cae5bb94.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
let $ae2aa5d5610059af$var$_addComplexStringPropTween = function(target, prop, start, end, setter, stringFilter, funcParam) {
    let pt = new $ae2aa5d5610059af$export$3a67f7f44b1e838a(this._pt, target, prop, 0, 1, $ae2aa5d5610059af$export$c5bc8e04394ecb2, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = $ae2aa5d5610059af$export$d5962a97e3cde94d(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match($ae2aa5d5610059af$var$_complexStringNumExp) || [];
    while(result = $ae2aa5d5610059af$var$_complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0;
            //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                s: startNum,
                c: endNum.charAt(1) === "=" ? $ae2aa5d5610059af$export$dac762bc6301b560(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = $ae2aa5d5610059af$var$_complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if ($ae2aa5d5610059af$export$5a680e28b0b61bc.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, $ae2aa5d5610059af$var$_addPropTween = function(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    $ae2aa5d5610059af$var$_isFunction(end) && (end = end(index || 0, target, targets));
    let currentValue = target[prop], parsedStart = start !== "get" ? start : !$ae2aa5d5610059af$var$_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !$ae2aa5d5610059af$var$_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !$ae2aa5d5610059af$var$_isFunction(currentValue) ? $ae2aa5d5610059af$var$_setterPlain : funcParam ? $ae2aa5d5610059af$var$_setterFuncWithParam : $ae2aa5d5610059af$var$_setterFunc, pt;
    if ($ae2aa5d5610059af$export$f664476fd67145ca(end)) {
        if (~end.indexOf("random(")) end = $ae2aa5d5610059af$export$d5962a97e3cde94d(end);
        if (end.charAt(1) === "=") {
            pt = $ae2aa5d5610059af$export$dac762bc6301b560(parsedStart, end) + ($ae2aa5d5610059af$export$65f2564e9a9b9222(parsedStart) || 0);
            if (pt || pt === 0) end = pt;
        }
    }
    if (!optional || parsedStart !== end || $ae2aa5d5610059af$var$_forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            pt = new $ae2aa5d5610059af$export$3a67f7f44b1e838a(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? $ae2aa5d5610059af$var$_renderBoolean : $ae2aa5d5610059af$var$_renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && $ae2aa5d5610059af$export$7fb54635790b59a5(prop, end);
        return $ae2aa5d5610059af$var$_addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || $ae2aa5d5610059af$export$4922bee768729a77.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
$ae2aa5d5610059af$var$_processVars = (vars, index, target, targets, tween)=>{
    $ae2aa5d5610059af$var$_isFunction(vars) && (vars = $ae2aa5d5610059af$var$_parseFuncOrString(vars, tween, index, target, targets));
    if (!$ae2aa5d5610059af$var$_isObject(vars) || vars.style && vars.nodeType || $ae2aa5d5610059af$var$_isArray(vars) || $ae2aa5d5610059af$var$_isTypedArray(vars)) return $ae2aa5d5610059af$export$f664476fd67145ca(vars) ? $ae2aa5d5610059af$var$_parseFuncOrString(vars, tween, index, target, targets) : vars;
    let copy = {}, p;
    for(p in vars)copy[p] = $ae2aa5d5610059af$var$_parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, $ae2aa5d5610059af$export$5c457b74208010cf = (property, vars, tween, index, target, targets)=>{
    let plugin, pt, ptLookup, i;
    if ($ae2aa5d5610059af$export$d305d8ec5d7c26b8[property] && (plugin = new $ae2aa5d5610059af$export$d305d8ec5d7c26b8[property]()).init(target, plugin.rawVars ? vars[property] : $ae2aa5d5610059af$var$_processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new $ae2aa5d5610059af$export$3a67f7f44b1e838a(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== $ae2aa5d5610059af$var$_quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, $ae2aa5d5610059af$var$_overwritingTween, $ae2aa5d5610059af$var$_forceAllPropTweens, $ae2aa5d5610059af$var$_initTween = (tween, time, tTime)=>{
    let vars = tween.vars, { ease: ease, startAt: startAt, immediateRender: immediateRender, lazy: lazy, onUpdate: onUpdate, onUpdateParams: onUpdateParams, callbackScope: callbackScope, runBackwards: runBackwards, yoyoEase: yoyoEase, keyframes: keyframes, autoRevert: autoRevert } = vars, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, //when a stagger (or function-based duration/delay) is on a Tween instance, we create a nested timeline which means that the "targets" of that tween don't reflect the parent. This function allows us to discern when it's a nested tween and in that case, return the full targets array so that function-based values get calculated properly. Also remember that if the tween has a stagger AND keyframes, it could be multiple levels deep which is why we store the targets Array in the vars of the timeline.
    fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !$ae2aa5d5610059af$var$_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = $ae2aa5d5610059af$var$_parseEase(ease, $ae2aa5d5610059af$var$_defaults.ease);
    tween._yEase = yoyoEase ? $ae2aa5d5610059af$var$_invertEase($ae2aa5d5610059af$var$_parseEase(yoyoEase === true ? ease : yoyoEase, $ae2aa5d5610059af$var$_defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        harness = targets[0] ? $ae2aa5d5610059af$export$8b9be379d2de2a39(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = $ae2aa5d5610059af$var$_copyExcluding(vars, $ae2aa5d5610059af$var$_reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? $ae2aa5d5610059af$var$_revertConfigNoKill : $ae2aa5d5610059af$var$_startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            $ae2aa5d5610059af$var$_removeFromParent(tween._startAt = $ae2aa5d5610059af$export$208a41d6b4e37b97.set(targets, $ae2aa5d5610059af$export$dc2b19673bb53610({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && $ae2aa5d5610059af$var$_isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && ($ae2aa5d5610059af$var$_reverting || !immediateRender && !autoRevert) && tween._startAt.revert($ae2aa5d5610059af$var$_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = $ae2aa5d5610059af$export$dc2b19673bb53610({
                    overwrite: false,
                    data: "isFromStart",
                    lazy: immediateRender && !prevStartAt && $ae2aa5d5610059af$var$_isNotFalse(lazy),
                    immediateRender: immediateRender,
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                $ae2aa5d5610059af$var$_removeFromParent(tween._startAt = $ae2aa5d5610059af$export$208a41d6b4e37b97.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && ($ae2aa5d5610059af$var$_reverting ? tween._startAt.revert($ae2aa5d5610059af$var$_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) $ae2aa5d5610059af$var$_initTween(tween._startAt, $ae2aa5d5610059af$var$_tinyNum, $ae2aa5d5610059af$var$_tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && $ae2aa5d5610059af$var$_isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || $ae2aa5d5610059af$var$_harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            $ae2aa5d5610059af$var$_lazyLookup[gsData.id] && $ae2aa5d5610059af$var$_lazyTweens.length && $ae2aa5d5610059af$var$_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new $ae2aa5d5610059af$export$3a67f7f44b1e838a(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach((name)=>{
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if ($ae2aa5d5610059af$export$d305d8ec5d7c26b8[p] && (plugin = $ae2aa5d5610059af$export$5c457b74208010cf(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = $ae2aa5d5610059af$var$_addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                $ae2aa5d5610059af$var$_overwritingTween = tween;
                $ae2aa5d5610059af$var$_globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                $ae2aa5d5610059af$var$_overwritingTween = 0;
            }
            tween._pt && lazy && ($ae2aa5d5610059af$var$_lazyLookup[gsData.id] = 1);
        }
        hasPriority && $ae2aa5d5610059af$export$eed5824f53346d57(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render($ae2aa5d5610059af$var$_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, $ae2aa5d5610059af$var$_updatePropTweens = (tween, property, value, start, startIsRelative, ratio, time)=>{
    let ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)pt = pt._next;
            }
            if (!pt) {
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                $ae2aa5d5610059af$var$_forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                $ae2aa5d5610059af$var$_initTween(tween, time);
                $ae2aa5d5610059af$var$_forceAllPropTweens = 0;
                return 1;
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = $ae2aa5d5610059af$export$9c8d725d65e13f94(value) + $ae2aa5d5610059af$export$65f2564e9a9b9222(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + $ae2aa5d5610059af$export$65f2564e9a9b9222(rootPT.b)); // (beginning value)
    }
}, $ae2aa5d5610059af$var$_addAliasesToVars = (targets, vars)=>{
    let harness = targets[0] ? $ae2aa5d5610059af$export$8b9be379d2de2a39(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = $ae2aa5d5610059af$var$_merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
$ae2aa5d5610059af$var$_parseKeyframe = (prop, obj, allProps, easeEach)=>{
    let ease = obj.ease || easeEach || "power1.inOut", p, a;
    if ($ae2aa5d5610059af$var$_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []);
        // t = time (out of 100), v = value, e = ease
        obj.forEach((value, i)=>a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            }));
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, $ae2aa5d5610059af$var$_parseFuncOrString = (value, tween, i, target, targets)=>$ae2aa5d5610059af$var$_isFunction(value) ? value.call(tween, i, target, targets) : $ae2aa5d5610059af$export$f664476fd67145ca(value) && ~value.indexOf("random(") ? $ae2aa5d5610059af$export$d5962a97e3cde94d(value) : value, $ae2aa5d5610059af$var$_staggerTweenProps = $ae2aa5d5610059af$var$_callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", $ae2aa5d5610059af$var$_staggerPropsToSkip = {};
$ae2aa5d5610059af$export$f9000b814859f126($ae2aa5d5610059af$var$_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", (name)=>$ae2aa5d5610059af$var$_staggerPropsToSkip[name] = 1);
class $ae2aa5d5610059af$export$208a41d6b4e37b97 extends $ae2aa5d5610059af$export$c35d437ae5945fcd {
    constructor(targets, vars, position, skipInherit){
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        super(skipInherit ? vars : $ae2aa5d5610059af$var$_inheritDefaults(vars));
        let { duration: duration, delay: delay, immediateRender: immediateRender, stagger: stagger, overwrite: overwrite, keyframes: keyframes, defaults: defaults, scrollTrigger: scrollTrigger, yoyoEase: yoyoEase } = this.vars, parent = vars.parent || $ae2aa5d5610059af$var$_globalTimeline, parsedTargets = ($ae2aa5d5610059af$var$_isArray(targets) || $ae2aa5d5610059af$var$_isTypedArray(targets) ? $ae2aa5d5610059af$var$_isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : $ae2aa5d5610059af$export$45b10814cc054894(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        this._targets = parsedTargets.length ? $ae2aa5d5610059af$var$_harness(parsedTargets) : $ae2aa5d5610059af$var$_warn("GSAP target " + targets + " not found. https://greensock.com", !$ae2aa5d5610059af$export$4922bee768729a77.nullTargetWarn) || [];
        this._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        this._overwrite = overwrite;
        if (keyframes || stagger || $ae2aa5d5610059af$var$_isFuncOrString(duration) || $ae2aa5d5610059af$var$_isFuncOrString(delay)) {
            vars = this.vars;
            tl = this.timeline = new $ae2aa5d5610059af$export$e6a97ba2cae5bb94({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = this;
            tl._start = 0;
            if (stagger || $ae2aa5d5610059af$var$_isFuncOrString(duration) || $ae2aa5d5610059af$var$_isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && $ae2aa5d5610059af$export$f02a9ddbe4480f19(stagger);
                if ($ae2aa5d5610059af$var$_isObject(stagger)) {
                    for(p in stagger)if (~$ae2aa5d5610059af$var$_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = $ae2aa5d5610059af$var$_copyExcluding(vars, $ae2aa5d5610059af$var$_staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && $ae2aa5d5610059af$var$_merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i];
                    //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +$ae2aa5d5610059af$var$_parseFuncOrString(duration, this, i, curTarget, parsedTargets);
                    copy.delay = (+$ae2aa5d5610059af$var$_parseFuncOrString(delay, this, i, curTarget, parsedTargets) || 0) - this._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        this._delay = delay = copy.delay;
                        this._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = $ae2aa5d5610059af$var$_easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : this.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                $ae2aa5d5610059af$var$_inheritDefaults($ae2aa5d5610059af$export$dc2b19673bb53610(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = $ae2aa5d5610059af$var$_parseEase(keyframes.ease || vars.ease || "none");
                let time = 0, a, kf, v;
                if ($ae2aa5d5610059af$var$_isArray(keyframes)) {
                    keyframes.forEach((frame)=>tl.to(parsedTargets, frame, ">"));
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || $ae2aa5d5610059af$var$_parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort((a, b)=>a.t - b.t);
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || this.duration(duration = tl.duration());
        } else this.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !$ae2aa5d5610059af$var$_suppressOverwrites) {
            $ae2aa5d5610059af$var$_overwritingTween = this;
            $ae2aa5d5610059af$var$_globalTimeline.killTweensOf(parsedTargets);
            $ae2aa5d5610059af$var$_overwritingTween = 0;
        }
        $ae2aa5d5610059af$var$_addToTimeline(parent, this, position);
        vars.reversed && this.reverse();
        vars.paused && this.paused(true);
        if (immediateRender || !duration && !keyframes && this._start === $ae2aa5d5610059af$var$_roundPrecise(parent._time) && $ae2aa5d5610059af$var$_isNotFalse(immediateRender) && $ae2aa5d5610059af$var$_hasNoPausedAncestors(this) && parent.data !== "nested") {
            this._tTime = -$ae2aa5d5610059af$var$_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            this.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && $ae2aa5d5610059af$var$_scrollTrigger(this, scrollTrigger);
    }
    render(totalTime, suppressEvents, force) {
        let prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - $ae2aa5d5610059af$var$_tinyNum && !isNegative ? tDur : totalTime < $ae2aa5d5610059af$var$_tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) $ae2aa5d5610059af$var$_renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $ae2aa5d5610059af$var$_roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = $ae2aa5d5610059af$var$_animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && $ae2aa5d5610059af$var$_propagateYoyoEase(timeline, isYoyo);
                    //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render($ae2aa5d5610059af$var$_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if ($ae2aa5d5610059af$var$_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time) return this;
                if (dur !== this._dur) return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                $ae2aa5d5610059af$var$_callback(this, "onStart");
                if (this._tTime !== tTime) return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -$ae2aa5d5610059af$var$_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && $ae2aa5d5610059af$var$_rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                $ae2aa5d5610059af$var$_callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && $ae2aa5d5610059af$var$_callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && $ae2aa5d5610059af$var$_rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && $ae2aa5d5610059af$var$_removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    $ae2aa5d5610059af$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    }
    targets() {
        return this._targets;
    }
    invalidate(soft) {
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return super.invalidate(soft);
    }
    resetTo(property, value, start, startIsRelative) {
        $ae2aa5d5610059af$var$_tickerActive || $ae2aa5d5610059af$export$762ed8fbedb691e3.wake();
        this._ts || this.play();
        let time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || $ae2aa5d5610059af$var$_initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if ($ae2aa5d5610059af$var$_updatePropTweens(this, property, value, start, startIsRelative, ratio, time)) return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        //}
        $ae2aa5d5610059af$var$_alignPlayhead(this, 0);
        this.parent || $ae2aa5d5610059af$var$_addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    }
    kill(targets, vars = "all") {
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? $ae2aa5d5610059af$var$_interrupt(this) : this;
        }
        if (this.timeline) {
            let tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, $ae2aa5d5610059af$var$_overwritingTween && $ae2aa5d5610059af$var$_overwritingTween.vars.overwrite !== true)._first || $ae2aa5d5610059af$var$_interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && $ae2aa5d5610059af$var$_setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        let parsedTargets = this._targets, killingTargets = targets ? $ae2aa5d5610059af$export$45b10814cc054894(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && $ae2aa5d5610059af$var$_arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return $ae2aa5d5610059af$var$_interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            if ($ae2aa5d5610059af$export$f664476fd67145ca(vars)) {
                p = {};
                $ae2aa5d5610059af$export$f9000b814859f126(vars, (name)=>p[name] = 1);
                vars = p;
            }
            vars = $ae2aa5d5610059af$var$_addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) $ae2aa5d5610059af$export$cd008aa6cd8844e3(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && $ae2aa5d5610059af$var$_interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    }
    static to(targets, vars) {
        return new $ae2aa5d5610059af$export$208a41d6b4e37b97(targets, vars, arguments[2]);
    }
    static from(targets, vars) {
        return $ae2aa5d5610059af$var$_createTweenType(1, arguments);
    }
    static delayedCall(delay, callback, params, scope) {
        return new $ae2aa5d5610059af$export$208a41d6b4e37b97(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    }
    static fromTo(targets, fromVars, toVars) {
        return $ae2aa5d5610059af$var$_createTweenType(2, arguments);
    }
    static set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new $ae2aa5d5610059af$export$208a41d6b4e37b97(targets, vars);
    }
    static killTweensOf(targets, props, onlyActive) {
        return $ae2aa5d5610059af$var$_globalTimeline.killTweensOf(targets, props, onlyActive);
    }
}
$ae2aa5d5610059af$export$dc2b19673bb53610($ae2aa5d5610059af$export$208a41d6b4e37b97.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
});
//add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
$ae2aa5d5610059af$export$f9000b814859f126("staggerTo,staggerFrom,staggerFromTo", (name)=>{
    $ae2aa5d5610059af$export$208a41d6b4e37b97[name] = function() {
        let tl = new $ae2aa5d5610059af$export$e6a97ba2cae5bb94(), params = $ae2aa5d5610059af$var$_slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ let $ae2aa5d5610059af$var$_setterPlain = (target, property, value)=>target[property] = value, $ae2aa5d5610059af$var$_setterFunc = (target, property, value)=>target[property](value), $ae2aa5d5610059af$var$_setterFuncWithParam = (target, property, value, data)=>target[property](data.fp, value), $ae2aa5d5610059af$var$_setterAttribute = (target, property, value)=>target.setAttribute(property, value), $ae2aa5d5610059af$export$d60fbc1e0278aaf0 = (target, property)=>$ae2aa5d5610059af$var$_isFunction(target[property]) ? $ae2aa5d5610059af$var$_setterFunc : $ae2aa5d5610059af$export$a8178c063a9fd3a1(target[property]) && target.setAttribute ? $ae2aa5d5610059af$var$_setterAttribute : $ae2aa5d5610059af$var$_setterPlain, $ae2aa5d5610059af$var$_renderPlain = (ratio, data)=>data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data), $ae2aa5d5610059af$var$_renderBoolean = (ratio, data)=>data.set(data.t, data.p, !!(data.s + data.c * ratio), data), $ae2aa5d5610059af$export$c5bc8e04394ecb2 = function(ratio, data) {
    let pt = data._pt, s = "";
    if (!ratio && data.b) s = data.b;
    else if (ratio === 1 && data.e) s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, $ae2aa5d5610059af$var$_renderPropTweens = function(ratio, data) {
    let pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, $ae2aa5d5610059af$var$_addPluginModifier = function(modifier, tween, target, property) {
    let pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, $ae2aa5d5610059af$var$_killPropTweensOf = function(property) {
    let pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) $ae2aa5d5610059af$export$cd008aa6cd8844e3(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, $ae2aa5d5610059af$var$_setterWithModifier = (target, property, value, data)=>{
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, $ae2aa5d5610059af$export$eed5824f53346d57 = (parent)=>{
    let pt = parent._pt, next, pt2, first, last;
    //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
};
class $ae2aa5d5610059af$export$3a67f7f44b1e838a {
    constructor(next, target, prop, start, change, renderer, data, setter, priority){
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || $ae2aa5d5610059af$var$_renderPlain;
        this.d = data || this;
        this.set = setter || $ae2aa5d5610059af$var$_setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = $ae2aa5d5610059af$var$_setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    }
}
//Initialization tasks
$ae2aa5d5610059af$export$f9000b814859f126($ae2aa5d5610059af$var$_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", (name)=>$ae2aa5d5610059af$var$_reservedProps[name] = 1);
$ae2aa5d5610059af$var$_globals.TweenMax = $ae2aa5d5610059af$var$_globals.TweenLite = $ae2aa5d5610059af$export$208a41d6b4e37b97;
$ae2aa5d5610059af$var$_globals.TimelineLite = $ae2aa5d5610059af$var$_globals.TimelineMax = $ae2aa5d5610059af$export$e6a97ba2cae5bb94;
$ae2aa5d5610059af$var$_globalTimeline = new $ae2aa5d5610059af$export$e6a97ba2cae5bb94({
    sortChildren: false,
    defaults: $ae2aa5d5610059af$var$_defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
$ae2aa5d5610059af$export$4922bee768729a77.stringFilter = $ae2aa5d5610059af$export$7eb2e5eb5eeb96a4;
let $ae2aa5d5610059af$var$_media = [], $ae2aa5d5610059af$var$_listeners = {}, $ae2aa5d5610059af$var$_emptyArray = [], $ae2aa5d5610059af$var$_lastMediaTime = 0, $ae2aa5d5610059af$var$_contextID = 0, $ae2aa5d5610059af$var$_dispatch = (type)=>($ae2aa5d5610059af$var$_listeners[type] || $ae2aa5d5610059af$var$_emptyArray).map((f)=>f()), $ae2aa5d5610059af$var$_onMediaChange = ()=>{
    let time = Date.now(), matches = [];
    if (time - $ae2aa5d5610059af$var$_lastMediaTime > 2) {
        $ae2aa5d5610059af$var$_dispatch("matchMediaInit");
        $ae2aa5d5610059af$var$_media.forEach((c)=>{
            let queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = $ae2aa5d5610059af$var$_win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        $ae2aa5d5610059af$var$_dispatch("matchMediaRevert");
        matches.forEach((c)=>c.onMatch(c));
        $ae2aa5d5610059af$var$_lastMediaTime = time;
        $ae2aa5d5610059af$var$_dispatch("matchMedia");
    }
};
class $ae2aa5d5610059af$var$Context {
    constructor(func, scope){
        this.selector = scope && $ae2aa5d5610059af$export$aea217a45095ce11(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = $ae2aa5d5610059af$var$_contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if ($ae2aa5d5610059af$var$_isFunction(name)) {
            scope = func;
            func = name;
            name = $ae2aa5d5610059af$var$_isFunction;
        }
        let self = this, f = function() {
            let prev = $ae2aa5d5610059af$var$_context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = $ae2aa5d5610059af$export$aea217a45095ce11(scope));
            $ae2aa5d5610059af$var$_context = self;
            result = func.apply(self, arguments);
            $ae2aa5d5610059af$var$_isFunction(result) && self._r.push(result);
            $ae2aa5d5610059af$var$_context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === $ae2aa5d5610059af$var$_isFunction ? f(self) : name ? self[name] = f : f;
    }
    ignore(func) {
        let prev = $ae2aa5d5610059af$var$_context;
        $ae2aa5d5610059af$var$_context = null;
        func(this);
        $ae2aa5d5610059af$var$_context = prev;
    }
    getTweens() {
        let a = [];
        this.data.forEach((e)=>e instanceof $ae2aa5d5610059af$var$Context ? a.push(...e.getTweens()) : e instanceof $ae2aa5d5610059af$export$208a41d6b4e37b97 && !(e.parent && e.parent.data === "nested") && a.push(e));
        return a;
    }
    clear() {
        this._r.length = this.data.length = 0;
    }
    kill(revert, matchMedia) {
        if (revert) {
            let tweens = this.getTweens();
            this.data.forEach((t)=>{
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach((tween)=>tweens.splice(tweens.indexOf(tween), 1));
                }
            });
            // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map((t)=>{
                return {
                    g: t.globalTime(0),
                    t: t
                };
            }).sort((a, b)=>b.g - a.g || -Infinity).forEach((o)=>o.t.revert(revert)); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            this.data.forEach((e)=>!(e instanceof $ae2aa5d5610059af$export$208a41d6b4e37b97) && e.revert && e.revert(revert));
            this._r.forEach((f)=>f(revert, this));
            this.isReverted = true;
        } else this.data.forEach((e)=>e.kill && e.kill());
        this.clear();
        if (matchMedia) {
            let i = $ae2aa5d5610059af$var$_media.length;
            while(i--)$ae2aa5d5610059af$var$_media[i].id === this.id && $ae2aa5d5610059af$var$_media.splice(i, 1);
        }
    }
    revert(config) {
        this.kill(config || {});
    }
}
class $ae2aa5d5610059af$var$MatchMedia {
    constructor(scope){
        this.contexts = [];
        this.scope = scope;
    }
    add(conditions, func, scope) {
        $ae2aa5d5610059af$var$_isObject(conditions) || (conditions = {
            matches: conditions
        });
        let context = new $ae2aa5d5610059af$var$Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        $ae2aa5d5610059af$var$_context && !context.selector && (context.selector = $ae2aa5d5610059af$var$_context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = $ae2aa5d5610059af$var$_win.matchMedia(conditions[p]);
            if (mq) {
                $ae2aa5d5610059af$var$_media.indexOf(context) < 0 && $ae2aa5d5610059af$var$_media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener($ae2aa5d5610059af$var$_onMediaChange) : mq.addEventListener("change", $ae2aa5d5610059af$var$_onMediaChange);
            }
        }
        active && func(context);
        return this;
    }
    // refresh() {
    // 	let time = _lastMediaTime,
    // 		media = _media;
    // 	_lastMediaTime = -1;
    // 	_media = this.contexts;
    // 	_onMediaChange();
    // 	_lastMediaTime = time;
    // 	_media = media;
    // }
    revert(config) {
        this.kill(config || {});
    }
    kill(revert) {
        this.contexts.forEach((c)=>c.kill(revert, true));
    }
}
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ const $ae2aa5d5610059af$var$_gsap = {
    registerPlugin (...args) {
        args.forEach((config)=>$ae2aa5d5610059af$var$_createPlugin(config));
    },
    timeline (vars) {
        return new $ae2aa5d5610059af$export$e6a97ba2cae5bb94(vars);
    },
    getTweensOf (targets, onlyActive) {
        return $ae2aa5d5610059af$var$_globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty (target, property, unit, uncache) {
        $ae2aa5d5610059af$export$f664476fd67145ca(target) && (target = $ae2aa5d5610059af$export$45b10814cc054894(target)[0]); //in case selector text or an array is passed in
        let getter = $ae2aa5d5610059af$export$8b9be379d2de2a39(target || {}).get, format = unit ? $ae2aa5d5610059af$var$_passThrough : $ae2aa5d5610059af$var$_numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? (property, unit, uncache)=>format(($ae2aa5d5610059af$export$d305d8ec5d7c26b8[property] && $ae2aa5d5610059af$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache)) : format(($ae2aa5d5610059af$export$d305d8ec5d7c26b8[property] && $ae2aa5d5610059af$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter (target, property, unit) {
        target = $ae2aa5d5610059af$export$45b10814cc054894(target);
        if (target.length > 1) {
            let setters = target.map((t)=>$ae2aa5d5610059af$export$99ee26438460406a.quickSetter(t, property, unit)), l = setters.length;
            return (value)=>{
                let i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        let Plugin = $ae2aa5d5610059af$export$d305d8ec5d7c26b8[property], cache = $ae2aa5d5610059af$export$8b9be379d2de2a39(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, setter = Plugin ? (value)=>{
            let p = new Plugin();
            $ae2aa5d5610059af$var$_quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, $ae2aa5d5610059af$var$_quickTween, 0, [
                target
            ]);
            p.render(1, p);
            $ae2aa5d5610059af$var$_quickTween._pt && $ae2aa5d5610059af$var$_renderPropTweens(1, $ae2aa5d5610059af$var$_quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : (value)=>setter(target, p, unit ? value + unit : value, cache, 1);
    },
    quickTo (target, property, vars) {
        let tween = $ae2aa5d5610059af$export$99ee26438460406a.to(target, $ae2aa5d5610059af$var$_merge({
            [property]: "+=0.1",
            paused: true
        }, vars || {})), func = (value, start, startIsRelative)=>tween.resetTo(property, value, start, startIsRelative);
        func.tween = tween;
        return func;
    },
    isTweening (targets) {
        return $ae2aa5d5610059af$var$_globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults (value) {
        value && value.ease && (value.ease = $ae2aa5d5610059af$var$_parseEase(value.ease, $ae2aa5d5610059af$var$_defaults.ease));
        return $ae2aa5d5610059af$var$_mergeDeep($ae2aa5d5610059af$var$_defaults, value || {});
    },
    config (value) {
        return $ae2aa5d5610059af$var$_mergeDeep($ae2aa5d5610059af$export$4922bee768729a77, value || {});
    },
    registerEffect ({ name: name, effect: effect, plugins: plugins, defaults: defaults, extendTimeline: extendTimeline }) {
        (plugins || "").split(",").forEach((pluginName)=>pluginName && !$ae2aa5d5610059af$export$d305d8ec5d7c26b8[pluginName] && !$ae2aa5d5610059af$var$_globals[pluginName] && $ae2aa5d5610059af$var$_warn(name + " effect requires " + pluginName + " plugin."));
        $ae2aa5d5610059af$var$_effects[name] = (targets, vars, tl)=>effect($ae2aa5d5610059af$export$45b10814cc054894(targets), $ae2aa5d5610059af$export$dc2b19673bb53610(vars || {}, defaults), tl);
        if (extendTimeline) $ae2aa5d5610059af$export$e6a97ba2cae5bb94.prototype[name] = function(targets, vars, position) {
            return this.add($ae2aa5d5610059af$var$_effects[name](targets, $ae2aa5d5610059af$var$_isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase (name, ease) {
        $ae2aa5d5610059af$var$_easeMap[name] = $ae2aa5d5610059af$var$_parseEase(ease);
    },
    parseEase (ease, defaultEase) {
        return arguments.length ? $ae2aa5d5610059af$var$_parseEase(ease, defaultEase) : $ae2aa5d5610059af$var$_easeMap;
    },
    getById (id) {
        return $ae2aa5d5610059af$var$_globalTimeline.getById(id);
    },
    exportRoot (vars = {}, includeDelayedCalls) {
        let tl = new $ae2aa5d5610059af$export$e6a97ba2cae5bb94(vars), child, next;
        tl.smoothChildTiming = $ae2aa5d5610059af$var$_isNotFalse(vars.smoothChildTiming);
        $ae2aa5d5610059af$var$_globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = $ae2aa5d5610059af$var$_globalTimeline._time;
        child = $ae2aa5d5610059af$var$_globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof $ae2aa5d5610059af$export$208a41d6b4e37b97 && child.vars.onComplete === child._targets[0])) $ae2aa5d5610059af$var$_addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        $ae2aa5d5610059af$var$_addToTimeline($ae2aa5d5610059af$var$_globalTimeline, tl, 0);
        return tl;
    },
    context: (func, scope)=>func ? new $ae2aa5d5610059af$var$Context(func, scope) : $ae2aa5d5610059af$var$_context,
    matchMedia: (scope)=>new $ae2aa5d5610059af$var$MatchMedia(scope),
    matchMediaRefresh: ()=>$ae2aa5d5610059af$var$_media.forEach((c)=>{
            let cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || $ae2aa5d5610059af$var$_onMediaChange(),
    addEventListener (type, callback) {
        let a = $ae2aa5d5610059af$var$_listeners[type] || ($ae2aa5d5610059af$var$_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener (type, callback) {
        let a = $ae2aa5d5610059af$var$_listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: $ae2aa5d5610059af$export$4997ffc0176396a6,
        wrapYoyo: $ae2aa5d5610059af$export$cfc0b067273edc55,
        distribute: $ae2aa5d5610059af$export$f02a9ddbe4480f19,
        random: $ae2aa5d5610059af$export$4385e60b38654f68,
        snap: $ae2aa5d5610059af$export$51a0620f7a28532b,
        normalize: $ae2aa5d5610059af$export$a3295358bff77e,
        getUnit: $ae2aa5d5610059af$export$65f2564e9a9b9222,
        clamp: $ae2aa5d5610059af$export$7d15b64cf5a3a4c4,
        splitColor: $ae2aa5d5610059af$export$73d6f35be992df24,
        toArray: $ae2aa5d5610059af$export$45b10814cc054894,
        selector: $ae2aa5d5610059af$export$aea217a45095ce11,
        mapRange: $ae2aa5d5610059af$export$f65a7599bbc6b121,
        pipe: $ae2aa5d5610059af$export$a4627e546088548d,
        unitize: $ae2aa5d5610059af$export$d7502930aa5492de,
        interpolate: $ae2aa5d5610059af$export$89e29e4ab65e70a9,
        shuffle: $ae2aa5d5610059af$export$448332262467e042
    },
    install: $ae2aa5d5610059af$var$_install,
    effects: $ae2aa5d5610059af$var$_effects,
    ticker: $ae2aa5d5610059af$export$762ed8fbedb691e3,
    updateRoot: $ae2aa5d5610059af$export$e6a97ba2cae5bb94.updateRoot,
    plugins: $ae2aa5d5610059af$export$d305d8ec5d7c26b8,
    globalTimeline: $ae2aa5d5610059af$var$_globalTimeline,
    core: {
        PropTween: $ae2aa5d5610059af$export$3a67f7f44b1e838a,
        globals: $ae2aa5d5610059af$var$_addGlobal,
        Tween: $ae2aa5d5610059af$export$208a41d6b4e37b97,
        Timeline: $ae2aa5d5610059af$export$e6a97ba2cae5bb94,
        Animation: $ae2aa5d5610059af$export$c35d437ae5945fcd,
        getCache: $ae2aa5d5610059af$export$8b9be379d2de2a39,
        _removeLinkedListItem: $ae2aa5d5610059af$export$cd008aa6cd8844e3,
        reverting: ()=>$ae2aa5d5610059af$var$_reverting,
        context: (toAdd)=>{
            if (toAdd && $ae2aa5d5610059af$var$_context) {
                $ae2aa5d5610059af$var$_context.data.push(toAdd);
                toAdd._ctx = $ae2aa5d5610059af$var$_context;
            }
            return $ae2aa5d5610059af$var$_context;
        },
        suppressOverwrites: (value)=>$ae2aa5d5610059af$var$_suppressOverwrites = value
    }
};
$ae2aa5d5610059af$export$f9000b814859f126("to,from,fromTo,delayedCall,set,killTweensOf", (name)=>$ae2aa5d5610059af$var$_gsap[name] = $ae2aa5d5610059af$export$208a41d6b4e37b97[name]);
$ae2aa5d5610059af$export$762ed8fbedb691e3.add($ae2aa5d5610059af$export$e6a97ba2cae5bb94.updateRoot);
$ae2aa5d5610059af$var$_quickTween = $ae2aa5d5610059af$var$_gsap.to({}, {
    duration: 0
});
// ---- EXTRA PLUGINS --------------------------------------------------------
let $ae2aa5d5610059af$var$_getPluginPropTween = (plugin, prop)=>{
    let pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, $ae2aa5d5610059af$var$_addModifiers = (tween, modifiers)=>{
    let targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) pt = $ae2aa5d5610059af$var$_getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, $ae2aa5d5610059af$var$_buildModifierPlugin = (name, modifier)=>{
    return {
        name: name,
        rawVars: 1,
        init (target, vars, tween) {
            tween._onInit = (tween)=>{
                let temp, p;
                if ($ae2aa5d5610059af$export$f664476fd67145ca(vars)) {
                    temp = {};
                    $ae2aa5d5610059af$export$f9000b814859f126(vars, (name)=>temp[name] = 1); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                $ae2aa5d5610059af$var$_addModifiers(tween, vars);
            };
        }
    };
};
const $ae2aa5d5610059af$export$99ee26438460406a = $ae2aa5d5610059af$var$_gsap.registerPlugin({
    name: "attr",
    init (target, vars, tween, index, targets) {
        let p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render (ratio, data) {
        let pt = data._pt;
        while(pt){
            $ae2aa5d5610059af$var$_reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init (target, value) {
        let i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, $ae2aa5d5610059af$var$_buildModifierPlugin("roundProps", $ae2aa5d5610059af$export$dd12390e6b265a17), $ae2aa5d5610059af$var$_buildModifierPlugin("modifiers"), $ae2aa5d5610059af$var$_buildModifierPlugin("snap", $ae2aa5d5610059af$export$51a0620f7a28532b)) || $ae2aa5d5610059af$var$_gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
$ae2aa5d5610059af$export$208a41d6b4e37b97.version = $ae2aa5d5610059af$export$e6a97ba2cae5bb94.version = $ae2aa5d5610059af$export$99ee26438460406a.version = "3.12.2";
$ae2aa5d5610059af$var$_coreReady = 1;
$ae2aa5d5610059af$var$_windowExists() && $ae2aa5d5610059af$var$_wake();
const { Power0: $ae2aa5d5610059af$export$2fae1e8613537d5f, Power1: $ae2aa5d5610059af$export$5d84ab4efbecec39, Power2: $ae2aa5d5610059af$export$d8c694b7490ad65d, Power3: $ae2aa5d5610059af$export$acebdf2b184a0b6f, Power4: $ae2aa5d5610059af$export$42e40a141003d2f0, Linear: $ae2aa5d5610059af$export$cff00ccf6e2392de, Quad: $ae2aa5d5610059af$export$7005c9eb6671414d, Cubic: $ae2aa5d5610059af$export$755261d5a1567778, Quart: $ae2aa5d5610059af$export$daf531446cad3d2a, Quint: $ae2aa5d5610059af$export$4c407d38ce8ad8cc, Strong: $ae2aa5d5610059af$export$f301627d437cff88, Elastic: $ae2aa5d5610059af$export$56ebabebb04a9ca9, Back: $ae2aa5d5610059af$export$25e48ac541203d4a, SteppedEase: $ae2aa5d5610059af$export$f7a11c7543d81853, Bounce: $ae2aa5d5610059af$export$d20e79fdc3899e95, Sine: $ae2aa5d5610059af$export$bed2d20ad96b784c, Expo: $ae2aa5d5610059af$export$41e9d1ff1a2fb15a, Circ: $ae2aa5d5610059af$export$ce49a57dd865b86c } = $ae2aa5d5610059af$var$_easeMap;


/*!
 * CSSPlugin 3.12.2
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
let $75a9595d152532df$var$_win, $75a9595d152532df$var$_doc, $75a9595d152532df$var$_docElement, $75a9595d152532df$var$_pluginInitted, $75a9595d152532df$var$_tempDiv, $75a9595d152532df$var$_tempDivStyler, $75a9595d152532df$var$_recentSetterPlugin, $75a9595d152532df$var$_reverting, $75a9595d152532df$var$_windowExists = ()=>typeof window !== "undefined", $75a9595d152532df$var$_transformProps = {}, $75a9595d152532df$var$_RAD2DEG = 180 / Math.PI, $75a9595d152532df$var$_DEG2RAD = Math.PI / 180, $75a9595d152532df$var$_atan2 = Math.atan2, $75a9595d152532df$var$_bigNum = 1e8, $75a9595d152532df$var$_capsExp = /([A-Z])/g, $75a9595d152532df$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $75a9595d152532df$var$_complexExp = /[\s,\(]\S/, $75a9595d152532df$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $75a9595d152532df$var$_renderCSSProp = (ratio, data)=>data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data), $75a9595d152532df$var$_renderPropWithEnd = (ratio, data)=>data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data), $75a9595d152532df$var$_renderCSSPropWithBeginning = (ratio, data)=>data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data), $75a9595d152532df$var$_renderRoundedCSSProp = (ratio, data)=>{
    let value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $75a9595d152532df$var$_renderNonTweeningValue = (ratio, data)=>data.set(data.t, data.p, ratio ? data.e : data.b, data), $75a9595d152532df$var$_renderNonTweeningValueOnlyAtEnd = (ratio, data)=>data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data), $75a9595d152532df$var$_setterCSSStyle = (target, property, value)=>target.style[property] = value, $75a9595d152532df$var$_setterCSSProp = (target, property, value)=>target.style.setProperty(property, value), $75a9595d152532df$var$_setterTransform = (target, property, value)=>target._gsap[property] = value, $75a9595d152532df$var$_setterScale = (target, property, value)=>target._gsap.scaleX = target._gsap.scaleY = value, $75a9595d152532df$var$_setterScaleWithRender = (target, property, value, data, ratio)=>{
    let cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $75a9595d152532df$var$_setterTransformWithRender = (target, property, value, data, ratio)=>{
    let cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $75a9595d152532df$var$_transformProp = "transform", $75a9595d152532df$var$_transformOriginProp = $75a9595d152532df$var$_transformProp + "Origin", $75a9595d152532df$var$_saveStyle = function(property, isNotCSS) {
    let target = this.target, style = target.style;
    if (property in $75a9595d152532df$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $75a9595d152532df$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach((a)=>this.tfm[a] = $75a9595d152532df$var$_get(target, a)) : this.tfm[property] = target._gsap.x ? target._gsap[property] : $75a9595d152532df$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
        } else return $75a9595d152532df$var$_propertyAliases.transform.split(",").forEach((p)=>$75a9595d152532df$var$_saveStyle.call(this, p, isNotCSS));
        if (this.props.indexOf($75a9595d152532df$var$_transformProp) >= 0) return;
        if (target._gsap.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($75a9595d152532df$var$_transformOriginProp, isNotCSS, "");
        }
        property = $75a9595d152532df$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $75a9595d152532df$var$_removeIndependentTransforms = (style)=>{
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $75a9595d152532df$var$_revertStyle = function() {
    let props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($75a9595d152532df$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $75a9595d152532df$var$_reverting();
        if ((!i || !i.isStart) && !style[$75a9595d152532df$var$_transformProp]) {
            $75a9595d152532df$var$_removeIndependentTransforms(style);
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $75a9595d152532df$var$_getStyleSaver = (target, properties)=>{
    let saver = {
        target: target,
        props: [],
        revert: $75a9595d152532df$var$_revertStyle,
        save: $75a9595d152532df$var$_saveStyle
    };
    target._gsap || (0, $ae2aa5d5610059af$export$99ee26438460406a).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach((p)=>saver.save(p));
    return saver;
}, $75a9595d152532df$var$_supports3D, $75a9595d152532df$export$a232bb0480ae674a = (type, ns)=>{
    let e = $75a9595d152532df$var$_doc.createElementNS ? $75a9595d152532df$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $75a9595d152532df$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $75a9595d152532df$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $75a9595d152532df$var$_getComputedProperty = (target, property, skipPrefixFallback)=>{
    let cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($75a9595d152532df$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && $75a9595d152532df$var$_getComputedProperty(target, $75a9595d152532df$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $75a9595d152532df$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $75a9595d152532df$export$8cbef5dd49a09c8b = (property, element, preferPrefix)=>{
    let e = element || $75a9595d152532df$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($75a9595d152532df$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $75a9595d152532df$var$_prefixes[i] : "") + property;
}, $75a9595d152532df$var$_initCore = ()=>{
    if ($75a9595d152532df$var$_windowExists() && window.document) {
        $75a9595d152532df$var$_win = window;
        $75a9595d152532df$var$_doc = $75a9595d152532df$var$_win.document;
        $75a9595d152532df$var$_docElement = $75a9595d152532df$var$_doc.documentElement;
        $75a9595d152532df$var$_tempDiv = $75a9595d152532df$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $75a9595d152532df$var$_tempDivStyler = $75a9595d152532df$export$a232bb0480ae674a("div");
        $75a9595d152532df$var$_transformProp = $75a9595d152532df$export$8cbef5dd49a09c8b($75a9595d152532df$var$_transformProp);
        $75a9595d152532df$var$_transformOriginProp = $75a9595d152532df$var$_transformProp + "Origin";
        $75a9595d152532df$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $75a9595d152532df$var$_supports3D = !!$75a9595d152532df$export$8cbef5dd49a09c8b("perspective");
        $75a9595d152532df$var$_reverting = (0, $ae2aa5d5610059af$export$99ee26438460406a).core.reverting;
        $75a9595d152532df$var$_pluginInitted = 1;
    }
}, $75a9595d152532df$var$_getBBoxHack = function(swapIfPossible) {
    let svg = $75a9595d152532df$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $75a9595d152532df$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = $75a9595d152532df$var$_getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $75a9595d152532df$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $75a9595d152532df$var$_getAttributeFallbacks = (target, attributesArray)=>{
    let i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $75a9595d152532df$export$41bc7c2d1e04f11b = (target)=>{
    let bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $75a9595d152532df$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $75a9595d152532df$var$_getBBoxHack || (bounds = $75a9595d152532df$var$_getBBoxHack.call(target, true));
    //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$75a9595d152532df$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$75a9595d152532df$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $75a9595d152532df$var$_isSVG = (e)=>!!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $75a9595d152532df$export$41bc7c2d1e04f11b(e)), $75a9595d152532df$var$_removeProperty = (target, property)=>{
    if (property) {
        let style = target.style;
        if (property in $75a9595d152532df$var$_transformProps && property !== $75a9595d152532df$var$_transformOriginProp) property = $75a9595d152532df$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") property = "-" + property;
            style.removeProperty(property.replace($75a9595d152532df$var$_capsExp, "-$1").toLowerCase());
        } else style.removeAttribute(property);
    }
}, $75a9595d152532df$var$_addNonTweeningPT = (plugin, target, property, beginning, end, onlySetAtEnd)=>{
    let pt = new (0, $ae2aa5d5610059af$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $75a9595d152532df$var$_renderNonTweeningValueOnlyAtEnd : $75a9595d152532df$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $75a9595d152532df$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $75a9595d152532df$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$75a9595d152532df$var$_convertToUnit = (target, property, value, unit)=>{
    let curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", style = $75a9595d152532df$var$_tempDiv.style, horizontal = $75a9595d152532df$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $75a9595d152532df$var$_nonConvertibleUnits[unit] || $75a9595d152532df$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = $75a9595d152532df$var$_convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $75a9595d152532df$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($75a9595d152532df$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $75a9595d152532df$var$_doc || !parent.appendChild) parent = $75a9595d152532df$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $ae2aa5d5610059af$export$762ed8fbedb691e3).time && !cache.uncache) return (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && !$75a9595d152532df$var$_nonStandardLayouts[$75a9595d152532df$var$_getComputedProperty(parent, "display")] && (style.position = $75a9595d152532df$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($75a9595d152532df$var$_tempDiv);
        px = $75a9595d152532df$var$_tempDiv[measureProperty];
        parent.removeChild($75a9595d152532df$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $ae2aa5d5610059af$export$8b9be379d2de2a39)(parent);
            cache.time = (0, $ae2aa5d5610059af$export$762ed8fbedb691e3).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $75a9595d152532df$var$_get = (target, property, unit, uncache)=>{
    let value;
    $75a9595d152532df$var$_pluginInitted || $75a9595d152532df$var$_initCore();
    if (property in $75a9595d152532df$var$_propertyAliases && property !== "transform") {
        property = $75a9595d152532df$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($75a9595d152532df$var$_transformProps[property] && property !== "transform") {
        value = $75a9595d152532df$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $75a9595d152532df$var$_firstTwoOnly($75a9595d152532df$var$_getComputedProperty(target, $75a9595d152532df$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $75a9595d152532df$var$_specialProps[property] && $75a9595d152532df$var$_specialProps[property](target, property, unit) || $75a9595d152532df$var$_getComputedProperty(target, property) || (0, $ae2aa5d5610059af$export$51d6bbe898aef1f9)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $75a9595d152532df$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $75a9595d152532df$var$_tweenComplexCSSString = function(target, prop, start, end) {
    if (!start || start === "none") {
        let p = $75a9595d152532df$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $75a9595d152532df$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $75a9595d152532df$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    let pt = new (0, $ae2aa5d5610059af$export$3a67f7f44b1e838a)(this._pt, target.style, prop, 0, 1, (0, $ae2aa5d5610059af$export$c5bc8e04394ecb2)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $75a9595d152532df$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $ae2aa5d5610059af$export$7eb2e5eb5eeb96a4)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $ae2aa5d5610059af$export$65c88bbd597e7b0a)) || [];
    endValues = end.match((0, $ae2aa5d5610059af$export$65c88bbd597e7b0a)) || [];
    if (endValues.length) {
        while(result = (0, $ae2aa5d5610059af$export$65c88bbd597e7b0a).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $ae2aa5d5610059af$export$dac762bc6301b560)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $ae2aa5d5610059af$export$65c88bbd597e7b0a).lastIndex - endUnit.length;
                if (!endUnit) {
                    endUnit = endUnit || (0, $ae2aa5d5610059af$export$4922bee768729a77).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $75a9595d152532df$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $75a9595d152532df$var$_renderNonTweeningValueOnlyAtEnd : $75a9595d152532df$var$_renderNonTweeningValue;
    (0, $ae2aa5d5610059af$export$5a680e28b0b61bc).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $75a9595d152532df$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $75a9595d152532df$var$_convertKeywordsToPercentages = (value)=>{
    let split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        value = x;
        x = y;
        y = value;
    }
    split[0] = $75a9595d152532df$var$_keywordToPercent[x] || x;
    split[1] = $75a9595d152532df$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $75a9595d152532df$var$_renderClearProps = (ratio, data)=>{
    if (data.tween && data.tween._time === data.tween._dur) {
        let target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($75a9595d152532df$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $75a9595d152532df$var$_transformOriginProp : $75a9595d152532df$var$_transformProp;
                }
                $75a9595d152532df$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $75a9595d152532df$var$_removeProperty(target, $75a9595d152532df$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $75a9595d152532df$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $75a9595d152532df$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$75a9595d152532df$var$_specialProps = {
    clearProps (plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            let pt = plugin._pt = new (0, $ae2aa5d5610059af$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 0, $75a9595d152532df$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
	 * --------------------------------------------------------------------------------------
	 * TRANSFORMS
	 * --------------------------------------------------------------------------------------
	 */ $75a9595d152532df$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $75a9595d152532df$var$_rotationalProperties = {}, $75a9595d152532df$var$_isNullTransform = (value)=>value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value, $75a9595d152532df$var$_getComputedTransformMatrixAsArray = (target)=>{
    let matrixString = $75a9595d152532df$var$_getComputedProperty(target, $75a9595d152532df$var$_transformProp);
    return $75a9595d152532df$var$_isNullTransform(matrixString) ? $75a9595d152532df$var$_identity2DMatrix : matrixString.substr(7).match((0, $ae2aa5d5610059af$export$b9d44bb6523120d6)).map((0, $ae2aa5d5610059af$export$9c8d725d65e13f94));
}, $75a9595d152532df$var$_getMatrix = (target, force2D)=>{
    let cache = target._gsap || (0, $ae2aa5d5610059af$export$8b9be379d2de2a39)(target), style = target.style, matrix = $75a9595d152532df$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $75a9595d152532df$var$_identity2DMatrix : matrix;
    } else if (matrix === $75a9595d152532df$var$_identity2DMatrix && !target.offsetParent && target !== $75a9595d152532df$var$_docElement && !cache.svg) {
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $75a9595d152532df$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $75a9595d152532df$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $75a9595d152532df$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $75a9595d152532df$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $75a9595d152532df$var$_applySVGOrigin = (target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo)=>{
    let cache = target._gsap, matrix = matrixArray || $75a9595d152532df$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $75a9595d152532df$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $75a9595d152532df$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$75a9595d152532df$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $75a9595d152532df$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $75a9595d152532df$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $75a9595d152532df$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $75a9595d152532df$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $75a9595d152532df$var$_parseTransform = (target, uncache)=>{
    let cache = target._gsap || new (0, $ae2aa5d5610059af$export$cf10981d5419cad5)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    let style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $75a9595d152532df$var$_getComputedProperty(target, $75a9595d152532df$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $75a9595d152532df$var$_isSVG(target));
    if (cs.translate) {
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$75a9595d152532df$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$75a9595d152532df$var$_transformProp] !== "none" ? cs[$75a9595d152532df$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $75a9595d152532df$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $75a9595d152532df$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $75a9595d152532df$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5];
        //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $75a9595d152532df$var$_atan2(b, a) * $75a9595d152532df$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $75a9595d152532df$var$_atan2(c, d) * $75a9595d152532df$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $75a9595d152532df$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            }
        //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $75a9595d152532df$var$_atan2(a32, a33);
            rotationX = angle * $75a9595d152532df$var$_RAD2DEG;
            //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            }
            //rotationY
            angle = $75a9595d152532df$var$_atan2(-c, a33);
            rotationY = angle * $75a9595d152532df$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            }
            //rotationZ
            angle = $75a9595d152532df$var$_atan2(b, a);
            rotation = angle * $75a9595d152532df$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $75a9595d152532df$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $75a9595d152532df$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$75a9595d152532df$var$_isNullTransform($75a9595d152532df$var$_getComputedProperty(target, $75a9595d152532df$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(scaleX);
    cache.scaleY = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(scaleY);
    cache.rotation = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(rotation) + deg;
    cache.rotationX = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(rotationX) + deg;
    cache.rotationY = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$75a9595d152532df$var$_transformOriginProp] = $75a9595d152532df$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $ae2aa5d5610059af$export$4922bee768729a77).force3D;
    cache.renderTransform = cache.svg ? $75a9595d152532df$var$_renderSVGTransforms : $75a9595d152532df$var$_supports3D ? $75a9595d152532df$var$_renderCSSTransforms : $75a9595d152532df$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $75a9595d152532df$var$_firstTwoOnly = (value)=>(value = value.split(" "))[0] + " " + value[1], $75a9595d152532df$var$_addPxTranslate = (target, start, value)=>{
    let unit = (0, $ae2aa5d5610059af$export$65f2564e9a9b9222)(start);
    return (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(parseFloat(start) + parseFloat($75a9595d152532df$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $75a9595d152532df$var$_renderNon3DTransforms = (ratio, cache)=>{
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $75a9595d152532df$var$_renderCSSTransforms(ratio, cache);
}, $75a9595d152532df$var$_zeroDeg = "0deg", $75a9595d152532df$var$_zeroPx = "0px", $75a9595d152532df$var$_endParenthesis = ") ", $75a9595d152532df$var$_renderCSSTransforms = function(ratio, cache) {
    let { xPercent: xPercent, yPercent: yPercent, x: x, y: y, z: z, rotation: rotation, rotationY: rotationY, rotationX: rotationX, skewX: skewX, skewY: skewY, scaleX: scaleX, scaleY: scaleY, transformPerspective: transformPerspective, force3D: force3D, target: target, zOrigin: zOrigin } = cache || this, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true;
    // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $75a9595d152532df$var$_zeroDeg || rotationY !== $75a9595d152532df$var$_zeroDeg)) {
        let angle = parseFloat(rotationY) * $75a9595d152532df$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $75a9595d152532df$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $75a9595d152532df$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $75a9595d152532df$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $75a9595d152532df$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $75a9595d152532df$var$_zeroPx) transforms += "perspective(" + transformPerspective + $75a9595d152532df$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $75a9595d152532df$var$_zeroPx || y !== $75a9595d152532df$var$_zeroPx || z !== $75a9595d152532df$var$_zeroPx) transforms += z !== $75a9595d152532df$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $75a9595d152532df$var$_endParenthesis;
    if (rotation !== $75a9595d152532df$var$_zeroDeg) transforms += "rotate(" + rotation + $75a9595d152532df$var$_endParenthesis;
    if (rotationY !== $75a9595d152532df$var$_zeroDeg) transforms += "rotateY(" + rotationY + $75a9595d152532df$var$_endParenthesis;
    if (rotationX !== $75a9595d152532df$var$_zeroDeg) transforms += "rotateX(" + rotationX + $75a9595d152532df$var$_endParenthesis;
    if (skewX !== $75a9595d152532df$var$_zeroDeg || skewY !== $75a9595d152532df$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $75a9595d152532df$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $75a9595d152532df$var$_endParenthesis;
    target.style[$75a9595d152532df$var$_transformProp] = transforms || "translate(0, 0)";
}, $75a9595d152532df$var$_renderSVGTransforms = function(ratio, cache) {
    let { xPercent: xPercent, yPercent: yPercent, x: x, y: y, rotation: rotation, skewX: skewX, skewY: skewY, scaleX: scaleX, scaleY: scaleY, target: target, xOrigin: xOrigin, yOrigin: yOrigin, xOffset: xOffset, yOffset: yOffset, forceCSS: forceCSS } = cache || this, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $75a9595d152532df$var$_DEG2RAD;
        skewX *= $75a9595d152532df$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $75a9595d152532df$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(a11);
        a21 = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(a21);
        a12 = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(a12);
        a22 = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $75a9595d152532df$var$_convertToUnit(target, "x", x, "px");
        ty = $75a9595d152532df$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(tx + xPercent / 100 * temp.width);
        ty = (0, $ae2aa5d5610059af$export$9c8d725d65e13f94)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$75a9595d152532df$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $75a9595d152532df$var$_addRotationalPropTween = function(plugin, target, property, startNum, endValue) {
    let cap = 360, isString = (0, $ae2aa5d5610059af$export$f664476fd67145ca)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $75a9595d152532df$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $75a9595d152532df$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $75a9595d152532df$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $ae2aa5d5610059af$export$3a67f7f44b1e838a)(plugin._pt, target, property, startNum, change, $75a9595d152532df$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $75a9595d152532df$var$_assign = (target, source)=>{
    for(let p in source)target[p] = source[p];
    return target;
}, $75a9595d152532df$var$_addRawTransformPTs = (plugin, transforms, target)=>{
    let startCache = $75a9595d152532df$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$75a9595d152532df$var$_transformProp] = transforms;
        endCache = $75a9595d152532df$var$_parseTransform(target, 1);
        $75a9595d152532df$var$_removeProperty(target, $75a9595d152532df$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$75a9595d152532df$var$_transformProp];
        style[$75a9595d152532df$var$_transformProp] = transforms;
        endCache = $75a9595d152532df$var$_parseTransform(target, 1);
        style[$75a9595d152532df$var$_transformProp] = startValue;
    }
    for(p in $75a9595d152532df$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            startUnit = (0, $ae2aa5d5610059af$export$65f2564e9a9b9222)(startValue);
            endUnit = (0, $ae2aa5d5610059af$export$65f2564e9a9b9222)(endValue);
            startNum = startUnit !== endUnit ? $75a9595d152532df$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $ae2aa5d5610059af$export$3a67f7f44b1e838a)(plugin._pt, endCache, p, startNum, endNum - startNum, $75a9595d152532df$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $75a9595d152532df$var$_assign(endCache, startCache);
};
// handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $ae2aa5d5610059af$export$f9000b814859f126)("padding,margin,Width,Radius", (name, index)=>{
    let t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map((side)=>index < 2 ? name + side : "border" + side + name);
    $75a9595d152532df$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        let a, vars;
        if (arguments.length < 4) {
            a = props.map((prop)=>$75a9595d152532df$var$_get(plugin, prop, property));
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach((prop, i)=>vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0]);
        plugin.init(target, vars, tween);
    };
});
const $75a9595d152532df$export$855822f522f18eef = {
    name: "css",
    register: $75a9595d152532df$var$_initCore,
    targetTest (target) {
        return target.style && target.nodeType;
    },
    init (target, vars, tween, index, targets) {
        let props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $75a9595d152532df$var$_pluginInitted || $75a9595d152532df$var$_initCore();
        // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $75a9595d152532df$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $ae2aa5d5610059af$export$d305d8ec5d7c26b8)[p] && (0, $ae2aa5d5610059af$export$5c457b74208010cf)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $75a9595d152532df$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $ae2aa5d5610059af$export$d5962a97e3cde94d)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $ae2aa5d5610059af$export$dd733e62515be2bd).lastIndex = 0;
                if (!(0, $ae2aa5d5610059af$export$dd733e62515be2bd).test(startValue)) {
                    startUnit = (0, $ae2aa5d5610059af$export$65f2564e9a9b9222)(startValue);
                    endUnit = (0, $ae2aa5d5610059af$export$65f2564e9a9b9222)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $75a9595d152532df$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $ae2aa5d5610059af$export$f664476fd67145ca)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $ae2aa5d5610059af$export$d5962a97e3cde94d)(startValue));
                    (0, $ae2aa5d5610059af$export$65f2564e9a9b9222)(startValue + "") || (startValue += (0, $ae2aa5d5610059af$export$4922bee768729a77).units[p] || (0, $ae2aa5d5610059af$export$65f2564e9a9b9222)($75a9595d152532df$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $75a9595d152532df$var$_get(target, p)); // can't work with relative values
                } else startValue = $75a9595d152532df$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $75a9595d152532df$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        if (startNum === 1 && $75a9595d152532df$var$_get(target, "visibility") === "hidden" && endNum) startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $75a9595d152532df$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $75a9595d152532df$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $75a9595d152532df$var$_transformProps;
                //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $75a9595d152532df$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $ae2aa5d5610059af$export$3a67f7f44b1e838a)(this._pt, style, $75a9595d152532df$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $ae2aa5d5610059af$export$3a67f7f44b1e838a)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $ae2aa5d5610059af$export$dac762bc6301b560)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $75a9595d152532df$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($75a9595d152532df$var$_transformOriginProp, 0, style[$75a9595d152532df$var$_transformOriginProp]);
                        endValue = $75a9595d152532df$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $75a9595d152532df$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $75a9595d152532df$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $75a9595d152532df$var$_addNonTweeningPT(this, style, p, $75a9595d152532df$var$_firstTwoOnly(startValue), $75a9595d152532df$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $75a9595d152532df$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $75a9595d152532df$var$_rotationalProperties) {
                        $75a9595d152532df$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $ae2aa5d5610059af$export$dac762bc6301b560)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $75a9595d152532df$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $75a9595d152532df$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $75a9595d152532df$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$75a9595d152532df$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $ae2aa5d5610059af$export$65f2564e9a9b9222)(endValue) || (p in (0, $ae2aa5d5610059af$export$4922bee768729a77).units ? (0, $ae2aa5d5610059af$export$4922bee768729a77).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $75a9595d152532df$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $ae2aa5d5610059af$export$3a67f7f44b1e838a)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $ae2aa5d5610059af$export$dac762bc6301b560)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $75a9595d152532df$var$_renderRoundedCSSProp : $75a9595d152532df$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        this._pt.b = startValue;
                        this._pt.r = $75a9595d152532df$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $ae2aa5d5610059af$export$7fb54635790b59a5)(p, endValue);
                        continue;
                    }
                } else $75a9595d152532df$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $ae2aa5d5610059af$export$eed5824f53346d57)(this);
    },
    render (ratio, data) {
        if (data.tween._time || !$75a9595d152532df$var$_reverting()) {
            let pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $75a9595d152532df$var$_get,
    aliases: $75a9595d152532df$var$_propertyAliases,
    getSetter (target, property, plugin) {
        let p = $75a9595d152532df$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $75a9595d152532df$var$_transformProps && property !== $75a9595d152532df$var$_transformOriginProp && (target._gsap.x || $75a9595d152532df$var$_get(target, "x")) ? plugin && $75a9595d152532df$var$_recentSetterPlugin === plugin ? property === "scale" ? $75a9595d152532df$var$_setterScale : $75a9595d152532df$var$_setterTransform : ($75a9595d152532df$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $75a9595d152532df$var$_setterScaleWithRender : $75a9595d152532df$var$_setterTransformWithRender) : target.style && !(0, $ae2aa5d5610059af$export$a8178c063a9fd3a1)(target.style[property]) ? $75a9595d152532df$var$_setterCSSStyle : ~property.indexOf("-") ? $75a9595d152532df$var$_setterCSSProp : (0, $ae2aa5d5610059af$export$d60fbc1e0278aaf0)(target, property);
    },
    core: {
        _removeProperty: $75a9595d152532df$var$_removeProperty,
        _getMatrix: $75a9595d152532df$var$_getMatrix
    }
};
(0, $ae2aa5d5610059af$export$99ee26438460406a).utils.checkPrefix = $75a9595d152532df$export$8cbef5dd49a09c8b;
(0, $ae2aa5d5610059af$export$99ee26438460406a).core.getStyleSaver = $75a9595d152532df$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    let all = (0, $ae2aa5d5610059af$export$f9000b814859f126)(positionAndScale + "," + rotation + "," + others, (name)=>{
        $75a9595d152532df$var$_transformProps[name] = 1;
    });
    (0, $ae2aa5d5610059af$export$f9000b814859f126)(rotation, (name)=>{
        (0, $ae2aa5d5610059af$export$4922bee768729a77).units[name] = "deg";
        $75a9595d152532df$var$_rotationalProperties[name] = 1;
    });
    $75a9595d152532df$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $ae2aa5d5610059af$export$f9000b814859f126)(aliases, (name)=>{
        let split = name.split(":");
        $75a9595d152532df$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $ae2aa5d5610059af$export$f9000b814859f126)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", (name)=>{
    (0, $ae2aa5d5610059af$export$4922bee768729a77).units[name] = "px";
});
(0, $ae2aa5d5610059af$export$99ee26438460406a).registerPlugin($75a9595d152532df$export$855822f522f18eef);


const $903863a8986407e7$export$99ee26438460406a = (0, $ae2aa5d5610059af$export$99ee26438460406a).registerPlugin((0, $75a9595d152532df$export$855822f522f18eef)) || (0, $ae2aa5d5610059af$export$99ee26438460406a), $903863a8986407e7$export$7b23975ad686bf91 = $903863a8986407e7$export$99ee26438460406a.core.Tween;


/*!
 * CustomEase 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ /*!
 * paths 3.12.2
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ let $5c95287ca4d9d8c9$var$_svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $5c95287ca4d9d8c9$var$_numbersExp = /(?:(-)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $5c95287ca4d9d8c9$var$_scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig, $5c95287ca4d9d8c9$var$_selectorExp = /(^[#\.][a-z]|[a-y][a-z])/i, $5c95287ca4d9d8c9$var$_DEG2RAD = Math.PI / 180, $5c95287ca4d9d8c9$var$_RAD2DEG = 180 / Math.PI, $5c95287ca4d9d8c9$var$_sin = Math.sin, $5c95287ca4d9d8c9$var$_cos = Math.cos, $5c95287ca4d9d8c9$var$_abs = Math.abs, $5c95287ca4d9d8c9$var$_sqrt = Math.sqrt, $5c95287ca4d9d8c9$var$_atan2 = Math.atan2, $5c95287ca4d9d8c9$var$_largeNum = 1e8, $5c95287ca4d9d8c9$var$_isString = (value)=>typeof value === "string", $5c95287ca4d9d8c9$var$_isNumber = (value)=>typeof value === "number", $5c95287ca4d9d8c9$var$_isUndefined = (value)=>typeof value === "undefined", $5c95287ca4d9d8c9$var$_temp = {}, $5c95287ca4d9d8c9$var$_temp2 = {}, $5c95287ca4d9d8c9$var$_roundingNum = 1e5, $5c95287ca4d9d8c9$var$_wrapProgress = (progress)=>Math.round((progress + $5c95287ca4d9d8c9$var$_largeNum) % 1 * $5c95287ca4d9d8c9$var$_roundingNum) / $5c95287ca4d9d8c9$var$_roundingNum || (progress < 0 ? 0 : 1), $5c95287ca4d9d8c9$var$_round = (value)=>Math.round(value * $5c95287ca4d9d8c9$var$_roundingNum) / $5c95287ca4d9d8c9$var$_roundingNum || 0, $5c95287ca4d9d8c9$var$_roundPrecise = (value)=>Math.round(value * 1e10) / 1e10 || 0, $5c95287ca4d9d8c9$var$_splitSegment = (rawPath, segIndex, i, t)=>{
    let segment = rawPath[segIndex], shift = t === 1 ? 6 : $5c95287ca4d9d8c9$export$bd9f14de8998b2c6(segment, i, t);
    if (shift && shift + i + 2 < segment.length) {
        rawPath.splice(segIndex, 0, segment.slice(0, i + shift + 2));
        segment.splice(0, i + shift);
        return 1;
    }
}, $5c95287ca4d9d8c9$var$_getSampleIndex = (samples, length, progress)=>{
    // slightly slower way than doing this (when there's no lookup): segment.lookup[progress < 1 ? ~~(length / segment.minLength) : segment.lookup.length - 1] || 0;
    let l = samples.length, i = ~~(progress * l);
    if (samples[i] > length) {
        while(--i && samples[i] > length);
        i < 0 && (i = 0);
    } else {
        while(samples[++i] < length && i < l);
    }
    return i < l ? i : l - 1;
}, $5c95287ca4d9d8c9$var$_reverseRawPath = (rawPath, skipOuter)=>{
    let i = rawPath.length;
    skipOuter || rawPath.reverse();
    while(i--)rawPath[i].reversed || $5c95287ca4d9d8c9$export$1c1e155a66a9b65a(rawPath[i]);
}, $5c95287ca4d9d8c9$var$_copyMetaData = (source, copy)=>{
    copy.totalLength = source.totalLength;
    if (source.samples) {
        copy.samples = source.samples.slice(0);
        copy.lookup = source.lookup.slice(0);
        copy.minLength = source.minLength;
        copy.resolution = source.resolution;
    } else if (source.totalPoints) copy.totalPoints = source.totalPoints;
    return copy;
}, //pushes a new segment into a rawPath, but if its starting values match the ending values of the last segment, it'll merge it into that same segment (to reduce the number of segments)
$5c95287ca4d9d8c9$var$_appendOrMerge = (rawPath, segment)=>{
    let index = rawPath.length, prevSeg = rawPath[index - 1] || [], l = prevSeg.length;
    if (index && segment[0] === prevSeg[l - 2] && segment[1] === prevSeg[l - 1]) {
        segment = prevSeg.concat(segment.slice(2));
        index--;
    }
    rawPath[index] = segment;
}, $5c95287ca4d9d8c9$var$_bestDistance;
function $5c95287ca4d9d8c9$export$a7de45090ab95fc7(value) {
    value = $5c95287ca4d9d8c9$var$_isString(value) && $5c95287ca4d9d8c9$var$_selectorExp.test(value) ? document.querySelector(value) || value : value;
    let e = value.getAttribute ? value : 0, rawPath;
    if (e && (value = value.getAttribute("d"))) {
        //implements caching
        if (!e._gsPath) e._gsPath = {};
        rawPath = e._gsPath[value];
        return rawPath && !rawPath._dirty ? rawPath : e._gsPath[value] = $5c95287ca4d9d8c9$export$a9a6ab89eb1c2191(value);
    }
    return !value ? console.warn("Expecting a <path> element or an SVG path data string") : $5c95287ca4d9d8c9$var$_isString(value) ? $5c95287ca4d9d8c9$export$a9a6ab89eb1c2191(value) : $5c95287ca4d9d8c9$var$_isNumber(value[0]) ? [
        value
    ] : value;
}
function $5c95287ca4d9d8c9$export$e358367bf79edde2(rawPath) {
    let a = [], i = 0;
    for(; i < rawPath.length; i++)a[i] = $5c95287ca4d9d8c9$var$_copyMetaData(rawPath[i], rawPath[i].slice(0));
    return $5c95287ca4d9d8c9$var$_copyMetaData(rawPath, a);
}
function $5c95287ca4d9d8c9$export$1c1e155a66a9b65a(segment) {
    let i = 0, y;
    segment.reverse(); //this will invert the order y, x, y, x so we must flip it back.
    for(; i < segment.length; i += 2){
        y = segment[i];
        segment[i] = segment[i + 1];
        segment[i + 1] = y;
    }
    segment.reversed = !segment.reversed;
}
let $5c95287ca4d9d8c9$var$_createPath = (e, ignore)=>{
    let path = document.createElementNS("http://www.w3.org/2000/svg", "path"), attr = [].slice.call(e.attributes), i = attr.length, name;
    ignore = "," + ignore + ",";
    while(--i > -1){
        name = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.
        if (ignore.indexOf("," + name + ",") < 0) path.setAttributeNS(null, name, attr[i].nodeValue);
    }
    return path;
}, $5c95287ca4d9d8c9$var$_typeAttrs = {
    rect: "rx,ry,x,y,width,height",
    circle: "r,cx,cy",
    ellipse: "rx,ry,cx,cy",
    line: "x1,x2,y1,y2"
}, $5c95287ca4d9d8c9$var$_attrToObj = (e, attrs)=>{
    let props = attrs ? attrs.split(",") : [], obj = {}, i = props.length;
    while(--i > -1)obj[props[i]] = +e.getAttribute(props[i]) || 0;
    return obj;
};
function $5c95287ca4d9d8c9$export$1a6b6149d6272140(element, swap) {
    let type = element.tagName.toLowerCase(), circ = 0.552284749831, data, x, y, r, ry, path, rcirc, rycirc, points, w, h, x2, x3, x4, x5, x6, y2, y3, y4, y5, y6, attr;
    if (type === "path" || !element.getBBox) return element;
    path = $5c95287ca4d9d8c9$var$_createPath(element, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
    attr = $5c95287ca4d9d8c9$var$_attrToObj(element, $5c95287ca4d9d8c9$var$_typeAttrs[type]);
    if (type === "rect") {
        r = attr.rx;
        ry = attr.ry || r;
        x = attr.x;
        y = attr.y;
        w = attr.width - r * 2;
        h = attr.height - ry * 2;
        if (r || ry) {
            x2 = x + r * (1 - circ);
            x3 = x + r;
            x4 = x3 + w;
            x5 = x4 + r * circ;
            x6 = x4 + r;
            y2 = y + ry * (1 - circ);
            y3 = y + ry;
            y4 = y3 + h;
            y5 = y4 + ry * circ;
            y6 = y4 + ry;
            data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [
                x6,
                y5,
                x5,
                y6,
                x4,
                y6,
                x4 - (x4 - x3) / 3,
                y6,
                x3 + (x4 - x3) / 3,
                y6,
                x3,
                y6,
                x2,
                y6,
                x,
                y5,
                x,
                y4,
                x,
                y4 - (y4 - y3) / 3,
                x,
                y3 + (y4 - y3) / 3,
                x,
                y3,
                x,
                y2,
                x2,
                y,
                x3,
                y,
                x3 + (x4 - x3) / 3,
                y,
                x4 - (x4 - x3) / 3,
                y,
                x4,
                y,
                x5,
                y,
                x6,
                y2,
                x6,
                y3
            ].join(",") + "z";
        } else data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
    } else if (type === "circle" || type === "ellipse") {
        if (type === "circle") {
            r = ry = attr.r;
            rycirc = r * circ;
        } else {
            r = attr.rx;
            ry = attr.ry;
            rycirc = ry * circ;
        }
        x = attr.cx;
        y = attr.cy;
        rcirc = r * circ;
        data = "M" + (x + r) + "," + y + " C" + [
            x + r,
            y + rycirc,
            x + rcirc,
            y + ry,
            x,
            y + ry,
            x - rcirc,
            y + ry,
            x - r,
            y + rycirc,
            x - r,
            y,
            x - r,
            y - rycirc,
            x - rcirc,
            y - ry,
            x,
            y - ry,
            x + rcirc,
            y - ry,
            x + r,
            y - rycirc,
            x + r,
            y
        ].join(",") + "z";
    } else if (type === "line") data = "M" + attr.x1 + "," + attr.y1 + " L" + attr.x2 + "," + attr.y2; //previously, we just converted to "Mx,y Lx,y" but Safari has bugs that cause that not to render properly when using a stroke-dasharray that's not fully visible! Using a cubic bezier fixes that issue.
    else if (type === "polyline" || type === "polygon") {
        points = (element.getAttribute("points") + "").match($5c95287ca4d9d8c9$var$_numbersExp) || [];
        x = points.shift();
        y = points.shift();
        data = "M" + x + "," + y + " L" + points.join(",");
        if (type === "polygon") data += "," + x + "," + y + "z";
    }
    path.setAttribute("d", $5c95287ca4d9d8c9$export$ced9e1d9be30c397(path._gsRawPath = $5c95287ca4d9d8c9$export$a9a6ab89eb1c2191(data)));
    if (swap && element.parentNode) {
        element.parentNode.insertBefore(path, element);
        element.parentNode.removeChild(element);
    }
    return path;
}
function $5c95287ca4d9d8c9$export$d03e55696b4d7894(rawPath, progress) {
    let d = $5c95287ca4d9d8c9$var$getProgressData(rawPath, progress >= 1 ? 1 - 1e-9 : progress ? progress : 1e-9);
    return $5c95287ca4d9d8c9$var$getRotationAtBezierT(d.segment, d.i, d.t);
}
function $5c95287ca4d9d8c9$var$getRotationAtBezierT(segment, i, t) {
    let a = segment[i], b = segment[i + 2], c = segment[i + 4], x;
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    x = b + (c + (segment[i + 6] - c) * t - b) * t - a;
    a = segment[i + 1];
    b = segment[i + 3];
    c = segment[i + 5];
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    return $5c95287ca4d9d8c9$var$_round($5c95287ca4d9d8c9$var$_atan2(b + (c + (segment[i + 7] - c) * t - b) * t - a, x) * $5c95287ca4d9d8c9$var$_RAD2DEG);
}
function $5c95287ca4d9d8c9$export$510a529ffd67482a(rawPath, start, end) {
    end = $5c95287ca4d9d8c9$var$_isUndefined(end) ? 1 : $5c95287ca4d9d8c9$var$_roundPrecise(end) || 0; // we must round to avoid issues like 4.15 / 8 = 0.8300000000000001 instead of 0.83 or 2.8 / 5 = 0.5599999999999999 instead of 0.56 and if someone is doing a loop like start: 2.8 / 0.5, end: 2.8 / 0.5 + 1.
    start = $5c95287ca4d9d8c9$var$_roundPrecise(start) || 0;
    let loops = Math.max(0, ~~($5c95287ca4d9d8c9$var$_abs(end - start) - 1e-8)), path = $5c95287ca4d9d8c9$export$e358367bf79edde2(rawPath);
    if (start > end) {
        start = 1 - start;
        end = 1 - end;
        $5c95287ca4d9d8c9$var$_reverseRawPath(path);
        path.totalLength = 0;
    }
    if (start < 0 || end < 0) {
        let offset = Math.abs(~~Math.min(start, end)) + 1;
        start += offset;
        end += offset;
    }
    path.totalLength || $5c95287ca4d9d8c9$export$cd44c6d3aa5b1098(path);
    let wrap = end > 1, s = $5c95287ca4d9d8c9$var$getProgressData(path, start, $5c95287ca4d9d8c9$var$_temp, true), e = $5c95287ca4d9d8c9$var$getProgressData(path, end, $5c95287ca4d9d8c9$var$_temp2), eSeg = e.segment, sSeg = s.segment, eSegIndex = e.segIndex, sSegIndex = s.segIndex, ei = e.i, si = s.i, sameSegment = sSegIndex === eSegIndex, sameBezier = ei === si && sameSegment, wrapsBehind, sShift, eShift, i, copy, totalSegments, l, j;
    if (wrap || loops) {
        wrapsBehind = eSegIndex < sSegIndex || sameSegment && ei < si || sameBezier && e.t < s.t;
        if ($5c95287ca4d9d8c9$var$_splitSegment(path, sSegIndex, si, s.t)) {
            sSegIndex++;
            if (!wrapsBehind) {
                eSegIndex++;
                if (sameBezier) {
                    e.t = (e.t - s.t) / (1 - s.t);
                    ei = 0;
                } else if (sameSegment) ei -= si;
            }
        }
        if (Math.abs(1 - (end - start)) < 1e-5) eSegIndex = sSegIndex - 1;
        else if (!e.t && eSegIndex) eSegIndex--;
        else if ($5c95287ca4d9d8c9$var$_splitSegment(path, eSegIndex, ei, e.t) && wrapsBehind) sSegIndex++;
        if (s.t === 1) sSegIndex = (sSegIndex + 1) % path.length;
        copy = [];
        totalSegments = path.length;
        l = 1 + totalSegments * loops;
        j = sSegIndex;
        l += (totalSegments - sSegIndex + eSegIndex) % totalSegments;
        for(i = 0; i < l; i++)$5c95287ca4d9d8c9$var$_appendOrMerge(copy, path[j++ % totalSegments]);
        path = copy;
    } else {
        eShift = e.t === 1 ? 6 : $5c95287ca4d9d8c9$export$bd9f14de8998b2c6(eSeg, ei, e.t);
        if (start !== end) {
            sShift = $5c95287ca4d9d8c9$export$bd9f14de8998b2c6(sSeg, si, sameBezier ? s.t / e.t : s.t);
            sameSegment && (eShift += sShift);
            eSeg.splice(ei + eShift + 2);
            (sShift || si) && sSeg.splice(0, si + sShift);
            i = path.length;
            while(i--)//chop off any extra segments
            (i < sSegIndex || i > eSegIndex) && path.splice(i, 1);
        } else {
            eSeg.angle = $5c95287ca4d9d8c9$var$getRotationAtBezierT(eSeg, ei + eShift, 0); //record the value before we chop because it'll be impossible to determine the angle after its length is 0!
            ei += eShift;
            s = eSeg[ei];
            e = eSeg[ei + 1];
            eSeg.length = eSeg.totalLength = 0;
            eSeg.totalPoints = path.totalPoints = 8;
            eSeg.push(s, e, s, e, s, e, s, e);
        }
    }
    path.totalLength = 0;
    return path;
}
//measures a Segment according to its resolution (so if segment.resolution is 6, for example, it'll take 6 samples equally across each Bezier) and create/populate a "samples" Array that has the length up to each of those sample points (always increasing from the start) as well as a "lookup" array that's broken up according to the smallest distance between 2 samples. This gives us a very fast way of looking up a progress position rather than looping through all the points/Beziers. You can optionally have it only measure a subset, starting at startIndex and going for a specific number of beziers (remember, there are 3 x/y pairs each, for a total of 6 elements for each Bezier). It will also populate a "totalLength" property, but that's not generally super accurate because by default it'll only take 6 samples per Bezier. But for performance reasons, it's perfectly adequate for measuring progress values along the path. If you need a more accurate totalLength, either increase the resolution or use the more advanced bezierToPoints() method which keeps adding points until they don't deviate by more than a certain precision value.
function $5c95287ca4d9d8c9$var$measureSegment(segment, startIndex, bezierQty) {
    startIndex = startIndex || 0;
    if (!segment.samples) {
        segment.samples = [];
        segment.lookup = [];
    }
    let resolution = ~~segment.resolution || 12, inc = 1 / resolution, endIndex = bezierQty ? startIndex + bezierQty * 6 + 1 : segment.length, x1 = segment[startIndex], y1 = segment[startIndex + 1], samplesIndex = startIndex ? startIndex / 6 * resolution : 0, samples = segment.samples, lookup = segment.lookup, min = (startIndex ? segment.minLength : $5c95287ca4d9d8c9$var$_largeNum) || $5c95287ca4d9d8c9$var$_largeNum, prevLength = samples[samplesIndex + bezierQty * resolution - 1], length = startIndex ? samples[samplesIndex - 1] : 0, i, j, x4, x3, x2, xd, xd1, y4, y3, y2, yd, yd1, inv, t, lengthIndex, l, segLength;
    samples.length = lookup.length = 0;
    for(j = startIndex + 2; j < endIndex; j += 6){
        x4 = segment[j + 4] - x1;
        x3 = segment[j + 2] - x1;
        x2 = segment[j] - x1;
        y4 = segment[j + 5] - y1;
        y3 = segment[j + 3] - y1;
        y2 = segment[j + 1] - y1;
        xd = xd1 = yd = yd1 = 0;
        if ($5c95287ca4d9d8c9$var$_abs(x4) < .01 && $5c95287ca4d9d8c9$var$_abs(y4) < .01 && $5c95287ca4d9d8c9$var$_abs(x2) + $5c95287ca4d9d8c9$var$_abs(y2) < .01) {
            if (segment.length > 8) {
                segment.splice(j, 6);
                j -= 6;
                endIndex -= 6;
            }
        } else for(i = 1; i <= resolution; i++){
            t = inc * i;
            inv = 1 - t;
            xd = xd1 - (xd1 = (t * t * x4 + 3 * inv * (t * x3 + inv * x2)) * t);
            yd = yd1 - (yd1 = (t * t * y4 + 3 * inv * (t * y3 + inv * y2)) * t);
            l = $5c95287ca4d9d8c9$var$_sqrt(yd * yd + xd * xd);
            if (l < min) min = l;
            length += l;
            samples[samplesIndex++] = length;
        }
        x1 += x4;
        y1 += y4;
    }
    if (prevLength) {
        prevLength -= length;
        for(; samplesIndex < samples.length; samplesIndex++)samples[samplesIndex] += prevLength;
    }
    if (samples.length && min) {
        segment.totalLength = segLength = samples[samples.length - 1] || 0;
        segment.minLength = min;
        if (segLength / min < 9999) {
            l = lengthIndex = 0;
            for(i = 0; i < segLength; i += min)lookup[l++] = samples[lengthIndex] < i ? ++lengthIndex : lengthIndex;
        }
    } else segment.totalLength = samples[0] = 0;
    return startIndex ? length - samples[startIndex / 2 - 1] : length;
}
function $5c95287ca4d9d8c9$export$cd44c6d3aa5b1098(rawPath, resolution) {
    let pathLength, points, i;
    for(i = pathLength = points = 0; i < rawPath.length; i++){
        rawPath[i].resolution = ~~resolution || 12; //steps per Bezier curve (anchor, 2 control points, to anchor)
        points += rawPath[i].length;
        pathLength += $5c95287ca4d9d8c9$var$measureSegment(rawPath[i]);
    }
    rawPath.totalPoints = points;
    rawPath.totalLength = pathLength;
    return rawPath;
}
function $5c95287ca4d9d8c9$export$bd9f14de8998b2c6(segment, i, t) {
    if (t <= 0 || t >= 1) return 0;
    let ax = segment[i], ay = segment[i + 1], cp1x = segment[i + 2], cp1y = segment[i + 3], cp2x = segment[i + 4], cp2y = segment[i + 5], bx = segment[i + 6], by = segment[i + 7], x1a = ax + (cp1x - ax) * t, x2 = cp1x + (cp2x - cp1x) * t, y1a = ay + (cp1y - ay) * t, y2 = cp1y + (cp2y - cp1y) * t, x1 = x1a + (x2 - x1a) * t, y1 = y1a + (y2 - y1a) * t, x2a = cp2x + (bx - cp2x) * t, y2a = cp2y + (by - cp2y) * t;
    x2 += (x2a - x2) * t;
    y2 += (y2a - y2) * t;
    segment.splice(i + 2, 4, $5c95287ca4d9d8c9$var$_round(x1a), $5c95287ca4d9d8c9$var$_round(y1a), $5c95287ca4d9d8c9$var$_round(x1), $5c95287ca4d9d8c9$var$_round(y1), $5c95287ca4d9d8c9$var$_round(x1 + (x2 - x1) * t), $5c95287ca4d9d8c9$var$_round(y1 + (y2 - y1) * t), $5c95287ca4d9d8c9$var$_round(x2), $5c95287ca4d9d8c9$var$_round(y2), $5c95287ca4d9d8c9$var$_round(x2a), $5c95287ca4d9d8c9$var$_round(y2a));
    segment.samples && segment.samples.splice(i / 6 * segment.resolution | 0, 0, 0, 0, 0, 0, 0, 0);
    return 6;
}
// returns an object {path, segment, segIndex, i, t}
function $5c95287ca4d9d8c9$var$getProgressData(rawPath, progress, decoratee, pushToNextIfAtEnd) {
    decoratee = decoratee || {};
    rawPath.totalLength || $5c95287ca4d9d8c9$export$cd44c6d3aa5b1098(rawPath);
    if (progress < 0 || progress > 1) progress = $5c95287ca4d9d8c9$var$_wrapProgress(progress);
    let segIndex = 0, segment = rawPath[0], samples, resolution, length, min, max, i, t;
    if (!progress) {
        t = i = segIndex = 0;
        segment = rawPath[0];
    } else if (progress === 1) {
        t = 1;
        segIndex = rawPath.length - 1;
        segment = rawPath[segIndex];
        i = segment.length - 8;
    } else {
        if (rawPath.length > 1) {
            length = rawPath.totalLength * progress;
            max = i = 0;
            while((max += rawPath[i++].totalLength) < length)segIndex = i;
            segment = rawPath[segIndex];
            min = max - segment.totalLength;
            progress = (length - min) / (max - min) || 0;
        }
        samples = segment.samples;
        resolution = segment.resolution; //how many samples per cubic bezier chunk
        length = segment.totalLength * progress;
        i = segment.lookup.length ? segment.lookup[~~(length / segment.minLength)] || 0 : $5c95287ca4d9d8c9$var$_getSampleIndex(samples, length, progress);
        min = i ? samples[i - 1] : 0;
        max = samples[i];
        if (max < length) {
            min = max;
            max = samples[++i];
        }
        t = 1 / resolution * ((length - min) / (max - min) + i % resolution);
        i = ~~(i / resolution) * 6;
        if (pushToNextIfAtEnd && t === 1) {
            if (i + 6 < segment.length) {
                i += 6;
                t = 0;
            } else if (segIndex + 1 < rawPath.length) {
                i = t = 0;
                segment = rawPath[++segIndex];
            }
        }
    }
    decoratee.t = t;
    decoratee.i = i;
    decoratee.path = rawPath;
    decoratee.segment = segment;
    decoratee.segIndex = segIndex;
    return decoratee;
}
function $5c95287ca4d9d8c9$export$5fcb25b7d1608b70(rawPath, progress, includeAngle, point) {
    let segment = rawPath[0], result = point || {}, samples, resolution, length, min, max, i, t, a, inv;
    if (progress < 0 || progress > 1) progress = $5c95287ca4d9d8c9$var$_wrapProgress(progress);
    segment.lookup || $5c95287ca4d9d8c9$export$cd44c6d3aa5b1098(rawPath);
    if (rawPath.length > 1) {
        length = rawPath.totalLength * progress;
        max = i = 0;
        while((max += rawPath[i++].totalLength) < length)segment = rawPath[i];
        min = max - segment.totalLength;
        progress = (length - min) / (max - min) || 0;
    }
    samples = segment.samples;
    resolution = segment.resolution;
    length = segment.totalLength * progress;
    i = segment.lookup.length ? segment.lookup[progress < 1 ? ~~(length / segment.minLength) : segment.lookup.length - 1] || 0 : $5c95287ca4d9d8c9$var$_getSampleIndex(samples, length, progress);
    min = i ? samples[i - 1] : 0;
    max = samples[i];
    if (max < length) {
        min = max;
        max = samples[++i];
    }
    t = 1 / resolution * ((length - min) / (max - min) + i % resolution) || 0;
    inv = 1 - t;
    i = ~~(i / resolution) * 6;
    a = segment[i];
    result.x = $5c95287ca4d9d8c9$var$_round((t * t * (segment[i + 6] - a) + 3 * inv * (t * (segment[i + 4] - a) + inv * (segment[i + 2] - a))) * t + a);
    result.y = $5c95287ca4d9d8c9$var$_round((t * t * (segment[i + 7] - (a = segment[i + 1])) + 3 * inv * (t * (segment[i + 5] - a) + inv * (segment[i + 3] - a))) * t + a);
    if (includeAngle) result.angle = segment.totalLength ? $5c95287ca4d9d8c9$var$getRotationAtBezierT(segment, i, t >= 1 ? 1 - 1e-9 : t ? t : 1e-9) : segment.angle || 0;
    return result;
}
function $5c95287ca4d9d8c9$export$9210b538875bfe33(rawPath, a, b, c, d, tx, ty) {
    let j = rawPath.length, segment, l, i, x, y;
    while(--j > -1){
        segment = rawPath[j];
        l = segment.length;
        for(i = 0; i < l; i += 2){
            x = segment[i];
            y = segment[i + 1];
            segment[i] = x * a + y * c + tx;
            segment[i + 1] = x * b + y * d + ty;
        }
    }
    rawPath._dirty = 1;
    return rawPath;
}
// translates SVG arc data into a segment (cubic beziers). Angle is in degrees.
function $5c95287ca4d9d8c9$var$arcToSegment(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
    if (lastX === x && lastY === y) return;
    rx = $5c95287ca4d9d8c9$var$_abs(rx);
    ry = $5c95287ca4d9d8c9$var$_abs(ry);
    let angleRad = angle % 360 * $5c95287ca4d9d8c9$var$_DEG2RAD, cosAngle = $5c95287ca4d9d8c9$var$_cos(angleRad), sinAngle = $5c95287ca4d9d8c9$var$_sin(angleRad), PI = Math.PI, TWOPI = PI * 2, dx2 = (lastX - x) / 2, dy2 = (lastY - y) / 2, x1 = cosAngle * dx2 + sinAngle * dy2, y1 = -sinAngle * dx2 + cosAngle * dy2, x1_sq = x1 * x1, y1_sq = y1 * y1, radiiCheck = x1_sq / (rx * rx) + y1_sq / (ry * ry);
    if (radiiCheck > 1) {
        rx = $5c95287ca4d9d8c9$var$_sqrt(radiiCheck) * rx;
        ry = $5c95287ca4d9d8c9$var$_sqrt(radiiCheck) * ry;
    }
    let rx_sq = rx * rx, ry_sq = ry * ry, sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
    if (sq < 0) sq = 0;
    let coef = (largeArcFlag === sweepFlag ? -1 : 1) * $5c95287ca4d9d8c9$var$_sqrt(sq), cx1 = coef * (rx * y1 / ry), cy1 = coef * -(ry * x1 / rx), sx2 = (lastX + x) / 2, sy2 = (lastY + y) / 2, cx = sx2 + (cosAngle * cx1 - sinAngle * cy1), cy = sy2 + (sinAngle * cx1 + cosAngle * cy1), ux = (x1 - cx1) / rx, uy = (y1 - cy1) / ry, vx = (-x1 - cx1) / rx, vy = (-y1 - cy1) / ry, temp = ux * ux + uy * uy, angleStart = (uy < 0 ? -1 : 1) * Math.acos(ux / $5c95287ca4d9d8c9$var$_sqrt(temp)), angleExtent = (ux * vy - uy * vx < 0 ? -1 : 1) * Math.acos((ux * vx + uy * vy) / $5c95287ca4d9d8c9$var$_sqrt(temp * (vx * vx + vy * vy)));
    isNaN(angleExtent) && (angleExtent = PI); //rare edge case. Math.cos(-1) is NaN.
    if (!sweepFlag && angleExtent > 0) angleExtent -= TWOPI;
    else if (sweepFlag && angleExtent < 0) angleExtent += TWOPI;
    angleStart %= TWOPI;
    angleExtent %= TWOPI;
    let segments = Math.ceil($5c95287ca4d9d8c9$var$_abs(angleExtent) / (TWOPI / 4)), rawPath = [], angleIncrement = angleExtent / segments, controlLength = 4 / 3 * $5c95287ca4d9d8c9$var$_sin(angleIncrement / 2) / (1 + $5c95287ca4d9d8c9$var$_cos(angleIncrement / 2)), ma = cosAngle * rx, mb = sinAngle * rx, mc = sinAngle * -ry, md = cosAngle * ry, i;
    for(i = 0; i < segments; i++){
        angle = angleStart + i * angleIncrement;
        x1 = $5c95287ca4d9d8c9$var$_cos(angle);
        y1 = $5c95287ca4d9d8c9$var$_sin(angle);
        ux = $5c95287ca4d9d8c9$var$_cos(angle += angleIncrement);
        uy = $5c95287ca4d9d8c9$var$_sin(angle);
        rawPath.push(x1 - controlLength * y1, y1 + controlLength * x1, ux + controlLength * uy, uy - controlLength * ux, ux, uy);
    }
    //now transform according to the actual size of the ellipse/arc (the beziers were noramlized, between 0 and 1 on a circle).
    for(i = 0; i < rawPath.length; i += 2){
        x1 = rawPath[i];
        y1 = rawPath[i + 1];
        rawPath[i] = x1 * ma + y1 * mc + cx;
        rawPath[i + 1] = x1 * mb + y1 * md + cy;
    }
    rawPath[i - 2] = x; //always set the end to exactly where it's supposed to be
    rawPath[i - 1] = y;
    return rawPath;
}
function $5c95287ca4d9d8c9$export$a9a6ab89eb1c2191(d) {
    let a = (d + "").replace($5c95287ca4d9d8c9$var$_scientific, (m)=>{
        let n = +m;
        return n < 0.0001 && n > -0.0001 ? 0 : n;
    }).match($5c95287ca4d9d8c9$var$_svgPathExp) || [], path = [], relativeX = 0, relativeY = 0, twoThirds = 2 / 3, elements = a.length, points = 0, errorMessage = "ERROR: malformed path: " + d, i, j, x, y, command, isRelative, segment, startX, startY, difX, difY, beziers, prevCommand, flag1, flag2, line = function(sx, sy, ex, ey) {
        difX = (ex - sx) / 3;
        difY = (ey - sy) / 3;
        segment.push(sx + difX, sy + difY, ex - difX, ey - difY, ex, ey);
    };
    if (!d || !isNaN(a[0]) || isNaN(a[1])) {
        console.log(errorMessage);
        return path;
    }
    for(i = 0; i < elements; i++){
        prevCommand = command;
        if (isNaN(a[i])) {
            command = a[i].toUpperCase();
            isRelative = command !== a[i]; //lower case means relative
        } else i--;
        x = +a[i + 1];
        y = +a[i + 2];
        if (isRelative) {
            x += relativeX;
            y += relativeY;
        }
        if (!i) {
            startX = x;
            startY = y;
        }
        // "M" (move)
        if (command === "M") {
            if (segment) {
                if (segment.length < 8) path.length -= 1;
                else points += segment.length;
            }
            relativeX = startX = x;
            relativeY = startY = y;
            segment = [
                x,
                y
            ];
            path.push(segment);
            i += 2;
            command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").
        // "C" (cubic bezier)
        } else if (command === "C") {
            if (!segment) segment = [
                0,
                0
            ];
            if (!isRelative) relativeX = relativeY = 0;
            //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
            segment.push(x, y, relativeX + a[i + 3] * 1, relativeY + a[i + 4] * 1, relativeX += a[i + 5] * 1, relativeY += a[i + 6] * 1);
            i += 6;
        // "S" (continuation of cubic bezier)
        } else if (command === "S") {
            difX = relativeX;
            difY = relativeY;
            if (prevCommand === "C" || prevCommand === "S") {
                difX += relativeX - segment[segment.length - 4];
                difY += relativeY - segment[segment.length - 3];
            }
            if (!isRelative) relativeX = relativeY = 0;
            segment.push(difX, difY, x, y, relativeX += a[i + 3] * 1, relativeY += a[i + 4] * 1);
            i += 4;
        // "Q" (quadratic bezier)
        } else if (command === "Q") {
            difX = relativeX + (x - relativeX) * twoThirds;
            difY = relativeY + (y - relativeY) * twoThirds;
            if (!isRelative) relativeX = relativeY = 0;
            relativeX += a[i + 3] * 1;
            relativeY += a[i + 4] * 1;
            segment.push(difX, difY, relativeX + (x - relativeX) * twoThirds, relativeY + (y - relativeY) * twoThirds, relativeX, relativeY);
            i += 4;
        // "T" (continuation of quadratic bezier)
        } else if (command === "T") {
            difX = relativeX - segment[segment.length - 4];
            difY = relativeY - segment[segment.length - 3];
            segment.push(relativeX + difX, relativeY + difY, x + (relativeX + difX * 1.5 - x) * twoThirds, y + (relativeY + difY * 1.5 - y) * twoThirds, relativeX = x, relativeY = y);
            i += 2;
        // "H" (horizontal line)
        } else if (command === "H") {
            line(relativeX, relativeY, relativeX = x, relativeY);
            i += 1;
        // "V" (vertical line)
        } else if (command === "V") {
            //adjust values because the first (and only one) isn't x in this case, it's y.
            line(relativeX, relativeY, relativeX, relativeY = x + (isRelative ? relativeY - relativeX : 0));
            i += 1;
        // "L" (line) or "Z" (close)
        } else if (command === "L" || command === "Z") {
            if (command === "Z") {
                x = startX;
                y = startY;
                segment.closed = true;
            }
            if (command === "L" || $5c95287ca4d9d8c9$var$_abs(relativeX - x) > 0.5 || $5c95287ca4d9d8c9$var$_abs(relativeY - y) > 0.5) {
                line(relativeX, relativeY, x, y);
                if (command === "L") i += 2;
            }
            relativeX = x;
            relativeY = y;
        // "A" (arc)
        } else if (command === "A") {
            flag1 = a[i + 4];
            flag2 = a[i + 5];
            difX = a[i + 6];
            difY = a[i + 7];
            j = 7;
            if (flag1.length > 1) {
                if (flag1.length < 3) {
                    difY = difX;
                    difX = flag2;
                    j--;
                } else {
                    difY = flag2;
                    difX = flag1.substr(2);
                    j -= 2;
                }
                flag2 = flag1.charAt(1);
                flag1 = flag1.charAt(0);
            }
            beziers = $5c95287ca4d9d8c9$var$arcToSegment(relativeX, relativeY, +a[i + 1], +a[i + 2], +a[i + 3], +flag1, +flag2, (isRelative ? relativeX : 0) + difX * 1, (isRelative ? relativeY : 0) + difY * 1);
            i += j;
            if (beziers) for(j = 0; j < beziers.length; j++)segment.push(beziers[j]);
            relativeX = segment[segment.length - 2];
            relativeY = segment[segment.length - 1];
        } else console.log(errorMessage);
    }
    i = segment.length;
    if (i < 6) {
        path.pop();
        i = 0;
    } else if (segment[0] === segment[i - 2] && segment[1] === segment[i - 1]) segment.closed = true;
    path.totalPoints = points + i;
    return path;
}
function $5c95287ca4d9d8c9$export$f86e11e84068dc85(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    let x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = $5c95287ca4d9d8c9$var$_abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = $5c95287ca4d9d8c9$var$_abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            x1,
            y1,
            x4,
            y4
        ];
        index = 2;
    }
    points.splice(index || points.length - 2, 0, x1234, y1234);
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        $5c95287ca4d9d8c9$export$f86e11e84068dc85(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        $5c95287ca4d9d8c9$export$f86e11e84068dc85(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 2 + (points.length - length));
    }
    return points;
}
function $5c95287ca4d9d8c9$export$e3b964ae0940782f(points, curviness = 1) {
    let x = points[0], y = 0, segment = [
        x,
        y
    ], i = 2;
    for(; i < points.length; i += 2)segment.push(x, y, points[i], y = (points[i] - x) * curviness / 2, x = points[i], -y);
    return segment;
}
function $5c95287ca4d9d8c9$export$ae6dd21671b80694(points, curviness) {
    //points = simplifyPoints(points, tolerance);
    $5c95287ca4d9d8c9$var$_abs(points[0] - points[2]) < 1e-4 && $5c95287ca4d9d8c9$var$_abs(points[1] - points[3]) < 1e-4 && (points = points.slice(2)); // if the first two points are super close, dump the first one.
    let l = points.length - 2, x = +points[0], y = +points[1], nextX = +points[2], nextY = +points[3], segment = [
        x,
        y,
        x,
        y
    ], dx2 = nextX - x, dy2 = nextY - y, closed = Math.abs(points[l] - x) < 0.001 && Math.abs(points[l + 1] - y) < 0.001, prevX, prevY, i, dx1, dy1, r1, r2, r3, tl, mx1, mx2, mxm, my1, my2, mym;
    if (closed) {
        points.push(nextX, nextY);
        nextX = x;
        nextY = y;
        x = points[l - 2];
        y = points[l - 1];
        points.unshift(x, y);
        l += 4;
    }
    curviness = curviness || curviness === 0 ? +curviness : 1;
    for(i = 2; i < l; i += 2){
        prevX = x;
        prevY = y;
        x = nextX;
        y = nextY;
        nextX = +points[i + 2];
        nextY = +points[i + 3];
        if (x === nextX && y === nextY) continue;
        dx1 = dx2;
        dy1 = dy2;
        dx2 = nextX - x;
        dy2 = nextY - y;
        r1 = $5c95287ca4d9d8c9$var$_sqrt(dx1 * dx1 + dy1 * dy1); // r1, r2, and r3 correlate x and y (and z in the future). Basically 2D or 3D hypotenuse
        r2 = $5c95287ca4d9d8c9$var$_sqrt(dx2 * dx2 + dy2 * dy2);
        r3 = $5c95287ca4d9d8c9$var$_sqrt((dx2 / r2 + dx1 / r1) ** 2 + (dy2 / r2 + dy1 / r1) ** 2);
        tl = (r1 + r2) * curviness * 0.25 / r3;
        mx1 = x - (x - prevX) * (r1 ? tl / r1 : 0);
        mx2 = x + (nextX - x) * (r2 ? tl / r2 : 0);
        mxm = x - (mx1 + ((mx2 - mx1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        my1 = y - (y - prevY) * (r1 ? tl / r1 : 0);
        my2 = y + (nextY - y) * (r2 ? tl / r2 : 0);
        mym = y - (my1 + ((my2 - my1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        if (x !== prevX || y !== prevY) segment.push($5c95287ca4d9d8c9$var$_round(mx1 + mxm), $5c95287ca4d9d8c9$var$_round(my1 + mym), $5c95287ca4d9d8c9$var$_round(x), $5c95287ca4d9d8c9$var$_round(y), $5c95287ca4d9d8c9$var$_round(mx2 + mxm), $5c95287ca4d9d8c9$var$_round(my2 + mym));
    }
    x !== nextX || y !== nextY || segment.length < 4 ? segment.push($5c95287ca4d9d8c9$var$_round(nextX), $5c95287ca4d9d8c9$var$_round(nextY), $5c95287ca4d9d8c9$var$_round(nextX), $5c95287ca4d9d8c9$var$_round(nextY)) : segment.length -= 2;
    if (segment.length === 2) segment.push(x, y, x, y, x, y);
    else if (closed) {
        segment.splice(0, 6);
        segment.length = segment.length - 6;
    }
    return segment;
}
//returns the squared distance between an x/y coordinate and a segment between x1/y1 and x2/y2
function $5c95287ca4d9d8c9$var$pointToSegDist(x, y, x1, y1, x2, y2) {
    let dx = x2 - x1, dy = y2 - y1, t;
    if (dx || dy) {
        t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return (x - x1) ** 2 + (y - y1) ** 2;
}
function $5c95287ca4d9d8c9$var$simplifyStep(points, first, last, tolerance, simplified) {
    let maxSqDist = tolerance, firstX = points[first], firstY = points[first + 1], lastX = points[last], lastY = points[last + 1], index, i, d;
    for(i = first + 2; i < last; i += 2){
        d = $5c95287ca4d9d8c9$var$pointToSegDist(points[i], points[i + 1], firstX, firstY, lastX, lastY);
        if (d > maxSqDist) {
            index = i;
            maxSqDist = d;
        }
    }
    if (maxSqDist > tolerance) {
        index - first > 2 && $5c95287ca4d9d8c9$var$simplifyStep(points, first, index, tolerance, simplified);
        simplified.push(points[index], points[index + 1]);
        last - index > 2 && $5c95287ca4d9d8c9$var$simplifyStep(points, index, last, tolerance, simplified);
    }
}
function $5c95287ca4d9d8c9$export$59627e036caae5e0(points, tolerance) {
    let prevX = parseFloat(points[0]), prevY = parseFloat(points[1]), temp = [
        prevX,
        prevY
    ], l = points.length - 2, i, x, y, dx, dy, result, last;
    tolerance = (tolerance || 1) ** 2;
    for(i = 2; i < l; i += 2){
        x = parseFloat(points[i]);
        y = parseFloat(points[i + 1]);
        dx = prevX - x;
        dy = prevY - y;
        if (dx * dx + dy * dy > tolerance) {
            temp.push(x, y);
            prevX = x;
            prevY = y;
        }
    }
    temp.push(parseFloat(points[l]), parseFloat(points[l + 1]));
    last = temp.length - 2;
    result = [
        temp[0],
        temp[1]
    ];
    $5c95287ca4d9d8c9$var$simplifyStep(temp, 0, last, tolerance, result);
    result.push(temp[last], temp[last + 1]);
    return result;
}
function $5c95287ca4d9d8c9$var$getClosestProgressOnBezier(iterations, px, py, start, end, slices, x0, y0, x1, y1, x2, y2, x3, y3) {
    let inc = (end - start) / slices, best = 0, t = start, x, y, d, dx, dy, inv;
    $5c95287ca4d9d8c9$var$_bestDistance = $5c95287ca4d9d8c9$var$_largeNum;
    while(t <= end){
        inv = 1 - t;
        x = inv * inv * inv * x0 + 3 * inv * inv * t * x1 + 3 * inv * t * t * x2 + t * t * t * x3;
        y = inv * inv * inv * y0 + 3 * inv * inv * t * y1 + 3 * inv * t * t * y2 + t * t * t * y3;
        dx = x - px;
        dy = y - py;
        d = dx * dx + dy * dy;
        if (d < $5c95287ca4d9d8c9$var$_bestDistance) {
            $5c95287ca4d9d8c9$var$_bestDistance = d;
            best = t;
        }
        t += inc;
    }
    return iterations > 1 ? $5c95287ca4d9d8c9$var$getClosestProgressOnBezier(iterations - 1, px, py, Math.max(best - inc, 0), Math.min(best + inc, 1), slices, x0, y0, x1, y1, x2, y2, x3, y3) : best;
}
function $5c95287ca4d9d8c9$export$c7551252c2f97fc2(rawPath, x, y, slices) {
    let closest = {
        j: 0,
        i: 0,
        t: 0
    }, bestDistance = $5c95287ca4d9d8c9$var$_largeNum, i, j, t, segment;
    for(j = 0; j < rawPath.length; j++){
        segment = rawPath[j];
        for(i = 0; i < segment.length; i += 6){
            t = $5c95287ca4d9d8c9$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices || 20, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
            if (bestDistance > $5c95287ca4d9d8c9$var$_bestDistance) {
                bestDistance = $5c95287ca4d9d8c9$var$_bestDistance;
                closest.j = j;
                closest.i = i;
                closest.t = t;
            }
        }
    }
    return closest;
}
function $5c95287ca4d9d8c9$export$179b6e586855bec6(x, y, segment, slices, iterations) {
    let l = segment.length, bestDistance = $5c95287ca4d9d8c9$var$_largeNum, bestT = 0, bestSegmentIndex = 0, t, i;
    slices = slices || 20;
    iterations = iterations || 3;
    for(i = 0; i < l; i += 6){
        t = $5c95287ca4d9d8c9$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
        if (bestDistance > $5c95287ca4d9d8c9$var$_bestDistance) {
            bestDistance = $5c95287ca4d9d8c9$var$_bestDistance;
            bestT = t;
            bestSegmentIndex = i;
        }
    }
    t = $5c95287ca4d9d8c9$var$getClosestProgressOnBezier(iterations, x, y, bestT - 0.05, bestT + 0.05, slices, segment[bestSegmentIndex], segment[bestSegmentIndex + 1], segment[bestSegmentIndex + 2], segment[bestSegmentIndex + 3], segment[bestSegmentIndex + 4], segment[bestSegmentIndex + 5], segment[bestSegmentIndex + 6], segment[bestSegmentIndex + 7]);
    $5c95287ca4d9d8c9$export$bd9f14de8998b2c6(segment, bestSegmentIndex, t);
    return bestSegmentIndex + 6;
}
function $5c95287ca4d9d8c9$export$ced9e1d9be30c397(rawPath) {
    if ($5c95287ca4d9d8c9$var$_isNumber(rawPath[0])) rawPath = [
        rawPath
    ];
    let result = "", l = rawPath.length, sl, s, i, segment;
    for(s = 0; s < l; s++){
        segment = rawPath[s];
        result += "M" + $5c95287ca4d9d8c9$var$_round(segment[0]) + "," + $5c95287ca4d9d8c9$var$_round(segment[1]) + " C";
        sl = segment.length;
        for(i = 2; i < sl; i++)result += $5c95287ca4d9d8c9$var$_round(segment[i++]) + "," + $5c95287ca4d9d8c9$var$_round(segment[i++]) + " " + $5c95287ca4d9d8c9$var$_round(segment[i++]) + "," + $5c95287ca4d9d8c9$var$_round(segment[i++]) + " " + $5c95287ca4d9d8c9$var$_round(segment[i++]) + "," + $5c95287ca4d9d8c9$var$_round(segment[i]) + " ";
        if (segment.closed) result += "z";
    }
    return result;
} /*
// takes a segment with coordinates [x, y, x, y, ...] and converts the control points into angles and lengths [x, y, angle, length, angle, length, x, y, angle, length, ...] so that it animates more cleanly and avoids odd breaks/kinks. For example, if you animate from 1 o'clock to 6 o'clock, it'd just go directly/linearly rather than around. So the length would be very short in the middle of the tween.
export function cpCoordsToAngles(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		x, y, i;
	for (i = 0; i < segment.length; i+=6) {
		x = segment[i+2] - segment[i];
		y = segment[i+3] - segment[i+1];
		result[i+2] = Math.atan2(y, x);
		result[i+3] = Math.sqrt(x * x + y * y);
		x = segment[i+6] - segment[i+4];
		y = segment[i+7] - segment[i+5];
		result[i+4] = Math.atan2(y, x);
		result[i+5] = Math.sqrt(x * x + y * y);
	}
	return result;
}

// takes a segment that was converted with cpCoordsToAngles() to have angles and lengths instead of coordinates for the control points, and converts it BACK into coordinates.
export function cpAnglesToCoords(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		length = segment.length,
		rnd = 1000,
		angle, l, i, j;
	for (i = 0; i < length; i+=6) {
		angle = segment[i+2];
		l = segment[i+3]; //length
		result[i+2] = (((segment[i] + Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+3] = (((segment[i+1] + Math.sin(angle) * l) * rnd) | 0) / rnd;
		angle = segment[i+4];
		l = segment[i+5]; //length
		result[i+4] = (((segment[i+6] - Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+5] = (((segment[i+7] - Math.sin(angle) * l) * rnd) | 0) / rnd;
	}
	return result;
}

//adds an "isSmooth" array to each segment and populates it with a boolean value indicating whether or not it's smooth (the control points have basically the same slope). For any smooth control points, it converts the coordinates into angle (x, in radians) and length (y) and puts them into the same index value in a smoothData array.
export function populateSmoothData(rawPath) {
	let j = rawPath.length,
		smooth, segment, x, y, x2, y2, i, l, a, a2, isSmooth, smoothData;
	while (--j > -1) {
		segment = rawPath[j];
		isSmooth = segment.isSmooth = segment.isSmooth || [0, 0, 0, 0];
		smoothData = segment.smoothData = segment.smoothData || [0, 0, 0, 0];
		isSmooth.length = 4;
		l = segment.length - 2;
		for (i = 6; i < l; i += 6) {
			x = segment[i] - segment[i - 2];
			y = segment[i + 1] - segment[i - 1];
			x2 = segment[i + 2] - segment[i];
			y2 = segment[i + 3] - segment[i + 1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			smooth = (Math.abs(a - a2) < 0.09);
			if (smooth) {
				smoothData[i - 2] = a;
				smoothData[i + 2] = a2;
				smoothData[i - 1] = _sqrt(x * x + y * y);
				smoothData[i + 3] = _sqrt(x2 * x2 + y2 * y2);
			}
			isSmooth.push(smooth, smooth, 0, 0, smooth, smooth);
		}
		//if the first and last points are identical, check to see if there's a smooth transition. We must handle this a bit differently due to their positions in the array.
		if (segment[l] === segment[0] && segment[l+1] === segment[1]) {
			x = segment[0] - segment[l-2];
			y = segment[1] - segment[l-1];
			x2 = segment[2] - segment[0];
			y2 = segment[3] - segment[1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			if (Math.abs(a - a2) < 0.09) {
				smoothData[l-2] = a;
				smoothData[2] = a2;
				smoothData[l-1] = _sqrt(x * x + y * y);
				smoothData[3] = _sqrt(x2 * x2 + y2 * y2);
				isSmooth[l-2] = isSmooth[l-1] = true; //don't change indexes 2 and 3 because we'll trigger everything from the END, and this will optimize file size a bit.
			}
		}
	}
	return rawPath;
}
export function pointToScreen(svgElement, point) {
	if (arguments.length < 2) { //by default, take the first set of coordinates in the path as the point
		let rawPath = getRawPath(svgElement);
		point = svgElement.ownerSVGElement.createSVGPoint();
		point.x = rawPath[0][0];
		point.y = rawPath[0][1];
	}
	return point.matrixTransform(svgElement.getScreenCTM());
}

*/ 


let $5c4bdc270e31825b$var$gsap, $5c4bdc270e31825b$var$_coreInitted, $5c4bdc270e31825b$var$_getGSAP = ()=>$5c4bdc270e31825b$var$gsap || typeof window !== "undefined" && ($5c4bdc270e31825b$var$gsap = window.gsap) && $5c4bdc270e31825b$var$gsap.registerPlugin && $5c4bdc270e31825b$var$gsap, $5c4bdc270e31825b$var$_initCore = ()=>{
    $5c4bdc270e31825b$var$gsap = $5c4bdc270e31825b$var$_getGSAP();
    if ($5c4bdc270e31825b$var$gsap) {
        $5c4bdc270e31825b$var$gsap.registerEase("_CE", $5c4bdc270e31825b$export$94f46869cc67acd8.create);
        $5c4bdc270e31825b$var$_coreInitted = 1;
    } else console.warn("Please gsap.registerPlugin(CustomEase)");
}, $5c4bdc270e31825b$var$_bigNum = 1e20, $5c4bdc270e31825b$var$_round = (value)=>~~(value * 1000 + (value < 0 ? -0.5 : .5)) / 1000, $5c4bdc270e31825b$var$_bonusValidated = 1, $5c4bdc270e31825b$var$_numExp = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, $5c4bdc270e31825b$var$_needsParsingExp = /[cLlsSaAhHvVtTqQ]/g, $5c4bdc270e31825b$var$_findMinimum = (values)=>{
    let l = values.length, min = $5c4bdc270e31825b$var$_bigNum, i;
    for(i = 1; i < l; i += 6)+values[i] < min && (min = +values[i]);
    return min;
}, //takes all the points and translates/scales them so that the x starts at 0 and ends at 1.
$5c4bdc270e31825b$var$_normalize = (values, height, originY)=>{
    if (!originY && originY !== 0) originY = Math.max(+values[values.length - 1], +values[1]);
    let tx = +values[0] * -1, ty = -originY, l = values.length, sx = 1 / (+values[l - 2] + tx), sy = -height || (Math.abs(+values[l - 1] - +values[1]) < 0.01 * (+values[l - 2] - +values[0]) ? $5c4bdc270e31825b$var$_findMinimum(values) + ty : +values[l - 1] + ty), i;
    if (sy) sy = 1 / sy;
    else sy = -sx;
    for(i = 0; i < l; i += 2){
        values[i] = (+values[i] + tx) * sx;
        values[i + 1] = (+values[i + 1] + ty) * sy;
    }
}, //note that this function returns point objects like {x, y} rather than working with segments which are arrays with alternating x, y values as in the similar function in paths.js
$5c4bdc270e31825b$var$_bezierToPoints = function(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    let x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            {
                x: x1,
                y: y1
            },
            {
                x: x4,
                y: y4
            }
        ];
        index = 1;
    }
    points.splice(index || points.length - 1, 0, {
        x: x1234,
        y: y1234
    });
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        $5c4bdc270e31825b$var$_bezierToPoints(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        $5c4bdc270e31825b$var$_bezierToPoints(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 1 + (points.length - length));
    }
    return points;
};
class $5c4bdc270e31825b$export$94f46869cc67acd8 {
    constructor(id, data, config){
        $5c4bdc270e31825b$var$_coreInitted || $5c4bdc270e31825b$var$_initCore();
        this.id = id;
        $5c4bdc270e31825b$var$_bonusValidated && this.setData(data, config);
    }
    setData(data, config) {
        config = config || {};
        data = data || "0,0,1,1";
        let values = data.match($5c4bdc270e31825b$var$_numExp), closest = 1, points = [], lookup = [], precision = config.precision || 1, fast = precision <= 1, l, a1, a2, i, inc, j, point, prevPoint, p;
        this.data = data;
        if ($5c4bdc270e31825b$var$_needsParsingExp.test(data) || ~data.indexOf("M") && data.indexOf("C") < 0) values = (0, $5c95287ca4d9d8c9$export$a9a6ab89eb1c2191)(data)[0];
        l = values.length;
        if (l === 4) {
            values.unshift(0, 0);
            values.push(1, 1);
            l = 8;
        } else if ((l - 2) % 6) throw "Invalid CustomEase";
        if (+values[0] !== 0 || +values[l - 2] !== 1) $5c4bdc270e31825b$var$_normalize(values, config.height, config.originY);
        this.segment = values;
        for(i = 2; i < l; i += 6){
            a1 = {
                x: +values[i - 2],
                y: +values[i - 1]
            };
            a2 = {
                x: +values[i + 4],
                y: +values[i + 5]
            };
            points.push(a1, a2);
            $5c4bdc270e31825b$var$_bezierToPoints(a1.x, a1.y, +values[i], +values[i + 1], +values[i + 2], +values[i + 3], a2.x, a2.y, 1 / (precision * 200000), points, points.length - 1);
        }
        l = points.length;
        for(i = 0; i < l; i++){
            point = points[i];
            prevPoint = points[i - 1] || point;
            if ((point.x > prevPoint.x || prevPoint.y !== point.y && prevPoint.x === point.x || point === prevPoint) && point.x <= 1) {
                prevPoint.cx = point.x - prevPoint.x; //change in x between this point and the next point (performance optimization)
                prevPoint.cy = point.y - prevPoint.y;
                prevPoint.n = point;
                prevPoint.nx = point.x; //next point's x value (performance optimization, making lookups faster in getRatio()). Remember, the lookup will always land on a spot where it's either this point or the very next one (never beyond that)
                if (fast && i > 1 && Math.abs(prevPoint.cy / prevPoint.cx - points[i - 2].cy / points[i - 2].cx) > 2) fast = 0;
                if (prevPoint.cx < closest) {
                    if (!prevPoint.cx) {
                        prevPoint.cx = 0.001; //avoids math problems in getRatio() (dividing by zero)
                        if (i === l - 1) {
                            prevPoint.x -= 0.001;
                            closest = Math.min(closest, 0.001);
                            fast = 0;
                        }
                    } else closest = prevPoint.cx;
                }
            } else {
                points.splice(i--, 1);
                l--;
            }
        }
        l = 1 / closest + 1 | 0;
        inc = 1 / l;
        j = 0;
        point = points[0];
        if (fast) {
            for(i = 0; i < l; i++){
                p = i * inc;
                if (point.nx < p) point = points[++j];
                a1 = point.y + (p - point.x) / point.cx * point.cy;
                lookup[i] = {
                    x: p,
                    cx: inc,
                    y: a1,
                    cy: 0,
                    nx: 9
                };
                if (i) lookup[i - 1].cy = a1 - lookup[i - 1].y;
            }
            lookup[l - 1].cy = points[points.length - 1].y - a1;
        } else {
            for(i = 0; i < l; i++){
                if (point.nx < i * inc) point = points[++j];
                lookup[i] = point;
            }
            if (j < points.length - 1) lookup[i - 1] = points[points.length - 2];
        }
        //this._calcEnd = (points[points.length-1].y !== 1 || points[0].y !== 0); //ensures that we don't run into floating point errors. As long as we're starting at 0 and ending at 1, tell GSAP to skip the final calculation and use 0/1 as the factor.
        this.ease = (p)=>{
            let point = lookup[p * l | 0] || lookup[l - 1];
            if (point.nx < p) point = point.n;
            return point.y + (p - point.x) / point.cx * point.cy;
        };
        this.ease.custom = this;
        this.id && $5c4bdc270e31825b$var$gsap && $5c4bdc270e31825b$var$gsap.registerEase(this.id, this.ease);
        return this;
    }
    getSVGData(config) {
        return $5c4bdc270e31825b$export$94f46869cc67acd8.getSVGData(this, config);
    }
    static create(id, data, config) {
        return new $5c4bdc270e31825b$export$94f46869cc67acd8(id, data, config).ease;
    }
    static register(core) {
        $5c4bdc270e31825b$var$gsap = core;
        $5c4bdc270e31825b$var$_initCore();
    }
    static get(id) {
        return $5c4bdc270e31825b$var$gsap.parseEase(id);
    }
    static getSVGData(ease, config) {
        config = config || {};
        let width = config.width || 100, height = config.height || 100, x = config.x || 0, y = (config.y || 0) + height, e = $5c4bdc270e31825b$var$gsap.utils.toArray(config.path)[0], a, slope, i, inc, tx, ty, precision, threshold, prevX, prevY;
        if (config.invert) {
            height = -height;
            y = 0;
        }
        if (typeof ease === "string") ease = $5c4bdc270e31825b$var$gsap.parseEase(ease);
        if (ease.custom) ease = ease.custom;
        if (ease instanceof $5c4bdc270e31825b$export$94f46869cc67acd8) a = (0, $5c95287ca4d9d8c9$export$ced9e1d9be30c397)((0, $5c95287ca4d9d8c9$export$9210b538875bfe33)([
            ease.segment
        ], width, 0, 0, -height, x, y));
        else {
            a = [
                x,
                y
            ];
            precision = Math.max(5, (config.precision || 1) * 200);
            inc = 1 / precision;
            precision += 2;
            threshold = 5 / precision;
            prevX = $5c4bdc270e31825b$var$_round(x + inc * width);
            prevY = $5c4bdc270e31825b$var$_round(y + ease(inc) * -height);
            slope = (prevY - y) / (prevX - x);
            for(i = 2; i < precision; i++){
                tx = $5c4bdc270e31825b$var$_round(x + i * inc * width);
                ty = $5c4bdc270e31825b$var$_round(y + ease(i * inc) * -height);
                if (Math.abs((ty - prevY) / (tx - prevX) - slope) > threshold || i === precision - 1) {
                    a.push(prevX, prevY);
                    slope = (ty - prevY) / (tx - prevX);
                }
                prevX = tx;
                prevY = ty;
            }
            a = "M" + a.join(",");
        }
        e && e.setAttribute("d", a);
        return a;
    }
}
$5c4bdc270e31825b$var$_getGSAP() && $5c4bdc270e31825b$var$gsap.registerPlugin($5c4bdc270e31825b$export$94f46869cc67acd8);
$5c4bdc270e31825b$export$94f46869cc67acd8.version = "3.12.2";


var $6f7dfd50968e230e$exports = {};

$parcel$export($6f7dfd50968e230e$exports, "path", function () { return $6f7dfd50968e230e$export$bb654e07daaf8c3a; });
$parcel$export($6f7dfd50968e230e$exports, "create", function () { return $6f7dfd50968e230e$export$185802fd694ee1f5; });
var $f01c9e244e25b0c1$exports = {};
$f01c9e244e25b0c1$exports = JSON.parse('{"seo":{"home":{"title":"Project Name","meta_name":{"keywords":"Boiler, Web, Project","description":"Project name description here."},"meta_property":{"og:type":"website","og:url":"https://boiler-stage.blakerutledge.com","og:image":"https://boiler-stage.blakerutledge.com/assets/images/og.jpg","og:image:width":"1200","og:image:height":"630","og:title":"Project Name","og:description":"Project name description here.","og:site_name":"ProjectName"}}},"home":"Project Name","about":"about hello world","gallery":{"a":[{"uri":"/assets/images/pic-1.jpg","width":1200,"height":900},{"uri":"/assets/images/pic-2.jpg","width":1200,"height":900},{"uri":"https://player.vimeo.com/video/393795643","width":1920,"height":1080},{"uri":"/assets/images/video-1.mp4","width":1920,"height":1080},{"uri":"/assets/images/pic-3.jpg","width":1200,"height":900},{"uri":"https://player.vimeo.com/video/393795643","width":1920,"height":1080},{"uri":"/assets/images/pic-4.jpg","width":1200,"height":900},{"uri":"/assets/images/pic-5.jpg","width":1200,"height":900},{"uri":"/assets/images/video-2.mp4","width":1920,"height":1080},{"uri":"/assets/images/pic-6.jpg","width":1200,"height":900},{"uri":"/assets/images/pic-7.jpg","width":1200,"height":900},{"uri":"/assets/images/pic-8.jpg","width":1200,"height":900}],"b":[{"uri":"https://player.vimeo.com/video/393795643","width":1920,"height":1080}],"c":[{"uri":"/assets/images/pic-8.jpg","width":1200,"height":900}]}}');


let $c9426da44d14829c$export$84bf76cd7afc7469 = {
    loaded: false
};
let $c9426da44d14829c$export$3f8fe6489e95757d = ()=>{
    $c9426da44d14829c$export$84bf76cd7afc7469 = (0, (/*@__PURE__*/$parcel$interopDefault($f01c9e244e25b0c1$exports)));
    $c9426da44d14829c$var$finish_store();
};
let $c9426da44d14829c$export$6f57813fe9f31bf9 = (data, callback)=>{
    $c9426da44d14829c$export$84bf76cd7afc7469 = data;
    $c9426da44d14829c$var$finish_store();
    if (callback) callback();
};
let $c9426da44d14829c$var$finish_store = ()=>{
    $c9426da44d14829c$export$84bf76cd7afc7469.loaded = true;
    console.log("%c content ", "background: #C476E7; color: #fff", $c9426da44d14829c$export$84bf76cd7afc7469);
};



class $11cc1daff6b2cc9a$export$2e2bcd8739ae039 {
    constructor(data){
        // BUILT IN
        this.loaded = false;
        this.el = null;
        this.nodes = {};
        this.nodes_list = [];
        // REQUIRED
        this.path = data.path;
        this.is_instance = data.is_instance;
        this.template = data.template;
        // OVERRIDES
        if (data.on_build) this.on_build = data.on_build;
        if (data.fetch) this.fetch = data.fetch;
        if (data.tween_in) this.tween_in = data.tween_in;
        if (data.tween_out) this.tween_out = data.tween_out;
        if (data.resize) this.resize = data.resize;
        if (data.nodes_list) this.nodes_list = data.nodes_list;
    }
    // DEFAULT fetch
    async fetch() {
        return new Promise((resolve)=>{
            this.data = $c9426da44d14829c$export$84bf76cd7afc7469;
            this.fetched = true;
            resolve();
        });
    }
    on_build() {
    // nothing
    }
    build(virtual_document) {
        // Static site generator will pass in the virtual dom
        let _document = virtual_document ? virtual_document : document;
        let el = _document.createElement("div");
        el.classList.add("container-inner");
        el.classList.add("hidden");
        let page_div = _document.createElement("div");
        page_div.classList.add("page");
        page_div.classList.add(this.path.replaceAll("/", ""));
        page_div.innerHTML = this.template(this.data);
        el.appendChild(page_div);
        this.nodes.container = el;
        this.nodes.page_div = page_div;
        return el;
    }
    get_nodes() {
        for(let n in this.nodes_list.qs)this.nodes[n] = this.qs(this.nodes_list.qs[n]);
        for(let n in this.nodes_list.qsa)this.nodes[n] = this.qsa(this.nodes_list.qsa[n]);
        console.log(`%c nodes | ${this.path} `, "background: #F9704B; color: #fff", this.nodes);
    }
    qs(selector) {
        return this.nodes.page_div.querySelector(selector);
    }
    qsa(selector) {
        return Array.prototype.slice.call(this.nodes.page_div.querySelectorAll(selector));
    }
    async tween_in(other, reverse) {
        return new Promise((resolve)=>{
            let dir = reverse ? -1 : 1;
            let tl = (0, $903863a8986407e7$export$99ee26438460406a).timeline({
                paused: true,
                onStart: ()=>{
                    this.nodes.container.classList.remove("hidden");
                },
                onComplete: ()=>{
                    resolve();
                    tl.kill();
                    tl = null;
                }
            });
            tl.add((0, $903863a8986407e7$export$99ee26438460406a).fromTo(this.nodes.page_div, {
                opacity: 0,
                y: 10
            }, {
                opacity: 1,
                y: 0,
                ease: (0, $ae2aa5d5610059af$export$d8c694b7490ad65d).easeOut,
                duration: 0.25
            }));
            tl.play();
        });
    }
    async tween_out(other, reverse) {
        return new Promise((resolve)=>{
            let dir = reverse ? -1 : 1;
            let tl = (0, $903863a8986407e7$export$99ee26438460406a).timeline({
                paused: true,
                onStart: ()=>{},
                onComplete: ()=>{
                    this.nodes.container.classList.add("hidden");
                    resolve();
                    tl.kill();
                    tl = null;
                }
            });
            tl.add((0, $903863a8986407e7$export$99ee26438460406a).to(this.nodes.page_div, {
                opacity: 0,
                y: -10,
                ease: (0, $ae2aa5d5610059af$export$d8c694b7490ad65d).easeIn,
                duration: 0.25
            }));
            tl.play();
        });
    }
    destroy() {
        this.nodes.container.remove();
    }
    resize() {}
}


function $71dabf97dc7d1824$export$2e2bcd8739ae039(it) {
    let out = '<div class="wrap"> <div class="header"> Home header here </div> <div class="body"> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. </div> <div class="buttons-row"> <a class="button" href="/gallery/a" data-link="internal"> Go to Gallery A </a> <a class="button" href="/gallery/b" data-link="internal"> Go to Gallery B </a> <a class="button" href="/gallery/c" data-link="internal"> Go to Gallery C </a> <a class="button" href="/about" data-link="internal"> Go to About </a> </div></div>';
    return out;
}


let $6f7dfd50968e230e$export$bb654e07daaf8c3a = "home";
let $6f7dfd50968e230e$export$185802fd694ee1f5 = ()=>{
    let p = new (0, $11cc1daff6b2cc9a$export$2e2bcd8739ae039)({
        path: "home",
        is_instances: false,
        template: (0, $71dabf97dc7d1824$export$2e2bcd8739ae039),
        nodes_list: {
            qs: {
                "header": ".header",
                "body": ".body"
            },
            qsa: {
                "buttons": ".button"
            }
        }
    });
    return p;
};


var $ef2f5fe70fc96b33$exports = {};

$parcel$export($ef2f5fe70fc96b33$exports, "path", function () { return $ef2f5fe70fc96b33$export$bb654e07daaf8c3a; });
$parcel$export($ef2f5fe70fc96b33$exports, "create", function () { return $ef2f5fe70fc96b33$export$185802fd694ee1f5; });

function $3c60b78997599c64$export$2e2bcd8739ae039(it) {
    let out = '<div class="wrap"> <div class="header"> About header here </div> <div class="body"> Ut atque praesentium aut assumenda cupiditate eos veniam internos. Eum eaque nihil ut dolor laudantium est voluptatem dolorem in molestiae ducimus vel iure sint. Quo eligendi voluptatem et magnam nihil non fugiat repudiandae et vitae dolores et quia recusandae qui quia consequatur. Qui ipsam nisi et autem consequatur cum autem sint est iure repudiandae et enim consequatur est nobis totam. </div> <div class="buttons-row"> <a class="button" href="/home" data-link="internal"> Go Home </a> </div></div>';
    return out;
}


let $ef2f5fe70fc96b33$export$bb654e07daaf8c3a = "about";
let $ef2f5fe70fc96b33$export$185802fd694ee1f5 = ()=>{
    let p = new (0, $11cc1daff6b2cc9a$export$2e2bcd8739ae039)({
        path: "about",
        is_instances: false,
        template: (0, $3c60b78997599c64$export$2e2bcd8739ae039)
    });
    return p;
};


var $64b5109d711c72e4$exports = {};

$parcel$export($64b5109d711c72e4$exports, "path", function () { return $64b5109d711c72e4$export$bb654e07daaf8c3a; });
$parcel$export($64b5109d711c72e4$exports, "create", function () { return $64b5109d711c72e4$export$185802fd694ee1f5; });

function $7aaa151d7cbdae70$export$2e2bcd8739ae039(it) {
    let out = '<div class="wrap"> <div class="header"> Gallery header here </div> <div class="body"> ';
    const _val1 = it;
    if (_val1) for (const media of _val1){
        out += ' <div class="media-container"> <!-- Vimeo Embed --> ';
        if (media.uri.includes("vimeo.com")) out += '<div class="video-container" style="width: 100%; padding-bottom: ' + 100 * media.height / media.width + '%; height: 0;"> <iframe blazy-src="' + (media.uri + "?autoplay=true&title=0&byline=0&portrait=0") + '" frameborder="0" allow="autoplay; fullscreen;" title="vimeo embed"></iframe></div> <!-- Youtube embed --> ';
        else if (media.uri.includes("youtube.com")) out += ' <iframe blazy-src="' + media.uri + '" title="youtube embed"></iframe> <!-- Plain video element --> ';
        else if (media.uri.includes(".mp4")) out += ' <video muted loop playsinline height="' + media.height + '" width="' + media.width + '" alt="hbo taser" style="aspect-ratio: ' + media.width / media.height + ';" blazy-src="' + media.uri + '"> <source type="video/mp4" /> </video> <!-- Image --> ';
        else if (Math.random() > 0.5) out += ' <img blazy-src="' + media.uri + '" width="' + media.width + '" height="' + media.height + '" alt="frog-1" style="aspect-ratio: ' + media.width / media.height + ';"> <!-- CSS Background image --> ';
        else out += ' <div blazy-src="' + media.uri + '" width="' + media.width + '" height="' + media.height + '" style="aspect-ratio: ' + media.width / media.height + ';"></div> ';
        out += " </div> ";
    }
    out += ' </div> <div class="svg"> <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke="white"> <path d="M25 47C37.1503 47 47 37.1503 47 25C47 12.8497 37.1503 3 25 3C12.8497 3 3 12.8497 3 25C3 37.1503 12.8497 47 25 47Z" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3 25H47" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/> <path d="M25 3C30.6279 9.02438 33.8262 16.8425 34 25C33.8262 33.1575 30.6279 40.9756 25 47C19.3721 40.9756 16.1738 33.1575 16 25C16.1738 16.8425 19.3721 9.02438 25 3V3Z" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></g></svg> </div> <div class="buttons-row"> <a class="button" href="/home" data-link="internal"> Go Home </a> <a class="button" href="/gallery/a" data-link="internal"> Go to Gallery A </a> <a class="button" href="/gallery/b" data-link="internal"> Go to Gallery B </a> <a class="button" href="/gallery/c" data-link="internal"> Go to Gallery C </a> </div></div>';
    return out;
}



let $64b5109d711c72e4$export$bb654e07daaf8c3a = "gallery";
let $64b5109d711c72e4$export$185802fd694ee1f5 = ()=>{
    let p = new (0, $11cc1daff6b2cc9a$export$2e2bcd8739ae039)({
        path: $64b5109d711c72e4$export$bb654e07daaf8c3a,
        is_instances: true,
        template: (0, $7aaa151d7cbdae70$export$2e2bcd8739ae039)
    });
    p.fetch = async function(query) {
        return new Promise((resolve)=>{
            if ($c9426da44d14829c$export$84bf76cd7afc7469.gallery[query]) this.data = $c9426da44d14829c$export$84bf76cd7afc7469.gallery[query];
            else this.data = {
                body: "Not found"
            };
            this.fetched = true;
            resolve();
        });
    };
    return p;
};


var $3424bd51297586ff$exports = {};

$parcel$export($3424bd51297586ff$exports, "path", function () { return $3424bd51297586ff$export$bb654e07daaf8c3a; });
$parcel$export($3424bd51297586ff$exports, "create", function () { return $3424bd51297586ff$export$185802fd694ee1f5; });

function $814dc3dec8f9c107$export$2e2bcd8739ae039(it) {
    let out = '<div class="wrap"> <div class="header"> ' + it.header + ' </div> <div class="body"> ' + it.body + ' </div> <div class="buttons-row"> <a class="button" href="/home" data-link="internal"> Go Home </a> </div></div>';
    return out;
}


let $3424bd51297586ff$export$bb654e07daaf8c3a = "error";
const $3424bd51297586ff$var$errors = {
    "default": {
        "header": "Unknown error",
        "body": "Hrmm. How did we get here?"
    },
    "404": {
        "header": "404 - Page not found",
        "body": "Sorry about that. Try a different URL."
    },
    "500": {
        "header": "500 - Server error",
        "body": "Sorry about that. Try again later?"
    }
};
let $3424bd51297586ff$export$185802fd694ee1f5 = ()=>{
    let p = new (0, $11cc1daff6b2cc9a$export$2e2bcd8739ae039)({
        path: "error",
        is_instances: false,
        template: (0, $814dc3dec8f9c107$export$2e2bcd8739ae039)
    });
    p.fetch = async function(query) {
        return new Promise((resolve)=>{
            if ($3424bd51297586ff$var$errors[query]) this.data = $3424bd51297586ff$var$errors[query];
            else this.data = $3424bd51297586ff$var$errors.default;
            resolve();
        });
    };
    return p;
};


let $250da9ff26fc5f99$export$84bf76cd7afc7469 = {};
let $250da9ff26fc5f99$export$3f8fe6489e95757d = ()=>{
    $250da9ff26fc5f99$export$6503ec6e8aabbaf($6f7dfd50968e230e$exports);
    $250da9ff26fc5f99$export$6503ec6e8aabbaf($ef2f5fe70fc96b33$exports);
    $250da9ff26fc5f99$export$6503ec6e8aabbaf($64b5109d711c72e4$exports);
    $250da9ff26fc5f99$export$6503ec6e8aabbaf($3424bd51297586ff$exports);
    //
    // ADD new pages here
    // 
    console.log("%c pages ", "background: #FFD086; color: #222", $250da9ff26fc5f99$export$84bf76cd7afc7469);
};
let $250da9ff26fc5f99$export$6503ec6e8aabbaf = (p)=>{
    let slug = p.path.replaceAll("/", ".");
    $250da9ff26fc5f99$export$84bf76cd7afc7469[slug] = p.create;
};
let $250da9ff26fc5f99$export$3988ae62b71be9a3 = (path)=>{
    if ($250da9ff26fc5f99$export$84bf76cd7afc7469[path] !== undefined) return $250da9ff26fc5f99$export$84bf76cd7afc7469[path];
    else return false;
};


class $88ac5272e498f294$export$2e2bcd8739ae039 {
    constructor(options){
        // Events
        this.events = {};
        // Set status flag that we are ready to use the instance
        this.ready = false;
        // Dump all deferred src's for seo bots
        this.bots = options.bots === true || false;
        // Identifier used to select which html nodes are to be lazy loaded
        this.tag = options.src || "blazy-src";
        // Unload mode
        this.unload = options.unload === true || false;
        // Scale the viewport by this factor, to create the view area
        let vs = options.view_scale;
        this.view_scale = vs && typeof vs === "number" && vs >= 0 ? vs : 2.0;
        // Element that contains all of the media to be lazy loaded, and is also scrollable
        this.container = options.container || document.body;
        // Document override, for node.js use
        this.document = options.document || document;
        // Initialize view measurements
        this.view_center = 0;
        this.view_height = 0;
        this.view_scroll = 0;
        // Initialize status flag
        this.checking = 0;
        // Empty nodes array
        this.nodes = [];
        if (!this.bots) {
            this.observer = new IntersectionObserver((data)=>{
                this.handler(data);
            }, {
                root: this.container,
                rootMargin: `${50 * (this.view_scale - 1.0)}% 0% ${50 * (this.view_scale - 1.0)}% 0%`,
                threshold: 0,
                trackVisibility: false
            });
            // Update the nodes being observed
            this.sync_nodes();
        }
        // We are ready for external use
        this.ready = true;
        if (this.bots) this.dump();
    }
    on(name, handler) {
        this.events[name] = handler;
    }
    once(name, handler) {
        handler._once = true;
        this.on(name, handler);
    }
    remove(name) {
        if (this.events[name] !== undefined) {
            this.events[name] = null;
            delete this.events[name];
        }
    }
    emit(name) {
        if (this.events[name] !== undefined) {
            let arg = arguments.length >= 2 ? arguments[1] : undefined;
            this.events[name](arg);
            if (this.events[name]._once) this.off(name);
        }
    }
    handler(observations) {
        observations.forEach((o)=>{
            let node = o.target;
            let visible = o.isIntersecting;
            let unset = node.dataset.blazy_loading !== "true" && node.dataset.blazy_loaded !== "true";
            if (visible && unset) this.set_source(node);
            if (!visible && !unset) this.unset_source(node);
        });
    }
    // - - - Node handlers
    set_source(node) {
        let type = node.tagName.toLowerCase();
        let url = node.getAttribute(this.tag);
        // Set the source
        if (type === "img" || type === "iframe") node.setAttribute("src", url);
        else if (type === "video") {
            let source = this.document.createElement("source");
            source.setAttribute("src", url);
            source.setAttribute("type", "video/mp4");
            node.innerHTML = "";
            node.appendChild(source);
        } else if (type === "div") {
            let temp = this.document.createElement("img");
            temp.src = url;
            // INLINE the style right away if we are dumping, otherwise, wait till the asset fully loads
            if (this.bots) node.style.backgroundImage = `url('${url}')`;
            else temp.addEventListener("load", (x)=>{
                node.style.backgroundImage = `url('${url}')`;
            }, {
                once: true
            });
        }
        // Update the state flags
        node.dataset.blazy_loading = true;
        node.dataset.blazy_aborted = false;
        node.dataset.blazy_loaded = false;
        // Emit the event
        this.emit("blazy:set", node);
        // Add the load listener
        if (type === "video") node.addEventListener("canplaythrough", ()=>{
            node.play();
            this.loaded(node);
        }, {
            once: true
        });
        else node.addEventListener("load", ()=>{
            this.loaded(node);
        }, {
            once: true
        });
    }
    unset_source(node) {
        let type = node.tagName.toLowerCase();
        // Unset the source
        if (type === "img" || type === "iframe") node.removeAttribute("src");
        else if (type === "video") {
            node.innerHTML = "";
            node.load();
        } else if (type === "div") node.style.backgroundImage = "unset";
        // Update the state flags
        if (node.dataset.blazy_loading === "true") node.dataset.blazy_aborted = true;
        else node.dataset.blazy_aborted = false;
        node.dataset.blazy_loading = false;
        node.dataset.blazy_loaded = false;
        // Remove the event listener
        node.removeEventListener("load", ()=>{
            this.loaded(node);
        }, {
            once: true
        });
        // Emit the event
        this.emit("blazy:unset", node);
    }
    loaded(node) {
        // Aborted load
        if (node.dataset.blazy_aborted === "true") {
            node.dataset.blazy_aborted = false;
            node.dataset.blazy_loading = false;
            node.dataset.blazy_loaded = false;
        } else {
            // Update the state flags
            node.dataset.blazy_loading = false;
            node.dataset.blazy_loaded = true;
            // Emit the event
            this.emit("blazy:loaded", node);
        }
    }
    sync_nodes() {
        // Stop watching all nodes
        this.observer.disconnect();
        // Find all nodes that match our tag
        this.nodes = this.qsa(`[${this.tag}]`, this.container);
        // Report them to the observer
        this.nodes.forEach((node)=>{
            this.observer.observe(node);
        });
    }
    dump() {
        // Find all nodes that match our tag
        this.nodes = this.qsa(`[${this.tag}]`, this.container);
        this.nodes.forEach((node)=>{
            let unset = node.dataset.blazy_loading !== "true" && node.dataset.blazy_loaded !== "true";
            if (unset) this.set_source(node);
        });
    }
    // Query Selector helper function
    qsa = (selector, node)=>{
        if (node) return Array.prototype.slice.call(node.querySelectorAll(selector));
        else return Array.prototype.slice.call(this.document.querySelectorAll(selector));
    };
}


let $9ad5e68ea0966dde$export$45823bd890ba4107;
let $9ad5e68ea0966dde$export$722fbec263ad908a = ()=>{
    if (!$9ad5e68ea0966dde$export$45823bd890ba4107.ready) return;
    $9ad5e68ea0966dde$export$45823bd890ba4107.sync_nodes();
};
let $9ad5e68ea0966dde$export$3f8fe6489e95757d = ()=>{
    $9ad5e68ea0966dde$export$45823bd890ba4107 = new (0, $88ac5272e498f294$export$2e2bcd8739ae039)({
        tag: "blazy-src",
        view_scale: 2.0,
        unload: true,
        container: document.querySelector(".container")
    });
/*
    blazy.on( 'blazy:set', ( node ) => {
        console.log( 'loading', node.getAttribute( 'blazy-src' ) )
    } )
    
    blazy.on( 'blazy:loaded', ( node ) => {
        console.log( 'loaded', node.getAttribute( 'blazy-src' ) )
    } )
    
    blazy.on( 'blazy:unset', ( node ) => {
        console.log( 'unload', node.getAttribute( 'blazy-src' ) )
    })
    */ };



let $12a9de212743a640$export$471f7ae5c4103ae1 = {
    current: null,
    previous: null,
    uid: 0,
    reverse: false,
    pages: {
        current: null
    },
    transitioning: false
};
let $12a9de212743a640$export$3f8fe6489e95757d = function() {
    // Add Back/Forward button listener
    window.addEventListener("popstate", function(e) {
        if ($12a9de212743a640$export$471f7ae5c4103ae1.transitioning) {
            e.preventDefault();
            return;
        }
        // Parse URL request, set base to home
        let _url = window.location.pathname;
        _url = _url === null || _url === "/" ? "home" : _url.replaceAll(/^.*\/\/[^\/]+/g, "");
        if (_url.startsWith("/")) _url = _url.slice(1);
        if (_url.endsWith("/")) _url = _url.slice(0, -1);
        // Test if reversing
        if (window.history.state !== null) {
            $12a9de212743a640$export$471f7ae5c4103ae1.reverse = window.history.state.uid < $12a9de212743a640$export$471f7ae5c4103ae1.uid ? true : false;
            $12a9de212743a640$export$471f7ae5c4103ae1.uid = window.history.state.uid;
        }
        $12a9de212743a640$export$471f7ae5c4103ae1.previous = $12a9de212743a640$export$471f7ae5c4103ae1.current;
        $12a9de212743a640$export$471f7ae5c4103ae1.current = _url;
        // Pass along to router
        $12a9de212743a640$export$7d69bfbfbd86cfd6(_url);
    });
};
let $12a9de212743a640$export$5200e0c7549d7bff = ()=>{
    // Get window location and strip file extension and leading slash
    let path = window.location.pathname;
    path = path.replace(path.match(/\.[0-9a-z]+$/i), "");
    //Trim leading and trailing slashes
    if (path[0] === "/") path = path.slice(1, path.length);
    if (path[path.length - 1] === "/") path = path.slice(0, path.length - 1);
    // Root url is home
    path = path === "" ? "home" : path;
    // Filter instance queries
    let template_str = path.replaceAll("/", ".");
    if ($250da9ff26fc5f99$export$3988ae62b71be9a3(template_str)) {
        let state = {
            path: path,
            uid: window.history.length
        };
        window.history.replaceState(state, null, window.location.origin + "/" + path + "/");
    } else {
        // Prep url components for testing
        let url_parts = path.split("/");
        // Format path with periods instead of slashes
        let normal_path = path.replaceAll("/", ".");
        // String after final / is instance id, the rest is the path
        let query = url_parts[url_parts.length - 1];
        let instanced_path = normal_path.replace(`.${query}`, "");
        if ($250da9ff26fc5f99$export$3988ae62b71be9a3(instanced_path)) {
            path = instanced_path + "/" + query + "/";
            let state = {
                path: path,
                uid: window.history.length
            };
            window.history.replaceState(state, null, window.location.origin + "/" + path);
        } else {
            path = "error/404/";
            let state = {
                path: path,
                uid: window.history.length
            };
            window.history.replaceState(state, null, window.location.origin + "/" + path);
        }
    }
    // We have found ourselves
    $12a9de212743a640$export$471f7ae5c4103ae1.current = path;
    // Nav away!
    $12a9de212743a640$export$7d69bfbfbd86cfd6(path);
};
let $12a9de212743a640$export$6401c68a3808c737 = (full_link, event)=>{
    if (event) event.preventDefault();
    if ($12a9de212743a640$export$471f7ae5c4103ae1.transitioning) return;
    // MANUALLY trigger a link click by passing in the path, instead of an el
    let url = new URL(full_link);
    let link = url.pathname;
    if (link.startsWith("/")) link = link.slice(1, link.length);
    if ($12a9de212743a640$export$471f7ae5c4103ae1.current === link) ;
    else {
        // Update status tracker
        $12a9de212743a640$export$471f7ae5c4103ae1.previous = $12a9de212743a640$export$471f7ae5c4103ae1.current;
        $12a9de212743a640$export$471f7ae5c4103ae1.current = link;
        // Update browser history
        let state = {
            path: link,
            uid: window.history.length + 1
        };
        let pretty = link === "home" ? "" : link + "/";
        window.history.pushState(state, null, window.location.origin + "/" + pretty);
        $12a9de212743a640$export$471f7ae5c4103ae1.uid = window.window.history.state.uid;
        $12a9de212743a640$export$471f7ae5c4103ae1.reverse = false;
        // Off to the router
        $12a9de212743a640$export$7d69bfbfbd86cfd6(link);
    }
};
let $12a9de212743a640$export$3b31b63215708bf9 = (el)=>{
    let link = el.dataset.external;
    window.open(link, "_blank");
};
let $12a9de212743a640$export$7d69bfbfbd86cfd6 = (_url)=>{
    $12a9de212743a640$export$471f7ae5c4103ae1.transitioning = true;
    let url = _url.endsWith("/") ? _url.slice(0, _url.length - 1) : _url;
    // Prep url components for testing
    let url_parts = url.split("/");
    // Format path with periods instead of slashes
    let normal_path = url.replaceAll("/", ".");
    // String after final / is instance id, the rest is the path
    let query = url_parts[url_parts.length - 1];
    let instanced_path = normal_path.replace(`.${query}`, "");
    // Normal path exists as page
    if ($250da9ff26fc5f99$export$3988ae62b71be9a3(normal_path)) {
        let page = $250da9ff26fc5f99$export$84bf76cd7afc7469[normal_path]();
        $12a9de212743a640$var$transition(page);
    } else if ($250da9ff26fc5f99$export$3988ae62b71be9a3(instanced_path)) {
        let page = $250da9ff26fc5f99$export$84bf76cd7afc7469[instanced_path]();
        $12a9de212743a640$var$transition(page, query);
    } else {
        let page = $250da9ff26fc5f99$export$84bf76cd7afc7469["error"]();
        $12a9de212743a640$var$transition(page, "404");
    }
};
// SEQUENCE page transitions
let $12a9de212743a640$var$transition = async (page, query)=>{
    // FETCH the pages data
    await page.fetch(query);
    // POPULATE the template
    let new_el = page.build();
    // REMOVE any static content
    let static_container = document.querySelector(".container-inner.static");
    if (static_container) static_container.remove();
    // INSERT into the parent container
    let parent = document.querySelector(".container");
    parent.appendChild(new_el);
    // START the tween out
    if ($12a9de212743a640$export$471f7ae5c4103ae1.pages.current) await $12a9de212743a640$export$471f7ae5c4103ae1.pages.current.tween_out(page.path, $12a9de212743a640$export$471f7ae5c4103ae1.reverse);
    // RESET the container scroll
    $6cc2588e8bf269f3$export$464af16f3cd3a566();
    // START the tween in
    let prev = $12a9de212743a640$export$471f7ae5c4103ae1.pages.current ? $12a9de212743a640$export$471f7ae5c4103ae1.pages.current.path : false;
    await page.tween_in(prev, $12a9de212743a640$export$471f7ae5c4103ae1.reverse);
    // DESTROY the previous page
    if ($12a9de212743a640$export$471f7ae5c4103ae1.pages.current) $12a9de212743a640$export$471f7ae5c4103ae1.pages.current.destroy();
    // SWAP the pages in status object
    $12a9de212743a640$export$471f7ae5c4103ae1.pages.current = page;
    $9ad5e68ea0966dde$export$722fbec263ad908a();
    $12a9de212743a640$export$d04d7fbbcd7ce3ca();
    $12a9de212743a640$export$471f7ae5c4103ae1.transitioning = false;
};
let $12a9de212743a640$export$d04d7fbbcd7ce3ca = (el)=>{
    el = el ? el : document.querySelector("body");
    let new_links = Array.prototype.slice.call(el.querySelectorAll("[data-link]"));
    new_links.forEach((x)=>{
        x.addEventListener("click", (e)=>{
            $12a9de212743a640$export$6401c68a3808c737(x.href, e);
        });
    });
    let new_externals = Array.prototype.slice.call(el.querySelectorAll("[data-external]"));
    new_externals.forEach((x)=>{
        x.addEventListener("click", (e)=>{
            $12a9de212743a640$export$3b31b63215708bf9(x.href, e);
        });
    });
};





function $a20c6758d5b5a9f3$export$2e2bcd8739ae039(it) {
    let out = '<div class="component"> dev tools here</div>';
    return out;
}


let $7983d7f66fa03a75$export$3f8fe6489e95757d = ()=>{};


(0, $903863a8986407e7$export$99ee26438460406a).registerPlugin((0, $ae2aa5d5610059af$export$d8c694b7490ad65d), (0, $5c4bdc270e31825b$export$94f46869cc67acd8));
let $6cc2588e8bf269f3$export$3f8fe6489e95757d = async ()=>{
    if (!$c9426da44d14829c$export$84bf76cd7afc7469.loaded) {
        // ADD resize handlers, and call right away
        window.addEventListener("resize", $6cc2588e8bf269f3$var$resize_handler);
        $6cc2588e8bf269f3$var$resize_handler();
        // TEST for mobile via user agent string
        $6cc2588e8bf269f3$export$ca000e230c0caa3e.is_mobile = (0, $cd7640162cf6c6ef$export$2e2bcd8739ae039)();
        if ($6cc2588e8bf269f3$export$ca000e230c0caa3e.is_mobile) $c174e9ba92688b1a$export$836aee6bce45247("body").body.classList.add("mobile");
        console.log("%c state ", "background: #FF1665; color: #fff", $6cc2588e8bf269f3$export$ca000e230c0caa3e);
        $c9426da44d14829c$export$3f8fe6489e95757d();
        // Build app
        $250da9ff26fc5f99$export$3f8fe6489e95757d();
        $7983d7f66fa03a75$export$3f8fe6489e95757d();
        $12a9de212743a640$export$3f8fe6489e95757d();
        $9ad5e68ea0966dde$export$3f8fe6489e95757d();
        // Load the app at our entry point
        $12a9de212743a640$export$5200e0c7549d7bff();
    }
};
let $6cc2588e8bf269f3$var$resize_handler = ()=>{
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    $6cc2588e8bf269f3$export$7902edfa21008576();
// ADD any more page resize handlers here
};
let $6cc2588e8bf269f3$export$7902edfa21008576 = ()=>{
    let w = window.innerWidth;
    let h = window.innerHeight;
    $6cc2588e8bf269f3$export$ca000e230c0caa3e.window_size = {
        w: w,
        h: h,
        aspect: w / h,
        d: Math.sqrt(Math.pow(w, 2) + Math.pow(h, 2)),
        px: window.devicePixelRatio,
        u_px_norm: {
            x: w,
            y: h
        },
        aspect_vec: {
            x: 1.0,
            y: w / h
        },
        x: 0,
        y: 0,
        u: 1.0 / w,
        v: 1.0 / h
    };
};
let $6cc2588e8bf269f3$export$464af16f3cd3a566 = ()=>{
    $c174e9ba92688b1a$export$836aee6bce45247(".container").scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.scrollTo(0, 0);
};
let $6cc2588e8bf269f3$export$ca000e230c0caa3e = {
    is_mobile: false,
    window_size: {},
    session_id: $c174e9ba92688b1a$export$31b40729666a4ae0()
};


var $84f88ce634a34e10$exports = {};

$84f88ce634a34e10$exports = new URL((parcelRequire("kyEFX")).resolve("fO7bx"), import.meta.url).toString();


const $d706c914d748cb55$var$main = async ()=>{
    if (document.querySelector("body").classList.contains("static")) document.querySelector("body").classList.remove("static");
    if (navigator.serviceWorker) navigator.serviceWorker.register($84f88ce634a34e10$exports).catch((e)=>{
        console.error("ServiceWorker registration failed: ", e);
    });
    console.log("%c env ", "background: #4A48D4; color: #fff", {
        env: "stage",
        url: "https://boiler-stage.blakerutledge.com"
    });
    $6cc2588e8bf269f3$export$3f8fe6489e95757d();
};
document.addEventListener("DOMContentLoaded", $d706c914d748cb55$var$main);




//# sourceMappingURL=index.0f774a73.js.map
